import { cancelable as Oi } from "@wharfkit/common";
const Rr = !1;
var Dr = Array.isArray, Bi = Array.prototype.indexOf, bn = Array.prototype.includes, zn = Array.from, Ri = Object.defineProperty, Ht = Object.getOwnPropertyDescriptor, Di = Object.getOwnPropertyDescriptors, Hi = Object.prototype, Ii = Array.prototype, Hr = Object.getPrototypeOf, pr = Object.isExtensible;
const Wn = () => {
};
function qi(t) {
  for (var e = 0; e < t.length; e++)
    t[e]();
}
function Ir() {
  var t, e, n = new Promise((r, i) => {
    t = r, e = i;
  });
  return { promise: n, resolve: t, reject: e };
}
const fe = 2, jt = 4, Mn = 8, qr = 1 << 24, Ge = 16, Ie = 32, lt = 64, Xn = 128, De = 512, ie = 1024, te = 2048, We = 4096, ge = 8192, Me = 16384, Wt = 32768, Qn = 1 << 25, Mt = 65536, yn = 1 << 17, Fi = 1 << 18, Xt = 1 << 19, ji = 1 << 20, $e = 1 << 25, Lt = 65536, xn = 1 << 21, It = 1 << 22, mt = 1 << 23, St = /* @__PURE__ */ Symbol("$state"), Ki = /* @__PURE__ */ Symbol("legacy props"), Ui = /* @__PURE__ */ Symbol(""), Fr = /* @__PURE__ */ Symbol("attributes"), Jn = /* @__PURE__ */ Symbol("class"), Zn = /* @__PURE__ */ Symbol("style"), $n = /* @__PURE__ */ Symbol("text"), mn = /* @__PURE__ */ Symbol("form reset"), fn = new class extends Error {
  name = "StaleReactionError";
  message = "The reaction that called `getAbortSignal()` was re-run or destroyed";
}(), Gi = (
  // We gotta write it like this because after downleveling the pure comment may end up in the wrong location
  !!globalThis.document?.contentType && /* @__PURE__ */ globalThis.document.contentType.includes("xml")
);
function Yi() {
  throw new Error("https://svelte.dev/e/async_derived_orphan");
}
function Vi(t, e, n) {
  throw new Error("https://svelte.dev/e/each_key_duplicate");
}
function Wi(t) {
  throw new Error("https://svelte.dev/e/effect_in_teardown");
}
function Xi() {
  throw new Error("https://svelte.dev/e/effect_in_unowned_derived");
}
function Qi(t) {
  throw new Error("https://svelte.dev/e/effect_orphan");
}
function Ji() {
  throw new Error("https://svelte.dev/e/effect_update_depth_exceeded");
}
function Zi(t) {
  throw new Error("https://svelte.dev/e/props_invalid_value");
}
function $i() {
  throw new Error("https://svelte.dev/e/state_descriptors_fixed");
}
function ea() {
  throw new Error("https://svelte.dev/e/state_prototype_fixed");
}
function ta() {
  throw new Error("https://svelte.dev/e/state_unsafe_mutation");
}
function na() {
  throw new Error("https://svelte.dev/e/svelte_boundary_reset_onerror");
}
const ra = 1, ia = 2, jr = 4, aa = 8, sa = 16, la = 1, oa = 4, ca = 8, ua = 16, fa = 1, da = 2, re = /* @__PURE__ */ Symbol("uninitialized"), Kr = "http://www.w3.org/1999/xhtml", va = "http://www.w3.org/2000/svg", ha = "http://www.w3.org/1998/Math/MathML";
function ga() {
  console.warn("https://svelte.dev/e/derived_inert");
}
function _a() {
  console.warn("https://svelte.dev/e/svelte_boundary_reset_noop");
}
function Ur(t) {
  return t === this.v;
}
function pa(t, e) {
  return t != t ? e == e : t !== e || t !== null && typeof t == "object" || typeof t == "function";
}
function Gr(t) {
  return !pa(t, this.v);
}
let ma = !1, _e = null;
function Kt(t) {
  _e = t;
}
function W(t, e = !1, n) {
  _e = {
    p: _e,
    i: !1,
    c: null,
    e: null,
    s: t,
    x: null,
    r: (
      /** @type {Effect} */
      F
    ),
    l: null
  };
}
function X(t) {
  var e = (
    /** @type {ComponentContext} */
    _e
  ), n = e.e;
  if (n !== null) {
    e.e = null;
    for (var r of n)
      di(r);
  }
  return e.i = !0, _e = e.p, /** @type {T} */
  {};
}
function Yr() {
  return !0;
}
let Ct = [];
function Vr() {
  var t = Ct;
  Ct = [], qi(t);
}
function et(t) {
  if (Ct.length === 0 && !sn) {
    var e = Ct;
    queueMicrotask(() => {
      e === Ct && Vr();
    });
  }
  Ct.push(t);
}
function wa() {
  for (; Ct.length > 0; )
    Vr();
}
function Wr(t) {
  var e = F;
  if (e === null)
    return j.f |= mt, t;
  if ((e.f & Wt) === 0 && (e.f & jt) === 0)
    throw t;
  _t(t, e);
}
function _t(t, e) {
  if (!(e !== null && (e.f & Me) !== 0)) {
    for (; e !== null; ) {
      if ((e.f & Xn) !== 0) {
        if ((e.f & Wt) === 0)
          throw t;
        try {
          e.b.error(t);
          return;
        } catch (n) {
          t = n;
        }
      }
      e = e.parent;
    }
    throw t;
  }
}
const ka = -7169;
function $(t, e) {
  t.f = t.f & ka | e;
}
function cr(t) {
  (t.f & De) !== 0 || t.deps === null ? $(t, ie) : $(t, We);
}
function Xr(t) {
  if (t !== null)
    for (const e of t)
      (e.f & fe) === 0 || (e.f & Lt) === 0 || (e.f ^= Lt, Xr(
        /** @type {Derived} */
        e.deps
      ));
}
function Qr(t, e, n) {
  (t.f & te) !== 0 ? e.add(t) : (t.f & We) !== 0 && n.add(t), Xr(t.deps), $(t, ie);
}
let _n = !1;
function ba(t) {
  var e = _n;
  try {
    return _n = !1, [t(), _n];
  } finally {
    _n = e;
  }
}
let mr = !1;
function ya() {
  mr || (mr = !0, document.addEventListener(
    "reset",
    (t) => {
      Promise.resolve().then(() => {
        if (!t.defaultPrevented)
          for (
            const e of
            /**@type {HTMLFormElement} */
            t.target.elements
          )
            e[mn]?.();
      });
    },
    // In the capture phase to guarantee we get noticed of it (no possibility of stopPropagation)
    { capture: !0 }
  ));
}
function dn(t) {
  var e = j, n = F;
  qe(null), rt(null);
  try {
    return t();
  } finally {
    qe(e), rt(n);
  }
}
function Jr(t, e, n, r = n) {
  t.addEventListener(e, () => dn(n));
  const i = (
    /** @type {any} */
    t[mn]
  );
  i ? t[mn] = () => {
    i(), r(!0);
  } : t[mn] = () => r(!0), ya();
}
function xa(t) {
  let e = 0, n = Nt(0), r;
  return () => {
    vr() && (s(n), Ln(() => (e === 0 && (r = On(() => t(() => ln(n)))), e += 1, () => {
      et(() => {
        e -= 1, e === 0 && (r?.(), r = void 0, ln(n));
      });
    })));
  };
}
var Ea = Mt | Xt;
function Ta(t, e, n, r) {
  new Ca(t, e, n, r);
}
class Ca {
  /** @type {Boundary | null} */
  parent;
  is_pending = !1;
  /**
   * API-level transformError transform function. Transforms errors before they reach the `failed` snippet.
   * Inherited from parent boundary, or defaults to identity.
   * @type {(error: unknown) => unknown}
   */
  transform_error;
  /** @type {TemplateNode} */
  #e;
  /** @type {TemplateNode | null} */
  #a = null;
  /** @type {BoundaryProps} */
  #t;
  /** @type {((anchor: Node) => void)} */
  #o;
  /** @type {Effect} */
  #r;
  /** @type {Effect | null} */
  #s = null;
  /** @type {Effect | null} */
  #n = null;
  /** @type {Effect | null} */
  #l = null;
  /** @type {DocumentFragment | null} */
  #i = null;
  #v = 0;
  #c = 0;
  #u = !1;
  /** @type {Set<Effect>} */
  #d = /* @__PURE__ */ new Set();
  /** @type {Set<Effect>} */
  #h = /* @__PURE__ */ new Set();
  /**
   * A source containing the number of pending async deriveds/expressions.
   * Only created if `$effect.pending()` is used inside the boundary,
   * otherwise updating the source results in needless `Batch.ensure()`
   * calls followed by no-op flushes
   * @type {Source<number> | null}
   */
  #f = null;
  #_ = xa(() => (this.#f = Nt(this.#v), () => {
    this.#f = null;
  }));
  /**
   * @param {TemplateNode} node
   * @param {BoundaryProps} props
   * @param {((anchor: Node) => void)} children
   * @param {((error: unknown) => unknown) | undefined} [transform_error]
   */
  constructor(e, n, r, i) {
    this.#e = e, this.#t = n, this.#o = (a) => {
      var l = (
        /** @type {Effect} */
        F
      );
      l.b = this, l.f |= Xn, r(a);
    }, this.parent = /** @type {Effect} */
    F.b, this.transform_error = i ?? this.parent?.transform_error ?? ((a) => a), this.#r = Nn(() => {
      this.#m();
    }, Ea);
  }
  #g() {
    try {
      this.#s = Ue(() => this.#o(this.#e));
    } catch (e) {
      this.error(e);
    }
  }
  /**
   * @param {unknown} error The deserialized error from the server's hydration comment
   */
  #k(e) {
    const n = this.#t.failed, { reset: r, invoke_onerror: i } = this.#p(e);
    et(i), n && (this.#l = Ue(() => {
      n(
        this.#e,
        () => e,
        () => r
      );
    }));
  }
  /**
   * Creates the `reset` function for a failed boundary, along with a function
   * that invokes `onerror` with it (if provided)
   * @param {unknown} error
   * @returns {{ reset: () => void, invoke_onerror: () => void }}
   */
  #p(e) {
    var n = !1, r = !1;
    const i = () => {
      if (n) {
        _a();
        return;
      }
      n = !0, r && na(), this.#l !== null && Pt(this.#l, () => {
        this.#l = null;
      }), this.#w(() => {
        this.#m();
      });
    };
    return { reset: i, invoke_onerror: () => {
      try {
        r = !0, this.#t.onerror?.(e, i), r = !1;
      } catch (l) {
        _t(l, this.#r && this.#r.parent);
      }
    } };
  }
  #b() {
    const e = this.#t.pending;
    e && (this.is_pending = !0, this.#n = Ue(() => e(this.#e)), et(() => {
      var n = this.#i = document.createDocumentFragment(), r = wt();
      n.append(r), this.#s = this.#w(() => Ue(() => this.#o(r))), this.#c === 0 && (this.#e.before(n), this.#i = null, Pt(
        /** @type {Effect} */
        this.#n,
        () => {
          this.#n = null;
        }
      ), this.#y(
        /** @type {Batch} */
        q
      ));
    }));
  }
  #m() {
    try {
      if (this.is_pending = this.has_pending_snippet(), this.#c = 0, this.#v = 0, this.#s = Ue(() => {
        this.#o(this.#e);
      }), this.#c > 0) {
        var e = this.#i = document.createDocumentFragment();
        gr(this.#s, e);
        const n = (
          /** @type {(anchor: Node) => void} */
          this.#t.pending
        );
        this.#n = Ue(() => n(this.#e));
      } else
        this.#y(
          /** @type {Batch} */
          q
        );
    } catch (n) {
      this.error(n);
    }
  }
  /**
   * @param {Batch} batch
   */
  #y(e) {
    this.is_pending = !1, e.transfer_effects(this.#d, this.#h);
  }
  /**
   * Defer an effect inside a pending boundary until the boundary resolves
   * @param {Effect} effect
   */
  defer_effect(e) {
    Qr(e, this.#d, this.#h);
  }
  /**
   * Returns `false` if the effect exists inside a boundary whose pending snippet is shown
   * @returns {boolean}
   */
  is_rendered() {
    return !this.is_pending && (!this.parent || this.parent.is_rendered());
  }
  has_pending_snippet() {
    return !!this.#t.pending;
  }
  /**
   * @template T
   * @param {() => T} fn
   */
  #w(e) {
    var n = F, r = j, i = _e;
    rt(this.#r), qe(this.#r), Kt(this.#r.ctx);
    try {
      return kt.ensure(), e();
    } catch (a) {
      return Wr(a), null;
    } finally {
      rt(n), qe(r), Kt(i);
    }
  }
  /**
   * Updates the pending count associated with the currently visible pending snippet,
   * if any, such that we can replace the snippet with content once work is done
   * @param {1 | -1} d
   * @param {Batch} batch
   */
  #x(e, n) {
    if (!this.has_pending_snippet()) {
      this.parent && this.parent.#x(e, n);
      return;
    }
    this.#c += e, this.#c === 0 && (this.#y(n), this.#n && Pt(this.#n, () => {
      this.#n = null;
    }), this.#i && (this.#e.before(this.#i), this.#i = null));
  }
  /**
   * Update the source that powers `$effect.pending()` inside this boundary,
   * and controls when the current `pending` snippet (if any) is removed.
   * Do not call from inside the class
   * @param {1 | -1} d
   * @param {Batch} batch
   */
  update_pending_count(e, n) {
    this.#x(e, n), this.#v += e, !(!this.#f || this.#u) && (this.#u = !0, et(() => {
      this.#u = !1, this.#f && Ut(this.#f, this.#v);
    }));
  }
  get_effect_pending() {
    return this.#_(), s(
      /** @type {Source<number>} */
      this.#f
    );
  }
  /** @param {unknown} error */
  error(e) {
    if (!this.#t.onerror && !this.#t.failed)
      throw e;
    q?.is_fork ? (this.#s && q.skip_effect(this.#s), this.#n && q.skip_effect(this.#n), this.#l && q.skip_effect(this.#l), q.oncommit(() => {
      this.#E(e);
    })) : this.#E(e);
  }
  /**
   * @param {unknown} error
   */
  #E(e) {
    this.#s && (Ce(this.#s), this.#s = null), this.#n && (Ce(this.#n), this.#n = null), this.#l && (Ce(this.#l), this.#l = null);
    let n = this.#t.failed;
    const r = (i) => {
      const { reset: a, invoke_onerror: l } = this.#p(i);
      l(), n && (this.#l = this.#w(() => {
        try {
          return Ue(() => {
            var o = (
              /** @type {Effect} */
              F
            );
            o.b = this, o.f |= Xn, n(
              this.#e,
              () => i,
              () => a
            );
          });
        } catch (o) {
          return _t(
            o,
            /** @type {Effect} */
            this.#r.parent
          ), null;
        }
      }));
    };
    et(() => {
      var i;
      try {
        i = this.transform_error(e);
      } catch (a) {
        _t(a, this.#r && this.#r.parent);
        return;
      }
      i !== null && typeof i == "object" && typeof /** @type {any} */
      i.then == "function" ? i.then(
        r,
        /** @param {unknown} e */
        (a) => _t(a, this.#r && this.#r.parent)
      ) : r(i);
    });
  }
}
function Aa(t, e, n, r) {
  const i = cn;
  var a = t.filter((_) => !_.settled), l = e.map(i);
  if (n.length === 0 && a.length === 0) {
    r(l);
    return;
  }
  var o = (
    /** @type {Effect} */
    F
  ), c = Sa(), f = a.length === 1 ? a[0].promise : a.length > 1 ? Promise.all(a.map((_) => _.promise)) : null;
  function u(_) {
    if ((o.f & Me) === 0) {
      c();
      try {
        r([...l, ..._]);
      } catch (g) {
        _t(g, o);
      }
      En();
    }
  }
  var v = Zr();
  if (n.length === 0) {
    f.then(() => u([])).finally(v);
    return;
  }
  function d() {
    Promise.all(n.map((_) => /* @__PURE__ */ Pa(_))).then(u).catch((_) => _t(_, o)).finally(v);
  }
  f ? f.then(() => {
    c(), d(), En();
  }) : d();
}
function Sa() {
  var t = (
    /** @type {Effect} */
    F
  ), e = j, n = _e, r = (
    /** @type {Batch} */
    q
  );
  return function(a = !0) {
    rt(t), qe(e), Kt(n), a && (t.f & Me) === 0 && (r?.activate(), r?.apply());
  };
}
function En(t = !0) {
  rt(null), qe(null), Kt(null), t && q?.deactivate();
}
function Zr() {
  var t = (
    /** @type {Effect} */
    F
  ), e = t.b, n = (
    /** @type {Batch} */
    q
  ), r = !!e?.is_rendered();
  return e?.update_pending_count(1, n), n.increment(r, t), () => {
    e?.update_pending_count(-1, n), n.decrement(r, t);
  };
}
// @__NO_SIDE_EFFECTS__
function cn(t) {
  var e = fe | te;
  return F !== null && (F.f |= Xt), {
    ctx: _e,
    deps: null,
    effects: null,
    equals: Ur,
    f: e,
    fn: t,
    reactions: null,
    rv: 0,
    v: (
      /** @type {V} */
      re
    ),
    wv: 0,
    parent: F,
    ac: null
  };
}
const tn = /* @__PURE__ */ Symbol("obsolete");
// @__NO_SIDE_EFFECTS__
function Pa(t, e, n) {
  let r = (
    /** @type {Effect | null} */
    F
  );
  r === null && Yi();
  var i = (
    /** @type {Promise<V>} */
    /** @type {unknown} */
    void 0
  ), a = Nt(
    /** @type {V} */
    re
  ), l = !j, o = /* @__PURE__ */ new Set();
  return Ua(() => {
    var c = (
      /** @type {Effect} */
      F
    ), f = Ir();
    i = f.promise;
    try {
      Promise.resolve(t()).then(f.resolve, (_) => {
        _ !== fn && f.reject(_);
      }).finally(En);
    } catch (_) {
      f.reject(_), En();
    }
    var u = (
      /** @type {Batch} */
      q
    );
    if (l) {
      if ((c.f & Wt) !== 0)
        var v = Zr();
      if (
        // boundary can be null if the async derived is inside an $effect.root not connected to the component render tree
        r.b?.is_rendered()
      )
        u.async_deriveds.get(c)?.reject(tn);
      else
        for (const _ of o.values())
          _.reject(tn);
      o.add(f), u.async_deriveds.set(c, f);
    }
    const d = (_, g = void 0) => {
      v?.(), o.delete(f), g !== tn && (u.activate(), g ? (a.f |= mt, Ut(a, g)) : ((a.f & mt) !== 0 && (a.f ^= mt), Ut(a, _)), u.deactivate());
    };
    f.promise.then(d, (_) => d(null, _ || "unknown"));
  }), fi(() => {
    for (const c of o)
      c.reject(tn);
  }), new Promise((c) => {
    function f(u) {
      function v() {
        u === i ? c(a) : f(i);
      }
      u.then(v, v);
    }
    f(i);
  });
}
// @__NO_SIDE_EFFECTS__
function E(t) {
  const e = /* @__PURE__ */ cn(t);
  return mi(e), e;
}
// @__NO_SIDE_EFFECTS__
function $r(t) {
  const e = /* @__PURE__ */ cn(t);
  return e.equals = Gr, e;
}
function za(t) {
  var e = t.effects;
  if (e !== null) {
    t.effects = null;
    for (var n = 0; n < e.length; n += 1)
      Ce(
        /** @type {Effect} */
        e[n]
      );
  }
}
function ur(t) {
  var e, n = F, r = t.parent;
  if (!ot && r !== null && t.v !== re && // if it was never evaluated before, it's guaranteed to fail downstream, so we try to execute instead
  (r.f & (Me | ge)) !== 0)
    return ga(), t.v;
  rt(r);
  try {
    t.f &= ~Lt, za(t), e = yi(t);
  } finally {
    rt(n);
  }
  return e;
}
function ei(t) {
  var e = ur(t);
  if (!t.equals(e) && (t.wv = ki(), (!q?.is_fork || t.deps === null) && (q !== null ? (q.capture(t, e, !0), er?.capture(t, e, !0)) : t.v = e, t.deps === null))) {
    $(t, ie);
    return;
  }
  ot || (Ye !== null ? (vr() || q?.is_fork) && Ye.set(t, e) : cr(t));
}
function Ma(t) {
  if (t.effects !== null)
    for (const e of t.effects)
      (e.teardown || e.ac) && (e.teardown?.(), e.ac !== null && dn(() => {
        e.ac.abort(fn), e.ac = null;
      }), e.fn !== null && (e.teardown = Wn), un(e, 0), hr(e));
}
function ti(t) {
  if (t.effects !== null)
    for (const e of t.effects)
      e.teardown && e.fn !== null && Gt(e);
}
let qn = null, Rt = null, q = null, er = null, Ye = null, tr = null, sn = !1, Fn = !1, Dt = null, wn = null;
var wr = 0;
let La = 1;
class kt {
  id = La++;
  /** True as soon as `#process` was called */
  #e = !1;
  linked = !0;
  /** @type {Batch | null} */
  #a = null;
  /** @type {Batch | null} */
  #t = null;
  /** @type {Map<Effect, ReturnType<typeof deferred<any>>>} */
  async_deriveds = /* @__PURE__ */ new Map();
  /**
   * The current values of any signals that are updated in this batch.
   * Tuple format: [value, is_derived] (note: is_derived is false for deriveds, too, if they were overridden via assignment)
   * They keys of this map are identical to `this.#previous`
   * @type {Map<Value, [any, boolean]>}
   */
  current = /* @__PURE__ */ new Map();
  /**
   * The values of any signals (sources and deriveds) that are updated in this batch _before_ those updates took place.
   * They keys of this map are identical to `this.#current`
   * @type {Map<Value, any>}
   */
  previous = /* @__PURE__ */ new Map();
  /**
   * When the batch is committed (and the DOM is updated), we need to remove old branches
   * and append new ones by calling the functions added inside (if/each/key/etc) blocks
   * @type {Set<(batch: Batch) => void>}
   */
  #o = /* @__PURE__ */ new Set();
  /**
   * If a fork is discarded, we need to destroy any effects that are no longer needed
   * @type {Set<(batch: Batch) => void>}
   */
  #r = /* @__PURE__ */ new Set();
  /**
   * The number of async effects that are currently in flight
   */
  #s = 0;
  /**
   * Async effects that are currently in flight, _not_ inside a pending boundary
   * @type {Map<Effect, number>}
   */
  #n = /* @__PURE__ */ new Map();
  /**
   * A deferred that resolves when the batch is committed, used with `settled()`
   * TODO replace with Promise.withResolvers once supported widely enough
   * @type {{ promise: Promise<void>, resolve: (value?: any) => void, reject: (reason: unknown) => void } | null}
   */
  #l = null;
  /**
   * The root effects that need to be flushed
   * @type {Effect[]}
   */
  #i = [];
  /**
   * Effects created while this batch was active.
   * @type {Effect[]}
   */
  #v = [];
  /**
   * Deferred effects (which run after async work has completed) that are DIRTY
   * @type {Set<Effect>}
   */
  #c = /* @__PURE__ */ new Set();
  /**
   * Deferred effects that are MAYBE_DIRTY
   * @type {Set<Effect>}
   */
  #u = /* @__PURE__ */ new Set();
  /**
   * A map of branches that still exist, but will be destroyed when this batch
   * is committed — we skip over these during `process`.
   * The value contains child effects that were dirty/maybe_dirty before being reset,
   * so they can be rescheduled if the branch survives.
   * @type {Map<Effect, { d: Effect[], m: Effect[] }>}
   */
  #d = /* @__PURE__ */ new Map();
  /**
   * Inverse of #skipped_branches which we need to tell prior batches to unskip them when committing
   * @type {Set<Effect>}
   */
  #h = /* @__PURE__ */ new Set();
  is_fork = !1;
  #f = !1;
  constructor() {
    Rt === null ? qn = Rt = this : (Rt.#t = this, this.#a = Rt), Rt = this;
  }
  #_() {
    if (this.is_fork) return !0;
    for (const r of this.#n.keys()) {
      for (var e = r, n = !1; e.parent !== null; ) {
        if (this.#d.has(e)) {
          n = !0;
          break;
        }
        e = e.parent;
      }
      if (!n)
        return !0;
    }
    return !1;
  }
  /**
   * Add an effect to the #skipped_branches map and reset its children
   * @param {Effect} effect
   */
  skip_effect(e) {
    this.#d.has(e) || this.#d.set(e, { d: [], m: [] }), this.#h.delete(e);
  }
  /**
   * Remove an effect from the #skipped_branches map and reschedule
   * any tracked dirty/maybe_dirty child effects
   * @param {Effect} effect
   * @param {(e: Effect) => void} callback
   */
  unskip_effect(e, n = (r) => this.schedule(r)) {
    var r = this.#d.get(e);
    if (r) {
      this.#d.delete(e);
      for (var i of r.d)
        $(i, te), n(i);
      for (i of r.m)
        $(i, We), n(i);
    }
    this.#h.add(e);
  }
  #g() {
    this.#e = !0, wr++ > 1e3 && (this.#w(), Oa());
    for (const c of this.#c)
      this.#u.delete(c), $(c, te), this.schedule(c);
    for (const c of this.#u)
      $(c, We), this.schedule(c);
    const e = this.#i;
    this.#i = [], this.apply();
    var n = Dt = [], r = [], i = wn = [];
    for (const c of e)
      try {
        this.#k(c, n, r);
      } catch (f) {
        throw ii(c), this.#_() || this.discard(), f;
      }
    if (q = null, i.length > 0) {
      var a = kt.ensure();
      for (const c of i)
        a.schedule(c);
    }
    if (Dt = null, wn = null, this.#_()) {
      this.#m(r), this.#m(n);
      for (const [c, f] of this.#d)
        ri(c, f);
      i.length > 0 && /** @type {unknown} */
      q.#g();
      return;
    }
    const l = this.#p();
    if (l) {
      this.#m(r), this.#m(n), l.#b(this);
      return;
    }
    this.#c.clear(), this.#u.clear();
    for (const c of this.#o) c(this);
    this.#o.clear(), er = this, kr(r), kr(n), er = null, this.#l?.resolve();
    var o = (
      /** @type {Batch | null} */
      /** @type {unknown} */
      q
    );
    if (this.#s === 0 && (this.#i.length === 0 || o !== null) && this.#w(), this.#i.length > 0)
      if (o !== null) {
        const c = o;
        c.#i.push(...this.#i.filter((f) => !c.#i.includes(f)));
      } else
        o = this;
    o !== null && (tt.clear(), o.#g());
  }
  /**
   * Traverse the effect tree, executing effects or stashing
   * them for later execution as appropriate
   * @param {Effect} root
   * @param {Effect[]} effects
   * @param {Effect[]} render_effects
   */
  #k(e, n, r) {
    e.f ^= ie;
    for (var i = e.first; i !== null; ) {
      var a = i.f, l = (a & (Ie | lt)) !== 0, o = l && (a & ie) !== 0, c = o || (a & ge) !== 0 || this.#d.has(i);
      if (!c && i.fn !== null) {
        l ? i.f ^= ie : (a & jt) !== 0 ? n.push(i) : hn(i) && ((a & Ge) !== 0 && this.#u.add(i), Gt(i));
        var f = i.first;
        if (f !== null) {
          i = f;
          continue;
        }
      }
      for (; i !== null; ) {
        var u = i.next;
        if (u !== null) {
          i = u;
          break;
        }
        i = i.parent;
      }
    }
  }
  #p() {
    for (var e = this.#a; e !== null; ) {
      if (!e.is_fork) {
        for (const [n, [, r]] of this.current)
          if (e.current.has(n) && !r)
            return e;
      }
      e = e.#a;
    }
    return null;
  }
  /**
   * @param {Batch} batch
   */
  #b(e) {
    for (const [r, i] of e.current)
      !this.previous.has(r) && e.previous.has(r) && this.previous.set(r, e.previous.get(r)), this.current.set(r, i);
    for (const [r, i] of e.async_deriveds) {
      const a = this.async_deriveds.get(r);
      a && i.promise.then(a.resolve).catch(a.reject);
    }
    e.async_deriveds.clear(), this.transfer_effects(e.#c, e.#u);
    const n = (r) => {
      var i = r.reactions;
      if (i !== null && !((r.f & fe) !== 0 && (r.f & (te | We)) === 0))
        for (const o of i) {
          var a = o.f;
          if ((a & fe) !== 0)
            n(
              /** @type {Derived} */
              o
            );
          else {
            var l = (
              /** @type {Effect} */
              o
            );
            a & (It | Ge) && !this.async_deriveds.has(l) && (this.#u.delete(l), $(l, te), this.schedule(l));
          }
        }
    };
    for (const r of this.current.keys())
      n(r);
    this.oncommit(() => e.discard()), e.#w(), q = this, this.#g();
  }
  /**
   * @param {Effect[]} effects
   */
  #m(e) {
    for (var n = 0; n < e.length; n += 1)
      Qr(e[n], this.#c, this.#u);
  }
  /**
   * Associate a change to a given source with the current
   * batch, noting its previous and current values
   * @param {Value} source
   * @param {any} value
   * @param {boolean} [is_derived]
   */
  capture(e, n, r = !1) {
    e.v !== re && !this.previous.has(e) && this.previous.set(e, e.v), (e.f & mt) === 0 && (this.current.set(e, [n, r]), Ye?.set(e, n)), this.is_fork || (e.v = n);
  }
  activate() {
    q = this;
  }
  deactivate() {
    q = null, Ye = null;
  }
  flush() {
    try {
      Fn = !0, q = this, this.#g();
    } finally {
      wr = 0, tr = null, Dt = null, wn = null, Fn = !1, q = null, Ye = null, tt.clear();
    }
  }
  discard() {
    for (const e of this.#r) e(this);
    this.#r.clear();
    for (const e of this.async_deriveds.values())
      e.reject(tn);
    this.#w(), this.#l?.resolve();
  }
  /**
   * @param {Effect} effect
   */
  register_created_effect(e) {
    this.#v.push(e);
  }
  #y() {
    for (let v = qn; v !== null; v = v.#t) {
      var e = v.id < this.id, n = [];
      for (const [d, [_, g]] of this.current) {
        if (v.current.has(d)) {
          var r = (
            /** @type {[any, boolean]} */
            v.current.get(d)[0]
          );
          if (e && _ !== r)
            v.current.set(d, [_, g]);
          else
            continue;
        }
        n.push(d);
      }
      if (e)
        for (const [d, _] of this.async_deriveds) {
          const g = v.async_deriveds.get(d);
          g && _.promise.then(g.resolve).catch(g.reject);
        }
      var i = [...v.current.keys()].filter(
        (d) => !/** @type {[any, boolean]} */
        v.current.get(d)[1]
      );
      if (!(!v.#e || i.length === 0)) {
        var a = i.filter((d) => !this.current.has(d));
        if (a.length === 0)
          e && v.discard();
        else if (n.length > 0) {
          if (e)
            for (const d of this.#h)
              v.unskip_effect(d, (_) => {
                (_.f & (Ge | It)) !== 0 ? v.schedule(_) : v.#m([_]);
              });
          v.activate();
          var l = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Map();
          for (var c of n)
            ni(c, a, l, o);
          o = /* @__PURE__ */ new Map();
          var f = [...v.current].filter(([d, _]) => {
            const g = this.current.get(d);
            return g ? g[0] !== _[0] || g[1] !== _[1] : !0;
          }).map(([d]) => d);
          if (f.length > 0)
            for (const d of this.#v)
              (d.f & (Me | ge | yn)) === 0 && fr(d, f, o) && ((d.f & (It | Ge)) !== 0 ? ($(d, te), v.schedule(d)) : v.#c.add(d));
          if (v.#i.length > 0 && !v.#f) {
            v.apply();
            for (var u of v.#i)
              v.#k(u, [], []);
            v.#i = [];
          }
          v.deactivate();
        }
      }
    }
  }
  /**
   * @param {boolean} blocking
   * @param {Effect} effect
   */
  increment(e, n) {
    if (this.#s += 1, e) {
      let r = this.#n.get(n) ?? 0;
      this.#n.set(n, r + 1);
    }
  }
  /**
   * @param {boolean} blocking
   * @param {Effect} effect
   */
  decrement(e, n) {
    if (this.#s -= 1, e) {
      let r = this.#n.get(n) ?? 0;
      r === 1 ? this.#n.delete(n) : this.#n.set(n, r - 1);
    }
    this.#f || (this.#f = !0, et(() => {
      this.#f = !1, this.linked && this.flush();
    }));
  }
  /**
   * @param {Set<Effect>} dirty_effects
   * @param {Set<Effect>} maybe_dirty_effects
   */
  transfer_effects(e, n) {
    for (const r of e)
      this.#c.add(r);
    for (const r of n)
      this.#u.add(r);
    e.clear(), n.clear();
  }
  /** @param {(batch: Batch) => void} fn */
  oncommit(e) {
    this.#o.add(e);
  }
  /** @param {(batch: Batch) => void} fn */
  ondiscard(e) {
    this.#r.add(e);
  }
  settled() {
    return (this.#l ??= Ir()).promise;
  }
  static ensure() {
    if (q === null) {
      const e = q = new kt();
      !Fn && !sn && et(() => {
        e.#e || e.flush();
      });
    }
    return q;
  }
  apply() {
    {
      Ye = null;
      return;
    }
  }
  /**
   *
   * @param {Effect} effect
   */
  schedule(e) {
    if (tr = e, e.b?.is_pending && (e.f & (jt | Mn | qr)) !== 0 && (e.f & Wt) === 0) {
      e.b.defer_effect(e);
      return;
    }
    for (var n = e; n.parent !== null; ) {
      n = n.parent;
      var r = n.f;
      if (Dt !== null && n === F && (j === null || (j.f & fe) === 0))
        return;
      if ((r & (lt | Ie)) !== 0) {
        if ((r & ie) === 0)
          return;
        n.f ^= ie;
      }
    }
    this.#i.push(n);
  }
  #w() {
    if (this.linked) {
      var e = this.#a, n = this.#t;
      e === null ? qn = n : e.#t = n, n === null ? Rt = e : n.#a = e, this.linked = !1;
    }
  }
}
function Na(t) {
  var e = sn;
  sn = !0;
  try {
    for (var n; ; ) {
      if (wa(), q === null)
        return (
          /** @type {T} */
          n
        );
      q.flush();
    }
  } finally {
    sn = e;
  }
}
function Oa() {
  try {
    Ji();
  } catch (t) {
    _t(t, tr);
  }
}
let at = null;
function kr(t) {
  var e = t.length;
  if (e !== 0) {
    for (var n = 0; n < e; ) {
      var r = t[n++];
      if ((r.f & (Me | ge)) === 0 && hn(r) && (at = /* @__PURE__ */ new Set(), Gt(r), r.deps === null && r.first === null && r.nodes === null && r.teardown === null && r.ac === null && gi(r), at?.size > 0)) {
        tt.clear();
        for (const i of at) {
          if ((i.f & (Me | ge)) !== 0) continue;
          const a = [i];
          let l = i.parent;
          for (; l !== null; )
            at.has(l) && (at.delete(l), a.push(l)), l = l.parent;
          for (let o = a.length - 1; o >= 0; o--) {
            const c = a[o];
            (c.f & (Me | ge)) === 0 && Gt(c);
          }
        }
        at.clear();
      }
    }
    at = null;
  }
}
function ni(t, e, n, r) {
  if (!n.has(t) && (n.add(t), t.reactions !== null))
    for (const i of t.reactions) {
      const a = i.f;
      (a & fe) !== 0 ? ni(
        /** @type {Derived} */
        i,
        e,
        n,
        r
      ) : (a & (It | Ge)) !== 0 && (a & te) === 0 && fr(i, e, r) && ($(i, te), dr(
        /** @type {Effect} */
        i
      ));
    }
}
function fr(t, e, n) {
  const r = n.get(t);
  if (r !== void 0) return r;
  if (t.deps !== null)
    for (const i of t.deps) {
      if (bn.call(e, i))
        return !0;
      if ((i.f & fe) !== 0 && fr(
        /** @type {Derived} */
        i,
        e,
        n
      ))
        return n.set(
          /** @type {Derived} */
          i,
          !0
        ), !0;
    }
  return n.set(t, !1), !1;
}
function dr(t) {
  q.schedule(t);
}
function ri(t, e) {
  if (!((t.f & Ie) !== 0 && (t.f & ie) !== 0)) {
    (t.f & te) !== 0 ? e.d.push(t) : (t.f & We) !== 0 && e.m.push(t), $(t, ie);
    for (var n = t.first; n !== null; )
      ri(n, e), n = n.next;
  }
}
function ii(t) {
  $(t, ie);
  for (var e = t.first; e !== null; )
    ii(e), e = e.next;
}
let Tn = /* @__PURE__ */ new Set();
const tt = /* @__PURE__ */ new Map();
let ai = !1;
function Nt(t, e) {
  var n = {
    f: 0,
    // TODO ideally we could skip this altogether, but it causes type errors
    v: t,
    reactions: null,
    equals: Ur,
    rv: 0,
    wv: 0
  };
  return n;
}
// @__NO_SIDE_EFFECTS__
function R(t, e) {
  const n = Nt(t);
  return mi(n), n;
}
// @__NO_SIDE_EFFECTS__
function Ba(t, e = !1, n = !0) {
  const r = Nt(t);
  return e || (r.equals = Gr), r;
}
function A(t, e, n = !1) {
  j !== null && // since we are untracking the function inside `$inspect.with` we need to add this check
  // to ensure we error if state is set inside an inspect effect
  (!Ve || (j.f & yn) !== 0) && Yr() && (j.f & (fe | Ge | It | yn)) !== 0 && (nt === null || !nt.has(t)) && ta();
  let r = n ? Te(e) : e;
  return Ut(t, r, wn);
}
function Ut(t, e, n = null) {
  if (!t.equals(e)) {
    ot ? tt.set(t, e) : tt.has(t) || tt.set(t, t.v);
    var r = kt.ensure();
    if (r.capture(t, e), (t.f & fe) !== 0) {
      const i = (
        /** @type {Derived} */
        t
      );
      (t.f & te) !== 0 && ur(i), Ye === null && cr(i);
    }
    t.wv = ki(), si(t, te, n), F !== null && (F.f & ie) !== 0 && (F.f & (Ie | lt)) === 0 && (Oe === null ? Ya([t]) : Oe.push(t)), !r.is_fork && Tn.size > 0 && !ai && Ra();
  }
  return e;
}
function Ra() {
  ai = !1;
  for (const t of Tn) {
    (t.f & ie) !== 0 && $(t, We);
    let e;
    try {
      e = hn(t);
    } catch {
      e = !0;
    }
    e && Gt(t);
  }
  Tn.clear();
}
function ln(t) {
  A(t, t.v + 1);
}
function si(t, e, n) {
  var r = t.reactions;
  if (r !== null)
    for (var i = r.length, a = 0; a < i; a++) {
      var l = r[a], o = l.f, c = (o & te) === 0;
      if (c && $(l, e), (o & yn) !== 0)
        Tn.add(
          /** @type {Effect} */
          l
        );
      else if ((o & fe) !== 0) {
        var f = (
          /** @type {Derived} */
          l
        );
        Ye?.delete(f), (o & Lt) === 0 && (o & De && (F === null || (F.f & xn) === 0) && (l.f |= Lt), si(f, We, n));
      } else if (c) {
        var u = (
          /** @type {Effect} */
          l
        );
        (o & Ge) !== 0 && at !== null && at.add(u), n !== null ? n.push(u) : dr(u);
      }
    }
}
function Te(t) {
  if (typeof t != "object" || t === null || St in t)
    return t;
  const e = Hr(t);
  if (e !== Hi && e !== Ii)
    return t;
  var n = /* @__PURE__ */ new Map(), r = Dr(t), i = /* @__PURE__ */ R(0), a = zt, l = (o) => {
    if (zt === a)
      return o();
    var c = j, f = zt;
    qe(null), Er(a);
    var u = o();
    return qe(c), Er(f), u;
  };
  return r && n.set("length", /* @__PURE__ */ R(
    /** @type {any[]} */
    t.length
  )), new Proxy(
    /** @type {any} */
    t,
    {
      defineProperty(o, c, f) {
        (!("value" in f) || f.configurable === !1 || f.enumerable === !1 || f.writable === !1) && $i();
        var u = n.get(c);
        return u === void 0 ? l(() => {
          var v = /* @__PURE__ */ R(f.value);
          return n.set(c, v), v;
        }) : A(u, f.value, !0), !0;
      },
      deleteProperty(o, c) {
        var f = n.get(c);
        if (f === void 0) {
          if (c in o) {
            const u = l(() => /* @__PURE__ */ R(re));
            n.set(c, u), ln(i);
          }
        } else
          A(f, re), ln(i);
        return !0;
      },
      get(o, c, f) {
        if (c === St)
          return t;
        var u = n.get(c), v = c in o;
        if (u === void 0 && (!v || Ht(o, c)?.writable) && (u = l(() => {
          var _ = Te(v ? o[c] : re), g = /* @__PURE__ */ R(_);
          return g;
        }), n.set(c, u)), u !== void 0) {
          var d = s(u);
          return d === re ? void 0 : d;
        }
        return Reflect.get(o, c, f);
      },
      getOwnPropertyDescriptor(o, c) {
        var f = Reflect.getOwnPropertyDescriptor(o, c);
        if (f && "value" in f) {
          var u = n.get(c);
          u && (f.value = s(u));
        } else if (f === void 0) {
          var v = n.get(c), d = v?.v;
          if (v !== void 0 && d !== re)
            return {
              enumerable: !0,
              configurable: !0,
              value: d,
              writable: !0
            };
        }
        return f;
      },
      has(o, c) {
        if (c === St)
          return !0;
        var f = n.get(c), u = f !== void 0 && f.v !== re || Reflect.has(o, c);
        if (f !== void 0 || F !== null && (!u || Ht(o, c)?.writable)) {
          f === void 0 && (f = l(() => {
            var d = u ? Te(o[c]) : re, _ = /* @__PURE__ */ R(d);
            return _;
          }), n.set(c, f));
          var v = s(f);
          if (v === re)
            return !1;
        }
        return u;
      },
      set(o, c, f, u) {
        var v = n.get(c), d = c in o;
        if (r && c === "length")
          for (var _ = f; _ < /** @type {Source<number>} */
          v.v; _ += 1) {
            var g = n.get(_ + "");
            g !== void 0 ? A(g, re) : _ in o && (g = l(() => /* @__PURE__ */ R(re)), n.set(_ + "", g));
          }
        if (v === void 0)
          (!d || Ht(o, c)?.writable) && (v = l(() => /* @__PURE__ */ R(void 0)), A(v, Te(f)), n.set(c, v));
        else {
          d = v.v !== re;
          var m = l(() => Te(f));
          A(v, m);
        }
        var h = Reflect.getOwnPropertyDescriptor(o, c);
        if (h?.set && h.set.call(u, f), !d) {
          if (r && typeof c == "string") {
            var p = (
              /** @type {Source<number>} */
              n.get("length")
            ), y = Number(c);
            Number.isInteger(y) && y >= p.v && A(p, y + 1);
          }
          ln(i);
        }
        return !0;
      },
      ownKeys(o) {
        s(i);
        var c = Reflect.ownKeys(o).filter((v) => {
          var d = n.get(v);
          return d === void 0 || d.v !== re;
        });
        for (var [f, u] of n)
          u.v !== re && !(f in o) && c.push(f);
        return c;
      },
      setPrototypeOf() {
        ea();
      }
    }
  );
}
function br(t) {
  try {
    if (t !== null && typeof t == "object" && St in t)
      return t[St];
  } catch {
  }
  return t;
}
function Da(t, e) {
  return Object.is(br(t), br(e));
}
var yr, li, oi, ci;
function Ha() {
  if (yr === void 0) {
    yr = window, li = /Firefox/.test(navigator.userAgent);
    var t = Element.prototype, e = Node.prototype, n = Text.prototype;
    oi = Ht(e, "firstChild").get, ci = Ht(e, "nextSibling").get, pr(t) && (t[Jn] = void 0, t[Fr] = null, t[Zn] = void 0, t.__e = void 0), pr(n) && (n[$n] = void 0);
  }
}
function wt(t = "") {
  return document.createTextNode(t);
}
// @__NO_SIDE_EFFECTS__
function pt(t) {
  return (
    /** @type {TemplateNode | null} */
    oi.call(t)
  );
}
// @__NO_SIDE_EFFECTS__
function vn(t) {
  return (
    /** @type {TemplateNode | null} */
    ci.call(t)
  );
}
function w(t, e) {
  return /* @__PURE__ */ pt(t);
}
function K(t, e = !1) {
  {
    var n = /* @__PURE__ */ pt(t);
    return n instanceof Comment && n.data === "" ? /* @__PURE__ */ vn(n) : n;
  }
}
function T(t, e = 1, n = !1) {
  let r = t;
  for (; e--; )
    r = /** @type {TemplateNode} */
    /* @__PURE__ */ vn(r);
  return r;
}
function Ia(t) {
  t.textContent = "";
}
function ui(t, e, n) {
  return e == null || e === Kr ? (
    /** @type {T extends keyof HTMLElementTagNameMap ? HTMLElementTagNameMap[T] : Element} */
    n ? document.createElement(t, { is: n }) : document.createElement(t)
  ) : (
    /** @type {T extends keyof HTMLElementTagNameMap ? HTMLElementTagNameMap[T] : Element} */
    n ? document.createElementNS(e, t, { is: n }) : document.createElementNS(e, t)
  );
}
function qa(t) {
  F === null && (j === null && Qi(), Xi()), ot && Wi();
}
function Fa(t, e) {
  var n = e.last;
  n === null ? e.last = e.first = t : (n.next = t, t.prev = n, e.last = t);
}
function ut(t, e) {
  var n = F;
  n !== null && (n.f & ge) !== 0 && (t |= ge);
  var r = {
    ctx: _e,
    deps: null,
    nodes: null,
    f: t | te | De,
    first: null,
    fn: e,
    last: null,
    next: null,
    parent: n,
    b: n && n.b,
    prev: null,
    teardown: null,
    wv: 0,
    ac: null
  };
  q?.register_created_effect(r);
  var i = r;
  if ((t & jt) !== 0)
    Dt !== null ? Dt.push(r) : kt.ensure().schedule(r);
  else if (e !== null) {
    try {
      Gt(r);
    } catch (l) {
      throw Ce(r), l;
    }
    i.deps === null && i.teardown === null && i.nodes === null && i.first === i.last && // either `null`, or a singular child
    (i.f & Xt) === 0 && (i = i.first, (t & Ge) !== 0 && (t & Mt) !== 0 && i !== null && (i.f |= Mt));
  }
  if (i !== null && (i.parent = n, n !== null && Fa(i, n), j !== null && (j.f & fe) !== 0 && (t & lt) === 0)) {
    var a = (
      /** @type {Derived} */
      j
    );
    (a.effects ??= []).push(i);
  }
  return r;
}
function vr() {
  return j !== null && !Ve;
}
function fi(t) {
  const e = ut(Mn, null);
  return $(e, ie), e.teardown = t, e;
}
function He(t) {
  qa();
  var e = (
    /** @type {Effect} */
    F.f
  ), n = !j && (e & Ie) !== 0 && _e !== null && !_e.i;
  if (n) {
    var r = (
      /** @type {ComponentContext} */
      _e
    );
    (r.e ??= []).push(t);
  } else
    return di(t);
}
function di(t) {
  return ut(jt | ji, t);
}
function ja(t) {
  kt.ensure();
  const e = ut(lt | Xt, t);
  return (n = {}) => new Promise((r) => {
    n.outro ? Pt(e, () => {
      Ce(e), r(void 0);
    }) : (Ce(e), r(void 0));
  });
}
function Ka(t) {
  return ut(jt, t);
}
function Ua(t) {
  return ut(It | Xt, t);
}
function Ln(t, e = 0) {
  return ut(Mn | e, t);
}
function z(t, e = [], n = [], r = []) {
  Aa(r, e, n, (i) => {
    ut(Mn, () => {
      t(...i.map(s));
    });
  });
}
function Nn(t, e = 0) {
  var n = ut(Ge | e, t);
  return n;
}
function Ue(t) {
  return ut(Ie | Xt, t);
}
function vi(t) {
  var e = t.teardown;
  if (e !== null) {
    const n = ot, r = j;
    xr(!0), qe(null);
    try {
      e.call(null);
    } finally {
      xr(n), qe(r);
    }
  }
}
function hr(t, e = !1) {
  var n = t.first;
  for (t.first = t.last = null; n !== null; ) {
    const i = n.ac;
    i !== null && dn(() => {
      i.abort(fn);
    });
    var r = n.next;
    (n.f & lt) !== 0 ? n.parent = null : Ce(n, e), n = r;
  }
}
function Ga(t) {
  for (var e = t.first; e !== null; ) {
    var n = e.next;
    (e.f & Ie) === 0 && Ce(e), e = n;
  }
}
function Ce(t, e = !0) {
  var n = !1;
  (e || (t.f & Fi) !== 0) && t.nodes !== null && t.nodes.end !== null && (hi(
    t.nodes.start,
    /** @type {TemplateNode} */
    t.nodes.end
  ), n = !0), t.f |= Qn, hr(t, e && !n), un(t, 0);
  var r = t.nodes && t.nodes.t;
  if (r !== null)
    for (const a of r)
      a.stop();
  vi(t), t.f ^= Qn, t.f |= Me;
  var i = t.parent;
  i !== null && i.first !== null && gi(t), t.next = t.prev = t.teardown = t.ctx = t.deps = t.fn = t.nodes = t.ac = t.b = null;
}
function hi(t, e) {
  for (; t !== null; ) {
    var n = t === e ? null : /* @__PURE__ */ vn(t);
    t.remove(), t = n;
  }
}
function gi(t) {
  var e = t.parent, n = t.prev, r = t.next;
  n !== null && (n.next = r), r !== null && (r.prev = n), e !== null && (e.first === t && (e.first = r), e.last === t && (e.last = n));
}
function Pt(t, e, n = !0) {
  var r = [];
  _i(t, r, !0);
  var i = () => {
    n && Ce(t), e && e();
  }, a = r.length;
  if (a > 0) {
    var l = () => --a || i();
    for (var o of r)
      o.out(l);
  } else
    i();
}
function _i(t, e, n) {
  if ((t.f & ge) === 0) {
    t.f ^= ge;
    var r = t.nodes && t.nodes.t;
    if (r !== null)
      for (const o of r)
        (o.is_global || n) && e.push(o);
    for (var i = t.first; i !== null; ) {
      var a = i.next;
      if ((i.f & lt) === 0) {
        var l = (i.f & Mt) !== 0 || // If this is a branch effect without a block effect parent,
        // it means the parent block effect was pruned. In that case,
        // transparency information was transferred to the branch effect.
        (i.f & Ie) !== 0 && (t.f & Ge) !== 0;
        _i(i, e, l ? n : !1);
      }
      i = a;
    }
  }
}
function Cn(t) {
  pi(t, !0);
}
function pi(t, e) {
  if ((t.f & ge) !== 0) {
    t.f ^= ge, (t.f & ie) === 0 && ($(t, te), kt.ensure().schedule(t));
    for (var n = t.first; n !== null; ) {
      var r = n.next, i = (n.f & Mt) !== 0 || (n.f & Ie) !== 0;
      pi(n, i ? e : !1), n = r;
    }
    var a = t.nodes && t.nodes.t;
    if (a !== null)
      for (const l of a)
        (l.is_global || e) && l.in();
  }
}
function gr(t, e) {
  if (t.nodes)
    for (var n = t.nodes.start, r = t.nodes.end; n !== null; ) {
      var i = n === r ? null : /* @__PURE__ */ vn(n);
      e.append(n), n = i;
    }
}
let kn = !1, ot = !1;
function xr(t) {
  ot = t;
}
let j = null, Ve = !1;
function qe(t) {
  j = t;
}
let F = null;
function rt(t) {
  F = t;
}
let nt = null;
function mi(t) {
  j !== null && (nt ??= /* @__PURE__ */ new Set()).add(t);
}
let Ee = null, Pe = 0, Oe = null;
function Ya(t) {
  Oe = t;
}
let wi = 1, At = 0, zt = At;
function Er(t) {
  zt = t;
}
function ki() {
  return ++wi;
}
function hn(t) {
  var e = t.f;
  if ((e & te) !== 0)
    return !0;
  if (e & fe && (t.f &= ~Lt), (e & We) !== 0) {
    for (var n = (
      /** @type {Value[]} */
      t.deps
    ), r = n.length, i = 0; i < r; i++) {
      var a = n[i];
      if (hn(
        /** @type {Derived} */
        a
      ) && ei(
        /** @type {Derived} */
        a
      ), a.wv > t.wv)
        return !0;
    }
    (e & De) !== 0 && // During time traveling we don't want to reset the status so that
    // traversal of the graph in the other batches still happens
    Ye === null && $(t, ie);
  }
  return !1;
}
function bi(t, e, n = !0) {
  var r = t.reactions;
  if (r !== null && !(nt !== null && nt.has(t)))
    for (var i = 0; i < r.length; i++) {
      var a = r[i];
      (a.f & fe) !== 0 ? bi(
        /** @type {Derived} */
        a,
        e,
        !1
      ) : e === a && (n ? $(a, te) : (a.f & ie) !== 0 && $(a, We), dr(
        /** @type {Effect} */
        a
      ));
    }
}
function yi(t) {
  var e = Ee, n = Pe, r = Oe, i = j, a = nt, l = _e, o = Ve, c = zt, f = t.f;
  Ee = /** @type {null | Value[]} */
  null, Pe = 0, Oe = null, j = (f & (Ie | lt)) === 0 ? t : null, nt = null, Kt(t.ctx), Ve = !1, zt = ++At, t.ac !== null && (dn(() => {
    t.ac.abort(fn);
  }), t.ac = null);
  try {
    t.f |= xn;
    var u = (
      /** @type {Function} */
      t.fn
    ), v = u();
    t.f |= Wt;
    var d = t.deps, _ = q?.is_fork;
    if (Ee !== null) {
      var g;
      if (_ || un(t, Pe), d !== null && Pe > 0)
        for (d.length = Pe + Ee.length, g = 0; g < Ee.length; g++)
          d[Pe + g] = Ee[g];
      else
        t.deps = d = Ee;
      if (vr() && (t.f & De) !== 0)
        for (g = Pe; g < d.length; g++)
          (d[g].reactions ??= []).push(t);
    } else !_ && d !== null && Pe < d.length && (un(t, Pe), d.length = Pe);
    if (Yr() && Oe !== null && !Ve && d !== null && (t.f & (fe | We | te)) === 0)
      for (g = 0; g < /** @type {Source[]} */
      Oe.length; g++)
        bi(
          Oe[g],
          /** @type {Effect} */
          t
        );
    if (i !== null && i !== t) {
      if (At++, i.deps !== null)
        for (let m = 0; m < n; m += 1)
          i.deps[m].rv = At;
      if (e !== null)
        for (const m of e)
          m.rv = At;
      Oe !== null && (r === null ? r = Oe : r.push(.../** @type {Source[]} */
      Oe));
    }
    return (t.f & mt) !== 0 && (t.f ^= mt), v;
  } catch (m) {
    return Wr(m);
  } finally {
    t.f ^= xn, Ee = e, Pe = n, Oe = r, j = i, nt = a, Kt(l), Ve = o, zt = c;
  }
}
function Va(t, e) {
  let n = e.reactions;
  if (n !== null) {
    var r = Bi.call(n, t);
    if (r !== -1) {
      var i = n.length - 1;
      i === 0 ? n = e.reactions = null : (n[r] = n[i], n.pop());
    }
  }
  if (n === null && (e.f & fe) !== 0 && // Destroying a child effect while updating a parent effect can cause a dependency to appear
  // to be unused, when in fact it is used by the currently-updating parent. Checking `new_deps`
  // allows us to skip the expensive work of disconnecting and immediately reconnecting it
  (Ee === null || !bn.call(Ee, e))) {
    var a = (
      /** @type {Derived} */
      e
    );
    (a.f & De) !== 0 && (a.f ^= De, a.f &= ~Lt), a.v !== re && cr(a), a.ac !== null && dn(() => {
      a.ac.abort(fn), a.ac = null, $(a, te);
    }), Ma(a), un(a, 0);
  }
}
function un(t, e) {
  var n = t.deps;
  if (n !== null)
    for (var r = e; r < n.length; r++)
      Va(t, n[r]);
}
function Gt(t) {
  var e = t.f;
  if ((e & Me) === 0) {
    $(t, ie);
    var n = F, r = kn;
    F = t, kn = (e & (Ie | lt)) === 0;
    try {
      (e & (Ge | qr)) !== 0 ? Ga(t) : hr(t), vi(t);
      var i = yi(t);
      t.teardown = typeof i == "function" ? i : null, t.wv = wi;
      var a;
      Rr && ma && (t.f & te) !== 0 && t.deps;
    } finally {
      kn = r, F = n;
    }
  }
}
async function Wa() {
  await Promise.resolve(), Na();
}
function s(t) {
  var e = t.f, n = (e & fe) !== 0;
  if (j !== null && !Ve) {
    var r = F !== null && (F.f & Me) !== 0;
    if (!r && (nt === null || !nt.has(t))) {
      var i = j.deps;
      if ((j.f & xn) !== 0)
        t.rv < At && (t.rv = At, Ee === null && i !== null && i[Pe] === t ? Pe++ : Ee === null ? Ee = [t] : Ee.push(t));
      else {
        j.deps ??= [], bn.call(j.deps, t) || j.deps.push(t);
        var a = t.reactions;
        a === null ? t.reactions = [j] : bn.call(a, j) || a.push(j);
      }
    }
  }
  if (ot && tt.has(t))
    return tt.get(t);
  if (n) {
    var l = (
      /** @type {Derived} */
      t
    );
    if (ot) {
      var o = l.v;
      return ((l.f & ie) === 0 && l.reactions !== null || Ei(l)) && (o = ur(l)), tt.set(l, o), o;
    }
    var c = (l.f & De) === 0 && !Ve && j !== null && (kn || (j.f & De) !== 0), f = (l.f & Wt) === 0;
    hn(l) && (c && (l.f |= De), ei(l)), c && !f && (ti(l), xi(l));
  }
  if (Ye?.has(t))
    return Ye.get(t);
  if ((t.f & mt) !== 0)
    throw t.v;
  return t.v;
}
function xi(t) {
  if (t.f |= De, t.deps !== null)
    for (const e of t.deps)
      (e.reactions ??= []).push(t), (e.f & fe) !== 0 && (e.f & De) === 0 && (ti(
        /** @type {Derived} */
        e
      ), xi(
        /** @type {Derived} */
        e
      ));
}
function Ei(t) {
  if (t.v === re) return !0;
  if (t.deps === null) return !1;
  for (const e of t.deps)
    if (tt.has(e) || (e.f & fe) !== 0 && Ei(
      /** @type {Derived} */
      e
    ))
      return !0;
  return !1;
}
function On(t) {
  var e = Ve;
  try {
    return Ve = !0, t();
  } finally {
    Ve = e;
  }
}
const Xa = ["touchstart", "touchmove"];
function Qa(t) {
  return Xa.includes(t);
}
const nn = /* @__PURE__ */ Symbol("events"), Ti = /* @__PURE__ */ new Set(), nr = /* @__PURE__ */ new Set();
function ct(t, e, n) {
  (e[nn] ??= {})[t] = n;
}
function Bt(t) {
  for (var e = 0; e < t.length; e++)
    Ti.add(t[e]);
  for (var n of nr)
    n(t);
}
let jn = null, Kn = !1;
function Tr(t) {
  var e = this, n = (
    /** @type {Node} */
    e.ownerDocument
  ), r = t.type, i = t.composedPath?.() || [], a = (
    /** @type {null | Element} */
    i[0] || t.target
  );
  jn = t, Kn || (Kn = !0, setTimeout(() => {
    Kn = !1, jn = null;
  }));
  var l = 0, o = jn === t && t[nn];
  if (o) {
    var c = i.indexOf(o);
    if (c !== -1 && (e === document || e === /** @type {any} */
    window)) {
      t[nn] = e;
      return;
    }
    var f = i.indexOf(e);
    if (f === -1)
      return;
    c <= f && (l = c);
  }
  if (a = /** @type {Element} */
  i[l] || t.target, a !== e) {
    Ri(t, "currentTarget", {
      configurable: !0,
      get() {
        return a || n;
      }
    });
    var u = j, v = F;
    qe(null), rt(null);
    try {
      for (var d, _ = []; a !== null && a !== e; ) {
        try {
          var g = a[nn]?.[r];
          g != null && (!/** @type {any} */
          a.disabled || // DOM could've been updated already by the time this is reached, so we check this as well
          // -> the target could not have been disabled because it emits the event in the first place
          t.target === a) && g.call(a, t);
        } catch (m) {
          d ? _.push(m) : d = m;
        }
        if (t.cancelBubble) break;
        l++, a = l < i.length ? (
          /** @type {Element} */
          i[l]
        ) : null;
      }
      if (d) {
        for (let m of _)
          queueMicrotask(() => {
            throw m;
          });
        throw d;
      }
    } finally {
      t[nn] = e, delete t.currentTarget, qe(u), rt(v);
    }
  }
}
const Ja = (
  // We gotta write it like this because after downleveling the pure comment may end up in the wrong location
  globalThis?.window?.trustedTypes && /* @__PURE__ */ globalThis.window.trustedTypes.createPolicy("svelte-trusted-html", {
    /** @param {string} html */
    createHTML: (t) => t
  })
);
function Za(t) {
  return (
    /** @type {string} */
    Ja?.createHTML(t) ?? t
  );
}
function $a(t) {
  var e = ui("template");
  return e.innerHTML = Za(t.replaceAll("<!>", "<!---->")), e.content;
}
function Yt(t, e) {
  var n = (
    /** @type {Effect} */
    F
  );
  n.nodes === null && (n.nodes = { start: t, end: e, a: null, t: null });
}
// @__NO_SIDE_EFFECTS__
function L(t, e) {
  var n = (e & fa) !== 0, r = (e & da) !== 0, i, a = !t.startsWith("<!>");
  return () => {
    i === void 0 && (i = $a(a ? t : "<!>" + t), n || (i = /** @type {TemplateNode} */
    /* @__PURE__ */ pt(i)));
    var l = (
      /** @type {TemplateNode} */
      r || li ? document.importNode(i, !0) : i.cloneNode(!0)
    );
    if (n) {
      var o = (
        /** @type {TemplateNode} */
        /* @__PURE__ */ pt(l)
      ), c = (
        /** @type {TemplateNode} */
        l.lastChild
      );
      Yt(o, c);
    } else
      Yt(l, l);
    return l;
  };
}
function ee(t = "") {
  {
    var e = wt(t + "");
    return Yt(e, e), e;
  }
}
function ne() {
  var t = document.createDocumentFragment(), e = document.createComment(""), n = wt();
  return t.append(e, n), Yt(e, n), t;
}
function k(t, e) {
  t !== null && t.before(
    /** @type {Node} */
    e
  );
}
function P(t, e) {
  var n = e == null ? "" : typeof e == "object" ? `${e}` : e;
  n !== /** @type {any} */
  (t[$n] ??= t.nodeValue) && (t[$n] = n, t.nodeValue = `${n}`);
}
function es(t, e) {
  return ts(t, e);
}
const pn = /* @__PURE__ */ new Map();
function ts(t, { target: e, anchor: n, props: r = {}, events: i, context: a, intro: l = !0, transformError: o }) {
  Ha();
  var c = void 0, f = ja(() => {
    var u = n ?? e.appendChild(wt());
    Ta(
      /** @type {TemplateNode} */
      u,
      {
        pending: () => {
        }
      },
      (_) => {
        W({});
        var g = (
          /** @type {ComponentContext} */
          _e
        );
        a && (g.c = a), i && (r.$$events = i), c = t(_, r) || {}, X();
      },
      o
    );
    var v = /* @__PURE__ */ new Set(), d = (_) => {
      for (var g = 0; g < _.length; g++) {
        var m = _[g];
        if (!v.has(m)) {
          v.add(m);
          var h = Qa(m);
          for (const b of [e, document]) {
            var p = pn.get(b);
            p === void 0 && (p = /* @__PURE__ */ new Map(), pn.set(b, p));
            var y = p.get(m);
            y === void 0 ? (b.addEventListener(m, Tr, { passive: h }), p.set(m, 1)) : p.set(m, y + 1);
          }
        }
      }
    };
    return d(zn(Ti)), nr.add(d), () => {
      for (var _ of v)
        for (const h of [e, document]) {
          var g = (
            /** @type {Map<string, number>} */
            pn.get(h)
          ), m = (
            /** @type {number} */
            g.get(_)
          );
          --m == 0 ? (h.removeEventListener(_, Tr), g.delete(_), g.size === 0 && pn.delete(h)) : g.set(_, m);
        }
      nr.delete(d), u !== n && u.parentNode?.removeChild(u);
    };
  });
  return rr.set(c, f), c;
}
let rr = /* @__PURE__ */ new WeakMap();
function ns(t, e) {
  const n = rr.get(t);
  return n ? (rr.delete(t), n(e)) : Promise.resolve();
}
class Ci {
  /** @type {TemplateNode} */
  anchor;
  /** @type {Map<Batch, Key>} */
  #e = /* @__PURE__ */ new Map();
  /**
   * Map of keys to effects that are currently rendered in the DOM.
   * These effects are visible and actively part of the document tree.
   * Example:
   * ```
   * {#if condition}
   * 	foo
   * {:else}
   * 	bar
   * {/if}
   * ```
   * Can result in the entries `true->Effect` and `false->Effect`
   * @type {Map<Key, Effect>}
   */
  #a = /* @__PURE__ */ new Map();
  /**
   * Similar to #onscreen with respect to the keys, but contains branches that are not yet
   * in the DOM, because their insertion is deferred.
   * @type {Map<Key, Branch>}
   */
  #t = /* @__PURE__ */ new Map();
  /**
   * Keys of effects that are currently outroing
   * @type {Set<Key>}
   */
  #o = /* @__PURE__ */ new Set();
  /**
   * Whether to pause (i.e. outro) on change, or destroy immediately.
   * This is necessary for `<svelte:element>`
   */
  #r = !0;
  /**
   * @param {TemplateNode} anchor
   * @param {boolean} transition
   */
  constructor(e, n = !0) {
    this.anchor = e, this.#r = n;
  }
  /**
   * @param {Batch} batch
   */
  #s = (e) => {
    if (this.#e.has(e)) {
      var n = (
        /** @type {Key} */
        this.#e.get(e)
      ), r = this.#a.get(n);
      if (r)
        Cn(r), this.#o.delete(n);
      else {
        var i = this.#t.get(n);
        i && (Cn(i.effect), this.#a.set(n, i.effect), this.#t.delete(n), i.fragment.lastChild.remove(), this.anchor.before(i.fragment), r = i.effect);
      }
      for (const [a, l] of this.#e) {
        if (this.#e.delete(a), a === e)
          break;
        const o = this.#t.get(l);
        o && (Ce(o.effect), this.#t.delete(l));
      }
      for (const [a, l] of this.#a) {
        if (a === n || this.#o.has(a)) continue;
        const o = () => {
          if (Array.from(this.#e.values()).includes(a)) {
            var f = document.createDocumentFragment();
            gr(l, f), f.append(wt()), this.#t.set(a, { effect: l, fragment: f });
          } else
            Ce(l);
          this.#o.delete(a), this.#a.delete(a);
        };
        this.#r || !r ? (this.#o.add(a), Pt(l, o, !1)) : o();
      }
    }
  };
  /**
   * @param {Batch} batch
   */
  #n = (e) => {
    this.#e.delete(e);
    const n = Array.from(this.#e.values());
    for (const [r, i] of this.#t)
      n.includes(r) || (Ce(i.effect), this.#t.delete(r));
  };
  /**
   *
   * @param {any} key
   * @param {null | ((target: TemplateNode) => void)} fn
   */
  ensure(e, n) {
    var r = (
      /** @type {Batch} */
      q
    );
    n && !this.#a.has(e) && !this.#t.has(e) && this.#a.set(
      e,
      Ue(() => n(this.anchor))
    ), this.#e.set(r, e), this.#s(r);
  }
}
function H(t, e, n = !1) {
  var r = new Ci(t), i = n ? Mt : 0;
  function a(l, o) {
    r.ensure(l, o);
  }
  Nn(() => {
    var l = !1;
    e((o, c = 0) => {
      l = !0, a(c, o);
    }), l || a(-1, null);
  }, i);
}
function Be(t, e) {
  return e;
}
function rs(t, e, n) {
  for (var r = [], i = e.length, a, l = e.length, o = 0; o < i; o++) {
    let v = e[o];
    Pt(
      v,
      () => {
        if (a) {
          if (a.pending.delete(v), a.done.add(v), a.pending.size === 0) {
            var d = (
              /** @type {Set<EachOutroGroup>} */
              t.outrogroups
            );
            ir(t, zn(a.done)), d.delete(a), d.size === 0 && (t.outrogroups = null);
          }
        } else
          l -= 1;
      },
      !1
    );
  }
  if (l === 0) {
    var c = r.length === 0 && n !== null && t.pending.size === 0;
    if (c) {
      var f = (
        /** @type {Element} */
        n
      ), u = (
        /** @type {Element} */
        f.parentNode
      );
      Ia(u), u.append(f), t.items.clear();
    }
    ir(t, e, !c);
  } else
    a = {
      pending: new Set(e),
      done: /* @__PURE__ */ new Set()
    }, (t.outrogroups ??= /* @__PURE__ */ new Set()).add(a);
}
function ir(t, e, n = !0) {
  var r;
  if (t.pending.size > 0) {
    r = /* @__PURE__ */ new Set();
    for (const l of t.pending.values())
      for (const o of l)
        r.add(
          /** @type {EachItem} */
          t.items.get(o).e
        );
  }
  for (var i = 0; i < e.length; i++) {
    var a = e[i];
    if (r?.has(a)) {
      a.f |= $e;
      const l = document.createDocumentFragment();
      gr(a, l);
    } else
      Ce(e[i], n);
  }
}
var Cr;
function Re(t, e, n, r, i, a = null) {
  var l = t, o = /* @__PURE__ */ new Map(), c = (e & jr) !== 0;
  if (c) {
    var f = (
      /** @type {Element} */
      t
    );
    l = f.appendChild(wt());
  }
  var u = null, v = /* @__PURE__ */ $r(() => {
    var y = n();
    return (
      /** @type {V[]} */
      Dr(y) ? y : y == null ? [] : zn(y)
    );
  }), d, _ = /* @__PURE__ */ new Map(), g = !0;
  function m(y) {
    (p.effect.f & Me) === 0 && (p.pending.delete(y), p.fallback = u, is(p, d, l, e, r), u !== null && (d.length === 0 ? (u.f & $e) === 0 ? Cn(u) : (u.f ^= $e, rn(u, null, l)) : Pt(u, () => {
      u = null;
    })));
  }
  var h = Nn(() => {
    d = /** @type {V[]} */
    s(v);
    for (var y = d.length, b = /* @__PURE__ */ new Set(), S = (
      /** @type {Batch} */
      q
    ), N = 0; N < y; N += 1) {
      var M = d[N], O = r(M, N), B = g ? null : o.get(O);
      B ? (B.v && Ut(B.v, M), B.i && Ut(B.i, N)) : (B = as(
        o,
        g ? l : Cr ??= wt(),
        M,
        O,
        N,
        i,
        e,
        n
      ), g || (B.e.f |= $e), o.set(O, B)), b.add(O);
    }
    y === 0 && a && !u && (g ? u = Ue(() => a(l)) : (u = Ue(() => a(Cr ??= wt())), u.f |= $e)), y > b.size && Vi(), g || (_.set(S, b), m(S)), s(v);
  }), p = { effect: h, items: o, pending: _, outrogroups: null, fallback: u };
  g = !1;
}
function en(t) {
  for (; t !== null && (t.f & Ie) === 0; )
    t = t.next;
  return t;
}
function is(t, e, n, r, i) {
  var a = (r & aa) !== 0, l = e.length, o = t.items, c = en(t.effect.first), f, u = null, v, d = [], _ = [], g, m, h, p;
  if (a)
    for (p = 0; p < l; p += 1)
      g = e[p], m = i(g, p), h = /** @type {EachItem} */
      o.get(m).e, (h.f & $e) === 0 && (h.nodes?.a?.measure(), (v ??= /* @__PURE__ */ new Set()).add(h));
  for (p = 0; p < l; p += 1) {
    if (g = e[p], m = i(g, p), h = /** @type {EachItem} */
    o.get(m).e, t.outrogroups !== null)
      for (const I of t.outrogroups)
        I.pending.delete(h), I.done.delete(h);
    if ((h.f & ge) !== 0 && (Cn(h), a && (h.nodes?.a?.unfix(), (v ??= /* @__PURE__ */ new Set()).delete(h))), (h.f & $e) !== 0)
      if (h.f ^= $e, h === c)
        rn(h, null, n);
      else {
        var y = u ? u.next : c;
        h === t.effect.last && (t.effect.last = h.prev), h.prev && (h.prev.next = h.next), h.next && (h.next.prev = h.prev), vt(t, u, h), vt(t, h, y), rn(h, y, n), u = h, d = [], _ = [], c = en(u.next);
        continue;
      }
    if (h !== c) {
      if (f !== void 0 && f.has(h)) {
        if (d.length < _.length) {
          var b = _[0], S;
          u = b.prev;
          var N = d[0], M = d[d.length - 1];
          for (S = 0; S < d.length; S += 1)
            rn(d[S], b, n);
          for (S = 0; S < _.length; S += 1)
            f.delete(_[S]);
          vt(t, N.prev, M.next), vt(t, u, N), vt(t, M, b), c = b, u = M, p -= 1, d = [], _ = [];
        } else
          f.delete(h), rn(h, c, n), vt(t, h.prev, h.next), vt(t, h, u === null ? t.effect.first : u.next), vt(t, u, h), u = h;
        continue;
      }
      for (d = [], _ = []; c !== null && c !== h; )
        (f ??= /* @__PURE__ */ new Set()).add(c), _.push(c), c = en(c.next);
      if (c === null)
        continue;
    }
    (h.f & $e) === 0 && d.push(h), u = h, c = en(h.next);
  }
  if (t.outrogroups !== null) {
    for (const I of t.outrogroups)
      I.pending.size === 0 && (ir(t, zn(I.done)), t.outrogroups?.delete(I));
    t.outrogroups.size === 0 && (t.outrogroups = null);
  }
  if (c !== null || f !== void 0) {
    var O = [];
    if (f !== void 0)
      for (h of f)
        (h.f & ge) === 0 && O.push(h);
    for (; c !== null; )
      (c.f & ge) === 0 && c !== t.fallback && O.push(c), c = en(c.next);
    var B = O.length;
    if (B > 0) {
      var Q = (r & jr) !== 0 && l === 0 ? n : null;
      if (a) {
        for (p = 0; p < B; p += 1)
          O[p].nodes?.a?.measure();
        for (p = 0; p < B; p += 1)
          O[p].nodes?.a?.fix();
      }
      rs(t, O, Q);
    }
  }
  a && et(() => {
    if (v !== void 0)
      for (h of v)
        h.nodes?.a?.apply();
  });
}
function as(t, e, n, r, i, a, l, o) {
  var c = (l & ra) !== 0 ? (l & sa) === 0 ? /* @__PURE__ */ Ba(n, !1, !1) : Nt(n) : null, f = (l & ia) !== 0 ? Nt(i) : null;
  return {
    v: c,
    i: f,
    e: Ue(() => (a(e, c ?? n, f ?? i, o), () => {
      t.delete(r);
    }))
  };
}
function rn(t, e, n) {
  if (t.nodes)
    for (var r = t.nodes.start, i = t.nodes.end, a = e && (e.f & $e) === 0 ? (
      /** @type {EffectNodes} */
      e.nodes.start
    ) : n; r !== null; ) {
      var l = (
        /** @type {TemplateNode} */
        /* @__PURE__ */ vn(r)
      );
      if (a.before(r), r === i)
        return;
      r = l;
    }
}
function vt(t, e, n) {
  e === null ? t.effect.first = n : e.next = n, n === null ? t.effect.last = e : n.prev = e;
}
function ss(t, e, n = !1, r = !1, i = !1, a = !1) {
  var l = t, o = "";
  if (n)
    var c = (
      /** @type {Element} */
      t
    );
  z(() => {
    var f = (
      /** @type {Effect} */
      F
    );
    if (o !== (o = e() ?? "")) {
      if (n) {
        f.nodes = null, c.innerHTML = /** @type {string} */
        o, o !== "" && Yt(
          /** @type {TemplateNode} */
          /* @__PURE__ */ pt(c),
          /** @type {TemplateNode} */
          c.lastChild
        );
        return;
      }
      if (f.nodes !== null && (hi(
        f.nodes.start,
        /** @type {TemplateNode} */
        f.nodes.end
      ), f.nodes = null), o !== "") {
        var u = r ? va : i ? ha : void 0, v = (
          /** @type {HTMLTemplateElement | SVGElement | MathMLElement} */
          ui(r ? "svg" : i ? "math" : "template", u)
        );
        v.innerHTML = /** @type {any} */
        o;
        var d = r || i ? v : (
          /** @type {HTMLTemplateElement} */
          v.content
        );
        if (Yt(
          /** @type {TemplateNode} */
          /* @__PURE__ */ pt(d),
          /** @type {TemplateNode} */
          d.lastChild
        ), r || i)
          for (; /* @__PURE__ */ pt(d); )
            l.before(
              /** @type {TemplateNode} */
              /* @__PURE__ */ pt(d)
            );
        else
          l.before(d);
      }
    }
  });
}
function An(t, e, ...n) {
  var r = new Ci(t);
  Nn(() => {
    const i = e() ?? null;
    r.ensure(i, i && ((a) => i(a, ...n)));
  }, Mt);
}
const Ar = [...` 	
\r\f \v\uFEFF`];
function ls(t, e, n) {
  var r = t == null ? "" : "" + t;
  if (n) {
    for (var i of Object.keys(n))
      if (n[i])
        r = r ? r + " " + i : i;
      else if (r.length)
        for (var a = i.length, l = 0; (l = r.indexOf(i, l)) >= 0; ) {
          var o = l + a;
          (l === 0 || Ar.includes(r[l - 1])) && (o === r.length || Ar.includes(r[o])) ? r = (l === 0 ? "" : r.substring(0, l)) + r.substring(o + 1) : l = o;
        }
  }
  return r === "" ? null : r;
}
function os(t, e) {
  return t == null ? null : String(t);
}
function Ot(t, e, n, r, i, a) {
  var l = (
    /** @type {any} */
    t[Jn]
  );
  if (l !== n || l === void 0) {
    var o = ls(n, r, a);
    o == null ? t.removeAttribute("class") : t.className = o, t[Jn] = n;
  } else if (a && i !== a)
    for (var c in a) {
      var f = !!a[c];
      (i == null || f !== !!i[c]) && t.classList.toggle(c, f);
    }
  return a;
}
function cs(t, e, n, r) {
  var i = (
    /** @type {any} */
    t[Zn]
  );
  if (i !== e) {
    var a = os(e);
    a == null ? t.removeAttribute("style") : t.style.cssText = a, t[Zn] = e;
  }
  return r;
}
const us = /* @__PURE__ */ Symbol("is custom element"), fs = /* @__PURE__ */ Symbol("is html"), ds = Gi ? "progress" : "PROGRESS";
function vs(t, e) {
  var n = Ai(t);
  n.value === (n.value = // treat null and undefined the same for the initial value
  e ?? void 0) || // @ts-expect-error
  // `progress` elements always need their value set when it's `0`
  t.value === e && (e !== 0 || t.nodeName !== ds) || (t.value = e ?? "");
}
function Ae(t, e, n, r) {
  var i = Ai(t);
  i[e] !== (i[e] = n) && (e === "loading" && (t[Ui] = n), n == null ? t.removeAttribute(e) : typeof n != "string" && hs(t).includes(e) ? t[e] = n : t.setAttribute(e, n));
}
function Ai(t) {
  return (
    /** @type {Record<string | symbol, unknown>} **/
    /** @type {any} */
    t[Fr] ??= {
      [us]: t.nodeName.includes("-"),
      [fs]: t.namespaceURI === Kr
    }
  );
}
var Sr = /* @__PURE__ */ new Map();
function hs(t) {
  var e = t.getAttribute("is") || t.nodeName, n = Sr.get(e);
  if (n) return n;
  Sr.set(e, n = []);
  for (var r, i = t, a = Element.prototype; a !== i; ) {
    r = Di(i);
    for (var l in r)
      r[l].set && // better safe than sorry, we don't want spread attributes to mess with HTML content
      l !== "innerHTML" && l !== "textContent" && l !== "innerText" && n.push(l);
    i = Hr(i);
  }
  return n;
}
function gs(t, e, n = e) {
  var r = /* @__PURE__ */ new WeakSet();
  Jr(t, "input", async (i) => {
    var a = i ? t.defaultValue : t.value;
    if (a = Gn(t) ? Yn(a) : a, n(a), q !== null && r.add(q), await Wa(), a !== (a = e())) {
      var l = t.selectionStart, o = t.selectionEnd, c = t.value.length;
      if (t.value = a ?? "", o !== null) {
        var f = t.value.length;
        l === o && o === c && f > c ? (t.selectionStart = f, t.selectionEnd = f) : (t.selectionStart = l, t.selectionEnd = Math.min(o, f));
      }
    }
  }), // If we are hydrating and the value has since changed,
  // then use the updated value from the input instead.
  // If defaultValue is set, then value == defaultValue
  // TODO Svelte 6: remove input.value check and set to empty string?
  On(e) == null && t.value && (n(Gn(t) ? Yn(t.value) : t.value), q !== null && r.add(q)), Ln(() => {
    var i = e();
    if (t === document.activeElement) {
      var a = (
        /** @type {Batch} */
        q
      );
      if (r.has(a))
        return;
    }
    Gn(t) && i === Yn(t.value) || t.type === "date" && !i && !t.value || i !== t.value && (t.value = i ?? "");
  });
}
const Un = /* @__PURE__ */ new Set();
function Pr(t, e, n, r, i = r) {
  var a = n.getAttribute("type") === "checkbox", l = t;
  if (e !== null)
    for (var o of e)
      l = l[o] ??= [];
  l.push(n), Jr(
    n,
    "change",
    () => {
      var c = n.__value;
      a && (c = _s(l, c, n.checked)), i(c);
    },
    // TODO better default value handling
    () => i(a ? [] : null)
  ), Ln(() => {
    var c = r();
    a ? (c = c || [], n.checked = c.includes(n.__value)) : n.checked = Da(n.__value, c);
  }), fi(() => {
    var c = l.indexOf(n);
    c !== -1 && l.splice(c, 1);
  }), Un.has(l) || (Un.add(l), et(() => {
    l.sort((c, f) => c.compareDocumentPosition(f) === 4 ? -1 : 1), Un.delete(l);
  })), et(() => {
  });
}
function _s(t, e, n) {
  for (var r = /* @__PURE__ */ new Set(), i = 0; i < t.length; i += 1)
    t[i].checked && r.add(t[i].__value);
  return n || r.delete(e), Array.from(r);
}
function Gn(t) {
  var e = t.type;
  return e === "number" || e === "range";
}
function Yn(t) {
  return t === "" ? null : +t;
}
function Vn(t, e) {
  return t === e || t?.[St] === e;
}
function Si(t = {}, e, n, r) {
  var i = (
    /** @type {ComponentContext} */
    _e.r
  ), a = (
    /** @type {Effect} */
    F
  );
  return Ka(() => {
    var l, o;
    return Ln(() => {
      l = o, o = [], On(() => {
        Vn(n(...o), t) || (e(t, ...o), l && Vn(n(...l), t) && e(null, ...l));
      });
    }), () => {
      let c = a;
      for (; c !== i && c.parent !== null && c.parent.f & Qn; )
        c = c.parent;
      const f = () => {
        o && Vn(n(...o), t) && e(null, ...o);
      }, u = c.teardown;
      c.teardown = () => {
        f(), u?.();
      };
    };
  }), t;
}
function ue(t, e, n, r) {
  var i = !0, a = (n & ca) !== 0, l = (n & ua) !== 0, o = (
    /** @type {V} */
    r
  ), c = !0, f = (
    /** @type {Derived<V> | undefined} */
    void 0
  ), u = () => l && i ? (f ??= /* @__PURE__ */ cn(
    /** @type {() => V} */
    r
  ), s(f)) : (c && (c = !1, o = l ? On(
    /** @type {() => V} */
    r
  ) : (
    /** @type {V} */
    r
  )), o);
  let v;
  if (a) {
    var d = St in t || Ki in t;
    v = Ht(t, e)?.set ?? (d && e in t ? (S) => t[e] = S : void 0);
  }
  var _, g = !1;
  a ? [_, g] = ba(() => (
    /** @type {V} */
    t[e]
  )) : _ = /** @type {V} */
  t[e], _ === void 0 && r !== void 0 && (_ = u(), v && (Zi(), v(_)));
  var m;
  if (m = () => {
    var S = (
      /** @type {V} */
      t[e]
    );
    return S === void 0 ? u() : (c = !0, S);
  }, (n & oa) === 0)
    return m;
  if (v) {
    var h = t.$$legacy;
    return (
      /** @type {() => V} */
      (function(S, N) {
        return arguments.length > 0 ? ((!N || h || g) && v(N ? m() : S), S) : m();
      })
    );
  }
  var p = !1, y = ((n & la) !== 0 ? cn : $r)(() => (p = !1, m()));
  a && s(y);
  var b = (
    /** @type {Effect} */
    F
  );
  return (
    /** @type {() => V} */
    (function(S, N) {
      if (arguments.length > 0) {
        const M = N ? s(y) : a ? Te(S) : S;
        return A(y, M), p = !0, o !== void 0 && (o = M), S;
      }
      return ot && p || (b.f & Me) !== 0 ? y.v : s(y);
    })
  );
}
const ps = "5";
typeof window < "u" && ((window.__svelte ??= {}).v ??= /* @__PURE__ */ new Set()).add(ps);
class ms {
  #e;
  get view() {
    return s(this.#e);
  }
  set view(e) {
    A(this.#e, e, !0);
  }
  #a;
  get active() {
    return s(this.#a);
  }
  set active(e) {
    A(this.#a, e, !0);
  }
  #t;
  get minimal() {
    return s(this.#t);
  }
  set minimal(e) {
    A(this.#t, e, !0);
  }
  #o;
  get loginContext() {
    return s(this.#o);
  }
  set loginContext(e) {
    A(this.#o, e, !0);
  }
  #r;
  get appName() {
    return s(this.#r);
  }
  set appName(e) {
    A(this.#r, e, !0);
  }
  #s;
  get transactStage() {
    return s(this.#s);
  }
  set transactStage(e) {
    A(this.#s, e, !0);
  }
  #n;
  get transactStartTime() {
    return s(this.#n);
  }
  set transactStartTime(e) {
    A(this.#n, e, !0);
  }
  #l;
  get promptTitle() {
    return s(this.#l);
  }
  set promptTitle(e) {
    A(this.#l, e, !0);
  }
  #i;
  get promptBody() {
    return s(this.#i);
  }
  set promptBody(e) {
    A(this.#i, e, !0);
  }
  #v;
  get promptElements() {
    return s(this.#v);
  }
  set promptElements(e) {
    A(this.#v, e, !0);
  }
  #c;
  get errorMessage() {
    return s(this.#c);
  }
  set errorMessage(e) {
    A(this.#c, e, !0);
  }
  #u;
  get errorDetails() {
    return s(this.#u);
  }
  set errorDetails(e) {
    A(this.#u, e, !0);
  }
  #d;
  get accountName() {
    return s(this.#d);
  }
  set accountName(e) {
    A(this.#d, e, !0);
  }
  #h;
  get chainName() {
    return s(this.#h);
  }
  set chainName(e) {
    A(this.#h, e, !0);
  }
  #f;
  get chainLogo() {
    return s(this.#f);
  }
  set chainLogo(e) {
    A(this.#f, e, !0);
  }
  #_;
  get skAppName() {
    return s(this.#_);
  }
  set skAppName(e) {
    A(this.#_, e, !0);
  }
  #g;
  get skWhitelist() {
    return s(this.#g);
  }
  set skWhitelist(e) {
    A(this.#g, e, !0);
  }
  #k;
  get skExistingKeyCount() {
    return s(this.#k);
  }
  set skExistingKeyCount(e) {
    A(this.#k, e, !0);
  }
  #p;
  get skAdded() {
    return s(this.#p);
  }
  set skAdded(e) {
    A(this.#p, e, !0);
  }
  #b;
  get skRemoved() {
    return s(this.#b);
  }
  set skRemoved(e) {
    A(this.#b, e, !0);
  }
  constructor() {
    this.#e = /* @__PURE__ */ R("idle"), this.#a = /* @__PURE__ */ R(!1), this.#t = /* @__PURE__ */ R(!1), this.#o = /* @__PURE__ */ R(null), this.#r = /* @__PURE__ */ R(""), this.#s = /* @__PURE__ */ R("preparing"), this.#n = /* @__PURE__ */ R(0), this.#l = /* @__PURE__ */ R(""), this.#i = /* @__PURE__ */ R(""), this.#v = /* @__PURE__ */ R(Te([])), this.#c = /* @__PURE__ */ R(""), this.#u = /* @__PURE__ */ R(""), this.#d = /* @__PURE__ */ R(""), this.#h = /* @__PURE__ */ R(""), this.#f = /* @__PURE__ */ R(""), this.#_ = /* @__PURE__ */ R(""), this.#g = /* @__PURE__ */ R(Te([])), this.#k = /* @__PURE__ */ R(0), this.#p = /* @__PURE__ */ R(Te([])), this.#b = /* @__PURE__ */ R(Te([]));
  }
  reset() {
    this.view = "idle", this.active = !1, this.loginContext = null, this.transactStage = "preparing", this.transactStartTime = 0, this.promptTitle = "", this.promptBody = "", this.promptElements = [], this.errorMessage = "", this.errorDetails = "", this.skAppName = "", this.skWhitelist = [], this.skExistingKeyCount = 0, this.skAdded = [], this.skRemoved = [];
  }
}
const x = new ms();
var ws = /* @__PURE__ */ L('<div class="drag-handle svelte-133dbco"><span class="svelte-133dbco"></span></div>'), ks = /* @__PURE__ */ L('<div role="dialog" aria-modal="true" aria-labelledby="web-ui-modal-title" tabindex="-1"><div tabindex="-1"><!> <!></div></div>');
function bs(t, e) {
  W(e, !0);
  let n = ue(e, "closeOnOverlayClick", 3, !0), r = ue(e, "closeOnEscape", 3, !0), i = /* @__PURE__ */ R(!1), a = /* @__PURE__ */ R(!1), l = /* @__PURE__ */ R(void 0);
  const o = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  function c() {
    A(i, window.innerWidth < 640);
  }
  function f() {
    return s(l) ? Array.from(s(l).querySelectorAll(o)) : [];
  }
  He(() => (c(), window.addEventListener("resize", c), () => window.removeEventListener("resize", c))), He(() => {
    x.active ? requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        A(a, !0);
      });
    }) : A(a, !1);
  }), He(() => {
    if (!x.active) return;
    const g = document.activeElement;
    requestAnimationFrame(() => {
      s(l)?.focus();
    });
    const m = (h) => {
      if (h.key === "Escape" && r()) {
        h.preventDefault(), e.onclose?.();
        return;
      }
      if (h.key !== "Tab") return;
      const p = f();
      if (p.length === 0) {
        h.preventDefault();
        return;
      }
      const b = s(l)?.getRootNode()?.activeElement, S = p[0], N = p[p.length - 1];
      h.shiftKey && (b === S || !s(l)?.contains(b)) ? (h.preventDefault(), N.focus()) : !h.shiftKey && (b === N || !s(l)?.contains(b)) && (h.preventDefault(), S.focus());
    };
    return window.addEventListener("keydown", m, !0), () => {
      window.removeEventListener("keydown", m, !0), g?.focus?.();
    };
  });
  function u(g) {
    n() && g.target === g.currentTarget && e.onclose?.();
  }
  var v = ne(), d = K(v);
  {
    var _ = (g) => {
      var m = ks();
      let h;
      var p = w(m);
      let y;
      var b = w(p);
      {
        var S = (M) => {
          var O = ws();
          k(M, O);
        };
        H(b, (M) => {
          s(i) && M(S);
        });
      }
      var N = T(b, 2);
      An(N, () => e.children), Si(p, (M) => A(l, M), () => s(l)), z(() => {
        h = Ot(m, 1, "web-ui-overlay svelte-133dbco", null, h, { visible: s(a), mobile: s(i) }), y = Ot(p, 1, "web-ui-modal svelte-133dbco", null, y, { mobile: s(i) });
      }), ct("click", m, u), k(g, m);
    };
    H(d, (g) => {
      x.active && g(_);
    });
  }
  k(t, v), X();
}
Bt(["click"]);
let ys = ["Error", "Hide technical details", "Show technical details", "Close", "Retry", ["Connect to ", 0], "Connect Wallet", "Select a wallet to continue", ["Wallet ", 0], ["Requested by ", 0], "Waiting for response…", "Cancel", "Confirm", "Permission Request", ["already has permissions on ", [0], "."], "Add this device", "All devices will continue to work", "Only use this device", "Other devices will stop working", ["This only affects ", 0, ". Your wallet still works everywhere."], "Continue", ["Allow ", 0, " to act for you?"], "Allow this app to act for you?", "Can move tokens from your account", [0, " can run these actions without asking your wallet each time, until you remove it."], [0, " permission", 1, " on ", 2, " contract", 3], "Hide details", "Show details", ["If approved, ", 0, " can perform these actions without wallet approval:"], "Full access, including future actions", ["Full access to ", 0, ", including future actions"], "Any other action will still require wallet approval.", "What's a session key?", "A session key lets this app sign the actions listed above for you, using a key stored in this browser that you can remove at any time. It can't sign anything else.", [0, " works without this. You'll just approve each action individually instead."], "Not Now", "Allow", "has active permissions on this device.", "Your wallet will ask you to sign a transaction to remove this permission.", "Log Out Only", "Remove and Log Out", ["All actions (", 0, ")"], "needs updated permissions.", "New permissions:", "Permissions no longer needed:", "Update", "Preparing transaction", "Awaiting signature", "Signed", "Broadcasting", "Confirming", "Transaction complete", "Processing", "Transaction", ["Confirmed on ", 0], "Network", "Account", "Elapsed", [0, "s"], "Done", "Decline", "Accept", "QR code unavailable. Use the link below to continue.", "Open Link", "Back", "Select a blockchain", "Select an account", "Enter your account", ["Choose the blockchain to use with ", 0], "These accounts can be signed for by this wallet", "Continue in your wallet", "Waiting for your wallet…", "Loading wallets…", "Account name", "Permission", "Looking up your accounts…", ["No accounts on ", 0, " use the key this wallet provided. Go back to pick a different wallet."], "Select a permission", "Name the account this wallet signs for", ["Choose the permission on ", 0, " to sign with"], "Account names use the letters a–z, the digits 1–5, and periods, up to 12 characters.", ["Looking up ", 0, "…"], ["The permissions on ", 0, " can't be listed without a blockchain to read them from. Name the permission you sign with."], "Permission names use the letters a–z, the digits 1–5, and periods, up to 12 characters.", ["Under ", 0], ["No account named ", 0, " exists on ", 1, ". Check the spelling and try again."], ["Could not reach ", 0, ", so the name ", 1, " was not checked. Try again."], "Something went wrong.", "The request was cancelled.", "Couldn't reach the network. Check your connection and try again.", "The transaction expired before it completed. Please try again.", "Your account needs more network resources (CPU, NET, or RAM) to complete this.", "Insufficient balance to complete this transaction.", "The transaction could not be completed."];
const pe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  c: ys
}, Symbol.toStringTag, { value: "Module" }));
let xs = ["오류", "기술 세부 정보 숨기기", "기술 세부 정보 표시", "닫기", "다시 시도", [0, "에 연결"], "지갑 연결", "계속하려면 지갑을 선택하세요", ["지갑 ", 0], [0, "에서 요청함"], "응답 대기 중…", "취소", "확인", "권한 요청", ["이미 ", [0], "에 대한 권한이 있습니다."], "이 기기 추가", "모든 기기가 계속 작동합니다", "이 기기만 사용", "다른 기기는 작동을 멈춥니다", ["이는 ", 0, "에만 영향을 줍니다. 지갑은 계속 어디서나 작동합니다."], "계속", [0, "이(가) 대신 작업하도록 허용하시겠습니까?"], "이 앱이 대신 작업하도록 허용하시겠습니까?", "계정에서 토큰을 이동할 수 있음", [0, "은(는) 삭제할 때까지 매번 지갑에 요청하지 않고 이러한 작업을 실행할 수 있습니다."], ["권한 ", 0, "개", 1, ", 컨트랙트 ", 2, "개", 3], "세부 정보 숨기기", "세부 정보 표시", ["승인하면 ", 0, "이(가) 지갑 승인 없이 다음 작업을 수행할 수 있습니다:"], "향후 작업을 포함한 모든 권한", ["향후 작업을 포함한 ", 0, "에 대한 모든 권한"], "그 외의 작업은 계속 지갑 승인이 필요합니다.", "세션 키란 무엇인가요?", "세션 키를 사용하면 이 앱이 위에 나열된 작업을 대신 서명할 수 있습니다. 키는 이 브라우저에 저장되며 언제든지 삭제할 수 있습니다. 그 외의 작업에는 서명할 수 없습니다.", [0, " 없이도 사용할 수 있습니다. 대신 각 작업을 개별적으로 승인하면 됩니다."], "나중에", "허용", "이 기기에 활성 권한이 있습니다.", "지갑에서 이 권한을 제거하기 위한 트랜잭션 서명을 요청합니다.", "로그아웃만", "제거하고 로그아웃", ["모든 작업 (", 0, ")"], "업데이트된 권한이 필요합니다.", "새 권한:", "더 이상 필요하지 않은 권한:", "업데이트", "거래 준비 중", "서명 대기 중", "서명 완료", "브로드캐스트 중", "확인 중", "거래 완료", "처리 중", "거래", [0, "에서 확인됨"], "네트워크", "계정", "경과 시간", [0, "초"], "완료", "거절", "수락", "QR 코드를 사용할 수 없습니다. 계속하려면 아래 링크를 사용하세요.", "링크 열기", "뒤로", "블록체인 선택", "계정 선택", "계정을 입력하세요", [0, "에서 사용할 블록체인을 선택하세요"], "이 지갑으로 서명할 수 있는 계정입니다", "지갑에서 계속하세요", "지갑을 기다리는 중…", "지갑을 불러오는 중…", "계정 이름", "권한", "계정을 조회하는 중…", [0, "의 어떤 계정도 이 지갑이 제공한 키를 사용하지 않습니다. 돌아가서 다른 지갑을 선택하세요."], "권한 선택", "이 지갑이 서명할 계정 이름을 지정하세요", ["서명에 사용할 ", 0, "의 권한을 선택하세요"], "계정 이름은 a–z 문자, 1–5 숫자 및 마침표를 사용하며, 최대 12자입니다.", [0, " 조회 중…"], [0, "의 권한을 조회할 블록체인이 없으면 권한을 나열할 수 없습니다. 서명할 권한 이름을 입력하세요."], "권한 이름은 a–z 문자, 숫자 1–5 및 마침표를 사용하며 최대 12자까지 입력할 수 있습니다.", [0, " 하위"], [1, "에 ", 0, "이라는 계정이 없습니다. 철자를 확인하고 다시 시도하세요."], [0, "에 연결할 수 없어 ", 1, " 이름을 확인하지 못했습니다. 다시 시도하세요."], "문제가 발생했습니다.", "요청이 취소되었습니다.", "네트워크에 연결할 수 없습니다. 연결 상태를 확인한 후 다시 시도하세요.", "거래가 완료되기 전에 만료되었습니다. 다시 시도하세요.", "이 작업을 완료하려면 계정에 더 많은 네트워크 리소스(CPU, NET 또는 RAM)가 필요합니다.", "이 거래를 완료하기에 잔액이 부족합니다.", "거래를 완료할 수 없습니다."];
const me = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  c: xs
}, Symbol.toStringTag, { value: "Module" }));
let Es = ["错误", "隐藏技术详情", "显示技术详情", "关闭", "重试", ["连接到 ", 0], "连接钱包", "选择钱包以继续", ["钱包 ", 0], ["由 ", 0, " 请求"], "等待响应…", "取消", "确认", "权限请求", ["已在 ", [0], " 上拥有权限。"], "添加此设备", "所有设备将继续工作", "仅使用此设备", "其他设备将停止工作", ["这只会影响 ", 0, "。您的钱包仍可在任何地方使用。"], "继续", ["允许 ", 0, " 代您操作吗？"], "允许此应用代您操作吗？", "可以从您的账户转移代币", [0, " 可以执行这些操作，无需每次都请求您的钱包确认，直到您将其移除。"], ["在 ", 2, " 个合约上有 ", 0, " 项权限", 1, 3], "隐藏详情", "显示详情", ["如果批准，", 0, " 可以执行以下操作，无需钱包确认："], "完全访问权限，包括未来的操作", ["完全访问 ", 0, " 的权限，包括未来的操作"], "任何其他操作仍需要钱包确认。", "什么是会话密钥？", "会话密钥允许此应用使用存储在此浏览器中的密钥，代您签署上方列出的操作。您可以随时移除该密钥。它无法签署其他任何内容。", [0, " 不使用此功能也能运行。您只需改为逐一批准每项操作。"], "暂不", "允许", "在此设备上拥有有效权限。", "您的钱包会要求您签署一笔交易，以移除此权限。", "仅退出登录", "移除并退出登录", ["所有操作（", 0, "）"], "需要更新权限。", "新权限：", "不再需要的权限：", "更新", "正在准备交易", "等待签名", "已签名", "正在广播", "正在确认", "交易完成", "处理中", "交易", ["已在 ", 0, " 上确认"], "网络", "账户", "已用时", [0, "秒"], "完成", "拒绝", "接受", "二维码不可用。请使用下面的链接继续。", "打开链接", "返回", "选择区块链", "选择账户", "输入您的账户", ["选择要与 ", 0, " 一起使用的区块链"], "此钱包可以代表以下账户签名", "在您的钱包中继续", "正在等待您的钱包…", "正在加载钱包…", "账户名", "权限", "正在查找您的账户…", [0, " 上没有账户使用此钱包提供的密钥。返回以选择其他钱包。"], "选择权限", "命名此钱包代表其签名的账户", ["选择要代表 ", 0, " 签名的权限"], "账户名只能使用字母 a–z、数字 1–5 和句点，最多 12 个字符。", ["正在查找 ", 0, "…"], ["无法列出 ", 0, " 上的权限，因为没有可读取权限的区块链。请命名您用于签名的权限。"], "权限名称最多 12 个字符，可使用字母 a–z、数字 1–5 和句点。", ["位于 ", 0, " 下"], [1, " 上不存在名为 ", 0, " 的账户。请检查拼写后重试。"], ["无法访问 ", 0, "，因此未检查名称 ", 1, "。请重试。"], "出了点问题。", "请求已取消。", "无法连接到网络。请检查您的连接后重试。", "交易在完成前已过期。请重试。", "您的账户需要更多网络资源（CPU、NET 或 RAM）才能完成此操作。", "余额不足，无法完成此交易。", "无法完成此交易。"];
const we = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  c: Es
}, Symbol.toStringTag, { value: "Module" }));
let Ts = ["錯誤", "隱藏技術詳細資訊", "顯示技術詳細資訊", "關閉", "重試", ["連線至 ", 0], "連接錢包", "選擇錢包以繼續", ["錢包 ", 0], ["由 ", 0, " 請求"], "等待回應…", "取消", "確認", "權限請求", ["已在 ", [0], " 上擁有權限。"], "新增此裝置", "所有裝置將繼續運作", "僅使用此裝置", "其他裝置將停止運作", ["這只會影響 ", 0, "。您的錢包仍可在任何地方使用。"], "繼續", ["允許 ", 0, " 代您執行操作嗎？"], "允許此應用程式代您執行操作嗎？", "可以從您的帳戶轉移代幣", ["在您移除前，", 0, " 可以無需每次詢問您的錢包，執行這些操作。"], [0, " 個權限", 1, "，涉及 ", 2, " 份合約", 3], "隱藏詳細資訊", "顯示詳細資訊", ["如果獲准，", 0, " 可以在無需錢包核准的情況下執行這些操作："], "完整存取權，包括未來的操作", ["完整存取 ", 0, " 的權限，包括未來的操作"], "任何其他操作仍需要錢包核准。", "什麼是工作階段金鑰？", "工作階段金鑰可讓此應用程式使用儲存在此瀏覽器中的金鑰，代您簽署上方列出的操作；您隨時可以移除該金鑰。它無法簽署其他任何內容。", [0, " 不使用此功能也能運作。您只需改為逐一核准每個操作。"], "現在不要", "允許", "在此裝置上擁有有效權限。", "您的錢包會要求您簽署一筆交易，以移除此權限。", "僅登出", "移除並登出", ["所有操作（", 0, "）"], "需要更新權限。", "新權限：", "不再需要的權限：", "更新", "正在準備交易", "等待簽署", "已簽署", "廣播中", "確認中", "交易完成", "處理中", "交易", ["已在 ", 0, " 上確認"], "網路", "帳戶", "經過時間", [0, " 秒"], "完成", "拒絕", "接受", "QR 碼無法使用。請使用下方連結繼續。", "開啟連結", "返回", "選擇區塊鏈", "選擇帳戶", "輸入您的帳戶", ["選擇要與 ", 0, " 搭配使用的區塊鏈"], "此錢包可代表以下帳戶簽署", "在您的錢包中繼續", "正在等待您的錢包…", "正在載入錢包…", "帳戶名稱", "權限", "正在查詢您的帳戶…", ["沒有任何 ", 0, " 上的帳戶使用此錢包提供的金鑰。返回以選擇其他錢包。"], "選擇權限", "命名此錢包代表其簽署的帳戶", ["選擇要用於簽署 ", 0, " 的權限"], "帳戶名稱最多可使用 12 個字元，且只能包含字母 a–z、數字 1–5 和句點。", ["正在查詢 ", 0, "…"], ["若沒有可供讀取權限的區塊鏈，就無法列出 ", 0, " 上的權限。請輸入您要簽署的權限名稱。"], "權限名稱最多 12 個字元，僅可使用字母 a–z、數字 1–5 和句點。", ["位於 ", 0, " 下"], [1, " 上不存在名為 ", 0, " 的帳戶。請檢查拼字後再試一次。"], ["無法連線至 ", 0, "，因此未檢查名稱 ", 1, "。請再試一次。"], "發生錯誤。", "請求已取消。", "無法連線至網路。請檢查您的連線，然後再試一次。", "交易在完成前已逾時。請再試一次。", "您的帳戶需要更多網路資源（CPU、NET 或 RAM）才能完成此操作。", "餘額不足，無法完成此交易。", "無法完成交易。"];
const ke = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  c: Ts
}, Symbol.toStringTag, { value: "Module" }));
let Cs = ["Hata", "Teknik ayrıntıları gizle", "Teknik ayrıntıları göster", "Kapat", "Yeniden dene", [0, " ile bağlan"], "Cüzdanı Bağla", "Devam etmek için bir cüzdan seçin", ["Cüzdan ", 0], [0, " tarafından istendi"], "Yanıt bekleniyor…", "İptal", "Onayla", "İzin İsteği", [[0], " üzerinde zaten izinlere sahip."], "Bu cihazı ekle", "Tüm cihazlar çalışmaya devam edecek", "Yalnızca bu cihazı kullan", "Diğer cihazlar çalışmayı durduracak", ["Bu yalnızca ", 0, " uygulamasını etkiler. Cüzdanınız hâlâ her yerde çalışır."], "Devam et", [0, " sizin adınıza işlem yapabilsin mi?"], "Bu uygulama sizin adınıza işlem yapabilsin mi?", "Hesabınızdan token taşıyabilir", ["Siz kaldırana kadar ", 0, ", cüzdanınıza her seferinde sormadan bu işlemleri gerçekleştirebilir."], [0, " izin, ", 2, " sözleşme üzerinde", 1, 3], "Ayrıntıları gizle", "Ayrıntıları göster", ["Onaylanırsa ", 0, ", cüzdan onayı olmadan şu işlemleri gerçekleştirebilir:"], "Gelecekteki işlemler de dahil tam erişim", ["Gelecekteki işlemler de dahil ", 0, " için tam erişim"], "Diğer tüm işlemler için yine cüzdan onayı gerekir.", "Oturum anahtarı nedir?", "Oturum anahtarı, bu uygulamanın yukarıda listelenen işlemleri sizin adınıza gerçekleştirmesini sağlar. Anahtar, istediğiniz zaman kaldırabileceğiniz bu tarayıcıda saklanır. Başka hiçbir şeyi imzalayamaz.", [0, " olmadan da çalışır. Bunun yerine her işlemi ayrı ayrı onaylamanız gerekir."], "Şimdi Değil", "İzin Ver", "bu cihazda etkin izinlere sahip.", "Cüzdanınız bu izni kaldırmak için bir işlemi imzalamanızı isteyecek.", "Yalnızca Oturumu Kapat", "Kaldır ve Oturumu Kapat", ["Tüm işlemler (", 0, ")"], "güncellenmiş izinlere ihtiyaç duyuyor.", "Yeni izinler:", "Artık gerekmeyen izinler:", "Güncelle", "İşlem hazırlanıyor", "İmza bekleniyor", "İmzalandı", "Yayınlanıyor", "Onaylanıyor", "İşlem tamamlandı", "İşleniyor", "İşlem", [0, " üzerinde onaylandı"], "Ağ", "Hesap", "Geçen süre", [0, " sn"], "Tamam", "Reddet", "Kabul Et", "QR kodu kullanılamıyor. Devam etmek için aşağıdaki bağlantıyı kullanın.", "Bağlantıyı Aç", "Geri", "Bir blok zinciri seçin", "Bir hesap seçin", "Hesabınızı girin", [0, " ile kullanılacak blok zincirini seçin"], "Bu cüzdan tarafından imzalanabilecek hesaplar", "Cüzdanınızda devam edin", "Cüzdanınız bekleniyor…", "Cüzdanlar yükleniyor…", "Hesap adı", "İzin", "Hesaplarınız aranıyor…", [0, " üzerinde, bu cüzdanın sağladığı anahtarı kullanan hesap yok. Farklı bir cüzdan seçmek için geri dönün."], "Bir izin seçin", "Bu cüzdanın imzaladığı hesabı adlandırın", ["İmzalamak için ", 0, " üzerindeki izni seçin"], "Hesap adlarında a–z harfleri, 1–5 rakamları ve noktalar kullanılabilir; uzunluk en fazla 12 karakterdir.", [0, " aranıyor…"], [0, " üzerindeki izinler, okunacak bir blokzincir olmadan listelenemez. İmza attığınız iznin adını yazın."], "İzin adları a–z harflerini, 1–5 rakamlarını ve noktaları kullanır; en fazla 12 karakter olabilir.", [0, " altında"], [1, " üzerinde ", 0, " adlı bir hesap yok. Yazımı kontrol edip tekrar deneyin."], [0, " sunucusuna ulaşılamadığı için ", 1, " adı kontrol edilmedi. Tekrar deneyin."], "Bir şeyler ters gitti.", "İstek iptal edildi.", "Ağa ulaşılamadı. Bağlantınızı kontrol edip tekrar deneyin.", "İşlem tamamlanmadan önce zaman aşımına uğradı. Lütfen tekrar deneyin.", "Bunu tamamlamak için hesabınızın daha fazla ağ kaynağına (CPU, NET veya RAM) ihtiyacı var.", "Bu işlemi tamamlamak için yeterli bakiye yok.", "İşlem tamamlanamadı."];
const be = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  c: Cs
}, Symbol.toStringTag, { value: "Module" })), zr = "c";
let As = () => "";
function Mr(t, e = [], n = 1) {
  let r = "";
  for (let i = n; i < t.length; i++) {
    const a = t[i];
    typeof a == "string" ? r += a : r += e[a];
  }
  return r;
}
function Pi(t = { [zr]: [] }, e) {
  const n = t[zr], r = (a) => {
    const l = n[a];
    return typeof l == "string" ? [l] : Array.isArray(l) ? l : [As()];
  }, i = (a, l = []) => Mr(r(a), l, 0);
  return i._ = t, i.l = e, i.c = r, i.x = Mr, i.t = (a, l, o) => {
    const c = r(l), f = [], u = [];
    typeof c[0] == "number" && f.push("");
    for (const v of c) {
      if (typeof v == "string") {
        f.push(v);
        continue;
      }
      u.push(o?.[v]);
    }
    return typeof c.at(-1) == "number" && f.push(""), a(f, ...u);
  }, i.p = (a) => n[a] ?? [], i;
}
const zi = ["en", "ko", "zh-Hans", "zh-Hant", "tr"];
let ar = /* @__PURE__ */ R(Te(zi[0]));
function Ss(t) {
  A(ar, t, !0);
}
const Ps = (t) => Pi(t[s(ar)], s(ar)), ye = Ps;
function ze(t, e) {
  W(e, !0);
  const n = ue(e, "n", 3, !1);
  var r = ne(), i = K(r);
  Re(i, 17, () => e.x, Be, (a, l, o) => {
    var c = ne(), f = K(c);
    {
      var u = (_) => {
        var g = ee();
        z(() => P(g, s(l))), k(_, g);
      }, v = (_) => {
        var g = ne(), m = K(g);
        {
          var h = (p) => {
            var y = ee();
            z(() => P(y, e.a[s(l)])), k(p, y);
          };
          H(m, (p) => {
            (!n() || o > 0) && p(h);
          });
        }
        k(_, g);
      }, d = (_) => {
        const g = /* @__PURE__ */ E(() => e.t[s(l)[0]]);
        var m = ne(), h = K(m);
        {
          var p = (b) => {
            var S = ee("[i18n-404:tag]");
            k(b, S);
          }, y = (b) => {
            var S = ne(), N = K(S);
            An(N, () => s(g), () => s(l)), k(b, S);
          };
          H(h, (b) => {
            s(g) == null ? b(p) : b(y, -1);
          });
        }
        k(_, m);
      };
      H(f, (_) => {
        typeof s(l) == "string" ? _(u) : typeof s(l) == "number" ? _(v, 1) : _(d, -1);
      });
    }
    k(a, c);
  }), k(t, r), X();
}
var zs = /* @__PURE__ */ L('<button class="icon-btn svelte-8nabiy"><svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M12 4L6 10l6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>'), Ms = /* @__PURE__ */ L('<p class="subtitle svelte-8nabiy"> </p>'), Ls = /* @__PURE__ */ L('<button class="icon-btn svelte-8nabiy"><svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15 5L5 15M5 5l10 10" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path></svg></button>'), Ns = /* @__PURE__ */ L('<div class="header svelte-8nabiy"><!> <div class="header-text svelte-8nabiy"><h2 id="web-ui-modal-title" class="svelte-8nabiy"> </h2> <!></div> <!></div>');
function bt(t, e) {
  W(e, !0);
  const n = {
    en: pe,
    ko: me,
    "zh-Hans": we,
    "zh-Hant": ke,
    tr: be
  }, r = /* @__PURE__ */ E(() => ye(n));
  var i = Ns(), a = w(i);
  {
    var l = (g) => {
      var m = zs();
      z((h) => Ae(m, "aria-label", h), [() => s(r)(64)]), ct("click", m, function(...h) {
        e.onback?.apply(this, h);
      }), k(g, m);
    };
    H(a, (g) => {
      e.onback && g(l);
    });
  }
  var o = T(a, 2), c = w(o), f = w(c), u = T(c, 2);
  {
    var v = (g) => {
      var m = Ms(), h = w(m);
      z(() => P(h, e.subtitle)), k(g, m);
    };
    H(u, (g) => {
      e.subtitle && g(v);
    });
  }
  var d = T(o, 2);
  {
    var _ = (g) => {
      var m = Ls();
      z((h) => Ae(m, "aria-label", h), [() => s(r)(3)]), ct("click", m, function(...h) {
        e.onclose?.apply(this, h);
      }), k(g, m);
    };
    H(d, (g) => {
      e.onclose && g(_);
    });
  }
  z(() => P(f, e.title)), k(t, i), X();
}
Bt(["click"]);
var Os = /* @__PURE__ */ L('<a rel="noreferrer"><!></a>'), Bs = /* @__PURE__ */ L("<button><!></button>");
function ae(t, e) {
  let n = ue(e, "variant", 3, "primary"), r = ue(e, "disabled", 3, !1), i = ue(e, "block", 3, !1), a = ue(e, "multiline", 3, !1);
  var l = ne(), o = K(l);
  {
    var c = (u) => {
      var v = Os();
      let d;
      var _ = w(v);
      An(_, () => e.children), z(() => {
        d = Ot(v, 1, "btn svelte-10u0xy3", null, d, {
          primary: n() === "primary",
          secondary: n() === "secondary",
          block: i(),
          multiline: a()
        }), Ae(v, "href", e.href), Ae(v, "target", e.target);
      }), k(u, v);
    }, f = (u) => {
      var v = Bs();
      let d;
      var _ = w(v);
      An(_, () => e.children), z(() => {
        d = Ot(v, 1, "btn svelte-10u0xy3", null, d, {
          primary: n() === "primary",
          secondary: n() === "secondary",
          block: i(),
          multiline: a()
        }), v.disabled = r();
      }), ct("click", v, function(...g) {
        e.onclick?.apply(this, g);
      }), k(u, v);
    };
    H(o, (u) => {
      e.href ? u(c) : u(f, -1);
    });
  }
  k(t, l);
}
Bt(["click"]);
var Rs = /* @__PURE__ */ L('<p class="error-details svelte-y9soiq"> </p>'), Ds = /* @__PURE__ */ L('<button class="details-toggle svelte-y9soiq"> </button> <!>', 1), Hs = /* @__PURE__ */ L('<!> <div class="error-content svelte-y9soiq"><div class="error-icon svelte-y9soiq"><svg width="56" height="56" viewBox="0 0 56 56" fill="none"><circle cx="28" cy="28" r="28" fill="var(--web-ui-error)" opacity="0.08"></circle><circle cx="28" cy="28" r="20" fill="var(--web-ui-error)" opacity="0.08"></circle><path d="M28 20v12M28 36v2" stroke="var(--web-ui-error)" stroke-width="2.5" stroke-linecap="round"></path></svg></div> <p class="error-message svelte-y9soiq"> </p> <!></div> <div class="actions svelte-y9soiq"><!> <!></div>', 1);
function Is(t, e) {
  W(e, !0);
  const n = {
    en: pe,
    ko: me,
    "zh-Hans": we,
    "zh-Hant": ke,
    tr: be
  }, r = /* @__PURE__ */ E(() => ye(n));
  let i = ue(e, "details", 3, ""), a = /* @__PURE__ */ R(!1);
  var l = Hs(), o = K(l);
  {
    let p = /* @__PURE__ */ E(() => s(r)(0));
    bt(o, {
      get title() {
        return s(p);
      },
      get onclose() {
        return e.onclose;
      }
    });
  }
  var c = T(o, 2), f = T(w(c), 2), u = w(f), v = T(f, 2);
  {
    var d = (p) => {
      var y = Ds(), b = K(y), S = w(b), N = T(b, 2);
      {
        var M = (O) => {
          var B = Rs(), Q = w(B);
          z(() => P(Q, i())), k(O, B);
        };
        H(N, (O) => {
          s(a) && O(M);
        });
      }
      z(
        (O) => {
          Ae(b, "aria-expanded", s(a)), P(S, O);
        },
        [
          () => s(a) ? s(r)(1) : s(r)(2)
        ]
      ), ct("click", b, () => A(a, !s(a))), k(p, y);
    };
    H(v, (p) => {
      i() && p(d);
    });
  }
  var _ = T(c, 2), g = w(_);
  ae(g, {
    variant: "secondary",
    get onclick() {
      return e.onclose;
    },
    children: (p, y) => {
      var b = ee();
      z((S) => P(b, S), [() => s(r)(3)]), k(p, b);
    },
    $$slots: { default: !0 }
  });
  var m = T(g, 2);
  {
    var h = (p) => {
      ae(p, {
        get onclick() {
          return e.onretry;
        },
        children: (y, b) => {
          var S = ee();
          z((N) => P(S, N), [() => s(r)(4)]), k(y, S);
        },
        $$slots: { default: !0 }
      });
    };
    H(m, (p) => {
      e.onretry && p(h);
    });
  }
  z(() => P(u, e.message)), k(t, l), X();
}
Bt(["click"]);
var qs = /* @__PURE__ */ L('<img alt="" class="select-logo svelte-f3myrl"/>'), Fs = /* @__PURE__ */ L('<div class="select-logo-placeholder svelte-f3myrl" aria-hidden="true"> </div>'), js = /* @__PURE__ */ L('<span class="select-caption svelte-f3myrl"> </span>'), Ks = /* @__PURE__ */ L('<button class="select-card svelte-f3myrl"><!> <span class="select-text svelte-f3myrl"><span class="select-label svelte-f3myrl"> </span> <!></span></button>');
function Bn(t, e) {
  W(e, !0);
  let n = ue(e, "icon", 3, !0);
  var r = Ks(), i = w(r);
  {
    var a = (d) => {
      var _ = qs();
      z(() => Ae(_, "src", e.logo)), k(d, _);
    }, l = (d) => {
      var _ = Fs(), g = w(_);
      z((m) => P(g, m), [() => e.label.charAt(0).toUpperCase()]), k(d, _);
    };
    H(i, (d) => {
      e.logo ? d(a) : n() && d(l, 1);
    });
  }
  var o = T(i, 2), c = w(o), f = w(c), u = T(c, 2);
  {
    var v = (d) => {
      var _ = js(), g = w(_);
      z(() => P(g, e.caption)), k(d, _);
    };
    H(u, (d) => {
      e.caption && d(v);
    });
  }
  z(() => P(f, e.label)), ct("click", r, function(...d) {
    e.onclick?.apply(this, d);
  }), k(t, r), X();
}
Bt(["click"]);
var Us = /* @__PURE__ */ L('<div class="spinner svelte-1qm4te0"><svg viewBox="0 0 24 24" fill="none" class="svelte-1qm4te0"><circle cx="12" cy="12" r="10" stroke="var(--web-ui-border)" stroke-width="3"></circle><path d="M12 2a10 10 0 019.8 8" stroke="var(--web-ui-accent)" stroke-width="3" stroke-linecap="round"></path></svg></div>');
function gn(t, e) {
  let n = ue(e, "size", 3, 32);
  var r = Us();
  z(() => cs(r, `width: ${n() ?? ""}px; height: ${n() ?? ""}px;`)), k(t, r);
}
var Gs = /* @__PURE__ */ L('<span class="field-prefix svelte-1ldu9ck" aria-hidden="true"> </span>'), Ys = /* @__PURE__ */ L('<label class="field svelte-1ldu9ck"><span class="field-label svelte-1ldu9ck"> </span> <span><!> <input type="text" autocapitalize="off" autocomplete="off" autocorrect="off" spellcheck="false" class="svelte-1ldu9ck"/></span></label>');
function Mi(t, e) {
  W(e, !0);
  let n = ue(e, "value", 15), r = ue(e, "invalid", 3, !1), i = ue(e, "autofocus", 3, !1), a = /* @__PURE__ */ R(void 0);
  He(() => {
    i() && s(a)?.focus();
  });
  function l(m) {
    m.key === "Enter" && (m.preventDefault(), e.onenter?.());
  }
  var o = Ys(), c = w(o), f = w(c), u = T(c, 2);
  let v;
  var d = w(u);
  {
    var _ = (m) => {
      var h = Gs(), p = w(h);
      z(() => P(p, e.prefix)), k(m, h);
    };
    H(d, (m) => {
      e.prefix && m(_);
    });
  }
  var g = T(d, 2);
  Si(g, (m) => A(a, m), () => s(a)), z(() => {
    P(f, e.label), v = Ot(u, 1, "field-control svelte-1ldu9ck", null, v, { invalid: r() }), Ae(g, "placeholder", e.placeholder), Ae(g, "aria-invalid", r());
  }), ct("keydown", g, l), gs(g, n), k(t, o), X();
}
Bt(["keydown"]);
const Vs = /^[a-z1-5](?:[a-z1-5.]{0,10}[a-z1-5])?$/;
function Li(t) {
  return Vs.test(t);
}
var Lr = /* @__PURE__ */ L('<p class="entry-error svelte-1t9vubs"> </p>'), Ws = /* @__PURE__ */ L('<div class="entry svelte-1t9vubs"><!> <!> <!></div>');
function Xs(t, e) {
  W(e, !0);
  const n = {
    en: pe,
    ko: me,
    "zh-Hans": we,
    "zh-Hant": ke,
    tr: be
  }, r = /* @__PURE__ */ E(() => ye(n));
  let i = ue(e, "value", 15), a = ue(e, "error", 3, ""), l = /* @__PURE__ */ R(!1), o = /* @__PURE__ */ E(() => Li(i()));
  function c() {
    if (!s(o)) {
      A(l, !0);
      return;
    }
    e.onsubmit?.(i());
  }
  var f = Ws(), u = w(f);
  {
    let m = /* @__PURE__ */ E(() => s(r)(73)), h = /* @__PURE__ */ E(() => !!a() || s(l) && !s(o));
    Mi(u, {
      get label() {
        return s(m);
      },
      placeholder: "youraccount",
      get invalid() {
        return s(h);
      },
      autofocus: !0,
      onenter: c,
      get value() {
        return i();
      },
      set value(p) {
        i(p);
      }
    });
  }
  var v = T(u, 2);
  {
    var d = (m) => {
      var h = Lr(), p = w(h);
      z((y) => P(p, y), [() => s(r)(80)]), k(m, h);
    }, _ = (m) => {
      var h = Lr(), p = w(h);
      z(() => P(p, a())), k(m, h);
    };
    H(v, (m) => {
      s(l) && !s(o) ? m(d) : a() && m(_, 1);
    });
  }
  var g = T(v, 2);
  ae(g, {
    block: !0,
    onclick: c,
    children: (m, h) => {
      var p = ee();
      z((y) => P(p, y), [() => s(r)(20)]), k(m, p);
    },
    $$slots: { default: !0 }
  }), k(t, f), X();
}
class Qs {
  #e;
  get theme() {
    return s(this.#e);
  }
  set theme(e) {
    A(this.#e, e, !0);
  }
  #a;
  get appearance() {
    return s(this.#a);
  }
  set appearance(e) {
    A(this.#a, e, !0);
  }
  constructor() {
    this.#e = /* @__PURE__ */ R("auto"), this.#a = /* @__PURE__ */ R(Te({}));
  }
  resolved() {
    return this.theme === "light" || this.theme === "dark" ? this.theme : typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  }
  applyToHost(e) {
    this.theme !== "auto" ? e.setAttribute("data-theme", this.theme) : e.removeAttribute("data-theme");
    const n = this.appearance;
    n.accent && (e.style.setProperty("--web-ui-accent", n.accent), e.style.setProperty("--web-ui-accent-hover", n.accentHover ?? `color-mix(in oklch, ${n.accent} 85%, var(--web-ui-surface))`), e.style.setProperty("--web-ui-accent-text", n.accentText ?? "var(--web-ui-bg)"), e.style.setProperty("--web-ui-ring", n.accent)), n.background && e.style.setProperty("--web-ui-bg", n.background), n.surface && e.style.setProperty("--web-ui-surface", n.surface), n.text && e.style.setProperty("--web-ui-text", n.text), n.textSecondary && e.style.setProperty("--web-ui-text-secondary", n.textSecondary), n.error && e.style.setProperty("--web-ui-error", n.error), n.success && e.style.setProperty("--web-ui-success", n.success), n.border && e.style.setProperty("--web-ui-border", n.border), n.borderRadius != null && e.style.setProperty("--web-ui-radius", `${n.borderRadius}px`), n.fontFamily && e.style.setProperty("--web-ui-font", n.fontFamily), n.backdropColor && e.style.setProperty("--web-ui-backdrop", n.backdropColor);
  }
}
const on = new Qs();
function Ni(t, e) {
  if (!t) return;
  if (typeof t == "string") return t;
  const n = e === "dark" ? "light" : "dark";
  return t.getVariant?.(e) ?? t.getVariant?.(n) ?? String(t);
}
var Js = /* @__PURE__ */ L('<div class="chain-list svelte-1oqx6nm"></div>');
function Zs(t, e) {
  W(e, !0);
  var n = Js();
  Re(n, 21, () => e.chains, Be, (r, i) => {
    {
      let a = /* @__PURE__ */ E(() => Ni(s(i).getLogo(), on.resolved()));
      Bn(r, {
        get label() {
          return s(i).name;
        },
        get logo() {
          return s(a);
        },
        onclick: () => e.onselect?.(s(i))
      });
    }
  }), k(t, n), X();
}
function $s(t) {
  if (!t.hasContext) return "loading";
  if (!t.hasWallet) return t.walletCount === 0 ? "loading" : "wallet";
  const { requiresChainSelect: e, requiresPermissionSelect: n, requiresPermissionEntry: r } = t.requirements;
  return !t.hasChain && e && t.chainCount > 1 ? "chain" : !t.hasPermission && n && t.hasChain ? "permission-select" : !t.hasPermission && r ? t.hasAccount ? "permission-choice" : "account-entry" : "done";
}
function el(t) {
  return typeof t == "object" && t !== null && "response" in t ? "not-found" : "unreachable";
}
var tl = /* @__PURE__ */ L('<div class="choice-loading svelte-1gs5td9"><!> <p class="svelte-1gs5td9"><!></p></div>'), nl = /* @__PURE__ */ L('<div class="choice-list svelte-1gs5td9"></div>'), rl = /* @__PURE__ */ L('<p class="choice-error svelte-1gs5td9"> </p>'), il = /* @__PURE__ */ L('<div class="choice-manual svelte-1gs5td9"><p class="choice-note svelte-1gs5td9"><!></p> <!> <!> <!></div>');
function al(t, e) {
  W(e, !0);
  const n = {
    en: pe,
    ko: me,
    "zh-Hans": we,
    "zh-Hant": ke,
    tr: be
  }, r = /* @__PURE__ */ E(() => ye(n));
  let i = /* @__PURE__ */ R(!0), a = /* @__PURE__ */ R(Te([])), l = /* @__PURE__ */ R(""), o = /* @__PURE__ */ R(!1), c = !1, f = /* @__PURE__ */ E(() => Li(s(l)));
  function u(y) {
    e.onselect?.(`${e.account}@${y}`);
  }
  function v() {
    if (!s(f)) {
      A(o, !0);
      return;
    }
    u(s(l));
  }
  async function d() {
    if (!e.chain) {
      A(i, !1);
      return;
    }
    try {
      const y = await e.context.getClient(e.chain).v1.chain.get_account(e.account);
      if (A(
        a,
        y.permissions.map((b) => ({
          name: String(b.perm_name),
          parent: String(b.parent)
        })),
        !0
      ), s(a).length === 0) {
        e.onfail?.("not-found");
        return;
      }
      if (s(a).length === 1) {
        u(s(a)[0].name);
        return;
      }
      A(i, !1);
    } catch (y) {
      e.onfail?.(el(y));
    }
  }
  He(() => {
    c || (c = !0, d());
  });
  var _ = ne(), g = K(_);
  {
    var m = (y) => {
      var b = tl(), S = w(b);
      gn(S, {});
      var N = T(S, 2), M = w(N);
      {
        let O = /* @__PURE__ */ E(() => s(r).c(81)), B = /* @__PURE__ */ E(() => [e.account]);
        ze(M, {
          get x() {
            return s(O);
          },
          get a() {
            return s(B);
          }
        });
      }
      k(y, b);
    }, h = (y) => {
      var b = nl();
      Re(b, 21, () => s(a), Be, (S, N) => {
        {
          let M = /* @__PURE__ */ E(() => s(N).parent ? s(r)(84, [s(N).parent]) : void 0);
          Bn(S, {
            get label() {
              return s(N).name;
            },
            get caption() {
              return s(M);
            },
            icon: !1,
            onclick: () => u(s(N).name)
          });
        }
      }), k(y, b);
    }, p = (y) => {
      var b = il(), S = w(b), N = w(S);
      {
        let I = /* @__PURE__ */ E(() => s(r).c(82)), Y = /* @__PURE__ */ E(() => [e.account]);
        ze(N, {
          get x() {
            return s(I);
          },
          get a() {
            return s(Y);
          }
        });
      }
      var M = T(S, 2);
      {
        let I = /* @__PURE__ */ E(() => s(r)(74)), Y = /* @__PURE__ */ E(() => s(o) && !s(f));
        Mi(M, {
          get label() {
            return s(I);
          },
          placeholder: "active",
          prefix: "@",
          get invalid() {
            return s(Y);
          },
          autofocus: !0,
          onenter: v,
          get value() {
            return s(l);
          },
          set value(V) {
            A(l, V, !0);
          }
        });
      }
      var O = T(M, 2);
      {
        var B = (I) => {
          var Y = rl(), V = w(Y);
          z((se) => P(V, se), [() => s(r)(83)]), k(I, Y);
        };
        H(O, (I) => {
          s(o) && !s(f) && I(B);
        });
      }
      var Q = T(O, 2);
      ae(Q, {
        block: !0,
        onclick: v,
        children: (I, Y) => {
          var V = ee();
          z((se) => P(V, se), [() => s(r)(20)]), k(I, V);
        },
        $$slots: { default: !0 }
      }), k(y, b);
    };
    H(g, (y) => {
      s(i) ? y(m) : e.chain ? y(h, 1) : y(p, -1);
    });
  }
  k(t, _), X();
}
var sl = /* @__PURE__ */ L('<div class="permission-loading svelte-x1too2"><!> <p class="svelte-x1too2"> </p></div>'), ll = /* @__PURE__ */ L('<p class="permission-note svelte-x1too2"> </p>'), ol = /* @__PURE__ */ L('<div class="permission-list svelte-x1too2"></div>'), cl = /* @__PURE__ */ L('<p class="permission-note svelte-x1too2"><!></p> <p class="permission-key svelte-x1too2"> </p>', 1);
function ul(t, e) {
  W(e, !0);
  const n = {
    en: pe,
    ko: me,
    "zh-Hans": we,
    "zh-Hant": ke,
    tr: be
  }, r = /* @__PURE__ */ E(() => ye(n));
  let i = /* @__PURE__ */ R(!0), a = /* @__PURE__ */ R(Te([])), l = /* @__PURE__ */ R(""), o = /* @__PURE__ */ R(""), c = !1;
  async function f() {
    try {
      let h = e.walletPlugin.metadata.publicKey;
      if (!h && e.walletPlugin.retrievePublicKey && (h = String(await e.walletPlugin.retrievePublicKey(e.chain.id))), !h)
        throw new Error("The wallet did not provide a public key.");
      A(l, String(h), !0);
      const y = (await e.context.getClient(e.chain).call({
        path: "/v1/chain/get_accounts_by_authorizers",
        params: { keys: [s(l)] }
      })).accounts.map((b) => `${b.account_name}@${b.permission_name}`);
      A(a, [...new Set(y)], !0);
    } catch (h) {
      A(o, h instanceof Error ? h.message : String(h), !0);
    } finally {
      A(i, !1);
    }
  }
  He(() => {
    c || (c = !0, f());
  });
  var u = ne(), v = K(u);
  {
    var d = (h) => {
      var p = sl(), y = w(p);
      gn(y, {});
      var b = T(y, 2), S = w(b);
      z((N) => P(S, N), [() => s(r)(75)]), k(h, p);
    }, _ = (h) => {
      var p = ll(), y = w(p);
      z(() => P(y, s(o))), k(h, p);
    }, g = (h) => {
      var p = ol();
      Re(p, 21, () => s(a), Be, (y, b) => {
        const S = /* @__PURE__ */ E(() => {
          const [N, M] = s(b).split("@");
          return { account: N, permission: M };
        });
        Bn(y, {
          get label() {
            return s(S).account;
          },
          get caption() {
            return `@${s(S).permission ?? ""}`;
          },
          icon: !1,
          onclick: () => e.onselect?.(s(b))
        });
      }), k(h, p);
    }, m = (h) => {
      var p = cl(), y = K(p), b = w(y);
      {
        let M = /* @__PURE__ */ E(() => s(r).c(76)), O = /* @__PURE__ */ E(() => [e.chain.name]);
        ze(b, {
          get x() {
            return s(M);
          },
          get a() {
            return s(O);
          }
        });
      }
      var S = T(y, 2), N = w(S);
      z(() => P(N, s(l))), k(h, p);
    };
    H(v, (h) => {
      s(i) ? h(d) : s(o) ? h(_, 1) : s(a).length > 0 ? h(g, 2) : h(m, -1);
    });
  }
  k(t, u), X();
}
var fl = /* @__PURE__ */ L('<div class="loading svelte-1swrueq"><!> <p class="svelte-1swrueq"> </p></div>'), dl = /* @__PURE__ */ L('<div class="wallet-list svelte-1swrueq"></div>'), vl = /* @__PURE__ */ L('<p class="origin svelte-1swrueq"><!></p>'), hl = /* @__PURE__ */ L("<!> <!> <!>", 1);
function gl(t, e) {
  W(e, !0);
  let n = /* @__PURE__ */ R(void 0), r = /* @__PURE__ */ R(void 0), i = /* @__PURE__ */ R(""), a = /* @__PURE__ */ R(void 0), l = /* @__PURE__ */ R(void 0), o = /* @__PURE__ */ R(void 0), c = !1, f = !1, u = /* @__PURE__ */ E(() => x.loginContext), v = /* @__PURE__ */ E(() => s(u)?.walletPlugins ?? []), d = /* @__PURE__ */ E(() => s(n) === void 0 ? void 0 : s(v)[s(n)]), _ = /* @__PURE__ */ E(() => ({
    ...s(u)?.uiRequirements ?? {
      requiresChainSelect: !1,
      requiresPermissionSelect: !1,
      requiresPermissionEntry: !1,
      requiresWalletSelect: !0
    },
    ...s(d)?.config ?? {}
  })), g = /* @__PURE__ */ E(() => {
    const C = s(u)?.chains ?? [], D = s(d)?.config.supportedChains;
    return !D || D.length === 0 ? C : C.filter((Z) => D.includes(String(Z.id)));
  }), m = /* @__PURE__ */ E(() => {
    if (s(r)) return s(r);
    if (s(u)?.chain) return s(u).chain;
    if (s(g).length === 1) return s(g)[0];
  }), h = /* @__PURE__ */ E(() => s(o) ?? (s(u)?.permissionLevel ? String(s(u).permissionLevel) : void 0)), p = /* @__PURE__ */ E(() => $s({
    hasContext: !!s(u),
    walletCount: s(v).length,
    hasWallet: s(n) !== void 0,
    chainCount: s(g).length,
    hasChain: !!s(m),
    hasAccount: !!s(a),
    hasPermission: !!s(h),
    requirements: s(_)
  }));
  const y = {
    en: pe,
    ko: me,
    "zh-Hans": we,
    "zh-Hant": ke,
    tr: be
  }, b = /* @__PURE__ */ E(() => ye(y));
  let S = /* @__PURE__ */ E(() => {
    switch (s(p)) {
      case "chain":
        return s(b)(65);
      case "permission-select":
        return s(b)(66);
      case "account-entry":
        return s(b)(67);
      case "permission-choice":
        return s(b)(77);
      default:
        return x.appName ? s(b)(5, [x.appName]) : s(b)(6);
    }
  }), N = /* @__PURE__ */ E(() => {
    switch (s(p)) {
      case "chain":
        return s(b)(68, [s(d)?.metadata?.name ?? "this wallet"]);
      case "permission-select":
        return s(b)(69);
      case "account-entry":
        return s(b)(78);
      case "permission-choice":
        return s(b)(79, [s(a)]);
      case "done":
        return s(b)(70);
      default:
        return s(b)(7);
    }
  }), M = /* @__PURE__ */ E(() => !s(l) || !s(m) ? "" : s(l).kind === "not-found" ? s(b)(85, [s(l).account, s(m).name]) : s(b)(86, [s(m).name, s(l).account])), O = /* @__PURE__ */ E(() => typeof window < "u" ? window.location.host : "");
  He(() => {
    f || !s(u) || (f = !0, s(u).walletPluginIndex !== void 0 && A(n, s(u).walletPluginIndex, !0));
  }), He(() => {
    if (s(p) !== "done" || c || s(n) === void 0) return;
    c = !0;
    const C = { walletPluginIndex: s(n) };
    s(m) && (C.chainId = s(m).id), s(h) && (C.permissionLevel = s(h)), e.oncomplete?.(C);
  });
  function B() {
    if (s(p) === "permission-choice") {
      A(a, void 0);
      return;
    }
    A(n, void 0), A(r, void 0), A(i, ""), A(a, void 0), A(l, void 0), A(o, void 0);
  }
  function Q(C) {
    A(l, void 0), A(a, C, !0);
  }
  function I(C) {
    A(l, { kind: C, account: s(a) ?? s(i) }, !0), A(a, void 0);
  }
  let Y = /* @__PURE__ */ E(() => {
    if (s(p) === "permission-choice") return B;
    if (!(s(p) === "loading" || s(p) === "wallet" || s(p) === "done"))
      return s(v).length > 1 ? B : void 0;
  });
  var V = hl(), se = K(V);
  bt(se, {
    get title() {
      return s(S);
    },
    get subtitle() {
      return s(N);
    },
    get onback() {
      return s(Y);
    },
    get onclose() {
      return e.onclose;
    }
  });
  var U = T(se, 2);
  {
    var xe = (C) => {
      var D = fl(), Z = w(D);
      gn(Z, {});
      var de = T(Z, 2), je = w(de);
      z((yt) => P(je, yt), [
        () => s(p) === "done" ? s(b)(71) : s(b)(72)
      ]), k(C, D);
    }, he = (C) => {
      var D = dl();
      Re(D, 21, () => s(v), Be, (Z, de, je) => {
        {
          let yt = /* @__PURE__ */ E(() => s(de).metadata?.name ?? s(b)(8, [je + 1])), Qt = /* @__PURE__ */ E(() => Ni(s(de).metadata?.logo, on.resolved()));
          Bn(Z, {
            get label() {
              return s(yt);
            },
            get logo() {
              return s(Qt);
            },
            onclick: () => A(n, je, !0)
          });
        }
      }), k(C, D);
    }, Fe = (C) => {
      Zs(C, {
        get chains() {
          return s(g);
        },
        onselect: (D) => A(r, D, !0)
      });
    }, Le = (C) => {
      ul(C, {
        get context() {
          return s(u);
        },
        get chain() {
          return s(m);
        },
        get walletPlugin() {
          return s(d);
        },
        onselect: (D) => A(o, D, !0)
      });
    }, Ne = (C) => {
      Xs(C, {
        get error() {
          return s(M);
        },
        onsubmit: Q,
        get value() {
          return s(i);
        },
        set value(D) {
          A(i, D, !0);
        }
      });
    }, G = (C) => {
      al(C, {
        get context() {
          return s(u);
        },
        get chain() {
          return s(m);
        },
        get account() {
          return s(a);
        },
        onselect: (D) => A(o, D, !0),
        onfail: I
      });
    };
    H(U, (C) => {
      s(p) === "loading" || s(p) === "done" ? C(xe) : s(p) === "wallet" ? C(he, 1) : s(p) === "chain" ? C(Fe, 2) : s(p) === "permission-select" && s(u) && s(m) && s(d) ? C(Le, 3) : s(p) === "account-entry" ? C(Ne, 4) : s(p) === "permission-choice" && s(u) && s(a) && C(G, 5);
    });
  }
  var le = T(U, 2);
  {
    var oe = (C) => {
      var D = vl(), Z = w(D);
      {
        let de = /* @__PURE__ */ E(() => s(b).c(9)), je = /* @__PURE__ */ E(() => [s(O)]);
        ze(Z, {
          get x() {
            return s(de);
          },
          get a() {
            return s(je);
          }
        });
      }
      k(C, D);
    };
    H(le, (C) => {
      s(O) && C(oe);
    });
  }
  k(t, V), X();
}
var _l = /* @__PURE__ */ L('<div class="success-icon svelte-px1e45"><svg width="64" height="64" viewBox="0 0 64 64" fill="none"><circle cx="32" cy="32" r="30" fill="var(--web-ui-success)" opacity="0.12"></circle><circle cx="32" cy="32" r="22" fill="var(--web-ui-success)" opacity="0.16"></circle><circle cx="32" cy="32" r="22" fill="none" stroke="var(--web-ui-success)" stroke-width="2" opacity="0.5"></circle><path d="M23 32l6 6 12-14" stroke="var(--web-ui-success)" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="checkmark svelte-px1e45"></path></svg></div>'), pl = /* @__PURE__ */ L('<p class="confirm-sub svelte-px1e45"><!></p>'), ml = /* @__PURE__ */ L('<img alt="" class="chain-logo svelte-px1e45"/>'), wl = /* @__PURE__ */ L('<div class="info-row svelte-px1e45"><span class="info-label svelte-px1e45"> </span> <div class="info-value-row svelte-px1e45"><!> <span class="info-value svelte-px1e45"> </span></div></div>'), kl = /* @__PURE__ */ L('<div class="info-row svelte-px1e45"><span class="info-label svelte-px1e45"> </span> <span class="info-value mono svelte-px1e45"> </span></div>'), bl = /* @__PURE__ */ L('<div class="info-row svelte-px1e45"><span class="info-label svelte-px1e45"> </span> <span class="info-value svelte-px1e45"><!></span></div>'), yl = /* @__PURE__ */ L('<div class="session-info svelte-px1e45"><!> <!> <!></div>'), xl = /* @__PURE__ */ L('<div class="done-actions svelte-px1e45"><!></div>'), El = /* @__PURE__ */ L('<!> <div class="transact-content svelte-px1e45"><!> <p class="stage-label svelte-px1e45"> </p> <!></div> <!>', 1);
function Tl(t, e) {
  W(e, !0);
  const n = {
    en: pe,
    ko: me,
    "zh-Hans": we,
    "zh-Hant": ke,
    tr: be
  }, r = /* @__PURE__ */ E(() => ye(n)), i = /* @__PURE__ */ E(() => ({
    preparing: s(r)(46),
    signing: s(r)(47),
    signed: s(r)(48),
    broadcasting: s(r)(49),
    confirming: s(r)(50),
    complete: s(r)(51)
  }));
  let a = /* @__PURE__ */ E(() => s(i)[x.transactStage] ?? s(r)(52)), l = /* @__PURE__ */ R(0), o;
  He(() => (x.transactStartTime > 0 && (A(l, 0), o = setInterval(
    () => {
      A(l, Math.floor((Date.now() - x.transactStartTime) / 1e3), !0);
    },
    1e3
  )), () => {
    o && clearInterval(o);
  }));
  let c = /* @__PURE__ */ E(() => x.transactStage === "complete");
  var f = El(), u = K(f);
  {
    let M = /* @__PURE__ */ E(() => s(r)(53)), O = /* @__PURE__ */ E(() => s(c) ? void 0 : e.onclose);
    bt(u, {
      get title() {
        return s(M);
      },
      get onclose() {
        return s(O);
      }
    });
  }
  var v = T(u, 2), d = w(v);
  {
    var _ = (M) => {
      var O = _l();
      k(M, O);
    }, g = (M) => {
      gn(M, { size: 40 });
    };
    H(d, (M) => {
      s(c) ? M(_) : M(g, -1);
    });
  }
  var m = T(d, 2), h = w(m), p = T(m, 2);
  {
    var y = (M) => {
      var O = ne(), B = K(O);
      {
        var Q = (I) => {
          var Y = pl(), V = w(Y);
          {
            let se = /* @__PURE__ */ E(() => s(r).c(54)), U = /* @__PURE__ */ E(() => [x.chainName]);
            ze(V, {
              get x() {
                return s(se);
              },
              get a() {
                return s(U);
              }
            });
          }
          k(I, Y);
        };
        H(B, (I) => {
          x.chainName && I(Q);
        });
      }
      k(M, O);
    }, b = (M) => {
      var O = yl(), B = w(O);
      {
        var Q = (U) => {
          var xe = wl(), he = w(xe), Fe = w(he), Le = T(he, 2), Ne = w(Le);
          {
            var G = (C) => {
              var D = ml();
              z(() => Ae(D, "src", x.chainLogo)), k(C, D);
            };
            H(Ne, (C) => {
              x.chainLogo && C(G);
            });
          }
          var le = T(Ne, 2), oe = w(le);
          z(
            (C) => {
              P(Fe, C), P(oe, x.chainName);
            },
            [() => s(r)(55)]
          ), k(U, xe);
        };
        H(B, (U) => {
          x.chainName && U(Q);
        });
      }
      var I = T(B, 2);
      {
        var Y = (U) => {
          var xe = kl(), he = w(xe), Fe = w(he), Le = T(he, 2), Ne = w(Le);
          z(
            (G) => {
              P(Fe, G), P(Ne, x.accountName);
            },
            [() => s(r)(56)]
          ), k(U, xe);
        };
        H(I, (U) => {
          x.accountName && U(Y);
        });
      }
      var V = T(I, 2);
      {
        var se = (U) => {
          var xe = bl(), he = w(xe), Fe = w(he), Le = T(he, 2), Ne = w(Le);
          {
            let G = /* @__PURE__ */ E(() => s(r).c(58)), le = /* @__PURE__ */ E(() => [s(l)]);
            ze(Ne, {
              get x() {
                return s(G);
              },
              get a() {
                return s(le);
              }
            });
          }
          z((G) => P(Fe, G), [() => s(r)(57)]), k(U, xe);
        };
        H(V, (U) => {
          s(l) > 0 && U(se);
        });
      }
      k(M, O);
    };
    H(p, (M) => {
      s(c) ? M(y) : (x.chainName || x.accountName || s(l) > 0) && M(b, 1);
    });
  }
  var S = T(v, 2);
  {
    var N = (M) => {
      var O = xl(), B = w(O);
      ae(B, {
        block: !0,
        get onclick() {
          return e.ondone;
        },
        children: (Q, I) => {
          var Y = ee();
          z((V) => P(Y, V), [() => s(r)(59)]), k(Q, Y);
        },
        $$slots: { default: !0 }
      }), k(M, O);
    };
    H(S, (M) => {
      s(c) && M(N);
    });
  }
  z(() => P(h, s(a))), k(t, f), X();
}
var Cl = /* @__PURE__ */ L('<div class="asset svelte-1smsag4"><p class="value svelte-1smsag4"> </p> <p class="label svelte-1smsag4"> </p></div>');
function Al(t, e) {
  W(e, !0);
  var n = Cl(), r = w(n), i = w(r), a = T(r, 2), l = w(a);
  z(() => {
    P(i, e.data.value ?? ""), P(l, e.data.label ?? "");
  }), k(t, n), X();
}
var Sl = /* @__PURE__ */ L('<div class="accept svelte-2cq8ks"><!> <!></div>');
function Pl(t, e) {
  W(e, !0);
  const n = {
    en: pe,
    ko: me,
    "zh-Hans": we,
    "zh-Hant": ke,
    tr: be
  }, r = /* @__PURE__ */ E(() => ye(n));
  var i = Sl(), a = w(i);
  ae(a, {
    variant: "secondary",
    get onclick() {
      return e.oncancel;
    },
    children: (o, c) => {
      var f = ee();
      z((u) => P(f, u), [() => s(r)(60)]), k(o, f);
    },
    $$slots: { default: !0 }
  });
  var l = T(a, 2);
  ae(l, {
    get onclick() {
      return e.oncomplete;
    },
    children: (o, c) => {
      var f = ee();
      z((u) => P(f, u), [() => s(r)(61)]), k(o, f);
    },
    $$slots: { default: !0 }
  }), k(t, i), X();
}
var zl = /* @__PURE__ */ L('<p class="label svelte-1dtoznn"> </p>'), Ml = /* @__PURE__ */ L('<div class="countdown svelte-1dtoznn"><div class="timer-ring svelte-1dtoznn"><svg width="56" height="56" viewBox="0 0 56 56"><circle cx="28" cy="28" r="24" fill="none" stroke="var(--web-ui-border)" stroke-width="2.5"></circle><circle cx="28" cy="28" r="24" fill="none" stroke="var(--web-ui-accent)" stroke-width="2.5" stroke-linecap="round" class="progress svelte-1dtoznn"></circle></svg> <span class="time svelte-1dtoznn"> </span></div> <!></div>');
function Ll(t, e) {
  W(e, !0);
  const n = 151;
  let r = /* @__PURE__ */ R(""), i = /* @__PURE__ */ R(1);
  function a(m) {
    if (m <= 0) return "00:00";
    const h = Math.floor(m / 1e3), p = Math.floor(h / 60), y = h % 60;
    return `${String(p).padStart(2, "0")}:${String(y).padStart(2, "0")}`;
  }
  let l = /* @__PURE__ */ E(() => n * (1 - Math.max(0, Math.min(1, s(i)))));
  He(() => {
    if (!e.data.end) return;
    const m = new Date(e.data.end).getTime(), h = Math.max(m - Date.now(), 1), p = () => {
      const b = m - Date.now();
      A(r, a(b), !0), A(i, b / h);
    };
    p();
    const y = setInterval(p, 200);
    return () => clearInterval(y);
  });
  var o = Ml(), c = w(o), f = w(c), u = T(w(f));
  Ae(u, "stroke-dasharray", n);
  var v = T(f, 2), d = w(v), _ = T(c, 2);
  {
    var g = (m) => {
      var h = zl(), p = w(h);
      z(() => P(p, e.data.label)), k(m, h);
    };
    H(_, (m) => {
      e.data.label && m(g);
    });
  }
  z(() => {
    Ae(u, "stroke-dashoffset", s(l)), P(d, s(r));
  }), k(t, o), X();
}
var Nl = /* @__PURE__ */ L('<a class="text-link svelte-1b9bzfw" target="_blank" rel="noreferrer"> </a>');
function Ol(t, e) {
  W(e, !0);
  const n = {
    en: pe,
    ko: me,
    "zh-Hans": we,
    "zh-Hant": ke,
    tr: be
  }, r = /* @__PURE__ */ E(() => ye(n));
  var i = ne(), a = K(i);
  {
    var l = (o) => {
      var c = ne(), f = K(c);
      {
        var u = (d) => {
          {
            let _ = /* @__PURE__ */ E(() => e.data.variant === "primary" ? "primary" : "secondary");
            ae(d, {
              get href() {
                return e.data.href;
              },
              target: "_blank",
              block: !0,
              get variant() {
                return s(_);
              },
              children: (g, m) => {
                var h = ee();
                z((p) => P(h, p), [() => e.data.label ?? s(r)(63)]), k(g, h);
              },
              $$slots: { default: !0 }
            });
          }
        }, v = (d) => {
          var _ = Nl(), g = w(_);
          z(
            (m) => {
              Ae(_, "href", e.data.href), P(g, m);
            },
            [() => e.data.label ?? s(r)(63)]
          ), k(d, _);
        };
        H(f, (d) => {
          e.data.button !== !1 ? d(u) : d(v, -1);
        });
      }
      k(o, c);
    };
    H(a, (o) => {
      e.data.href && o(l);
    });
  }
  k(t, i), X();
}
var Bl = /* @__PURE__ */ L('<div class="prompt-button svelte-f40858"><!></div>');
function Rl(t, e) {
  W(e, !0);
  var n = Bl(), r = w(n);
  {
    let i = /* @__PURE__ */ E(() => e.data.label?.includes(`
`)), a = /* @__PURE__ */ E(() => e.data.variant ?? "secondary");
    ae(r, {
      block: !0,
      get multiline() {
        return s(i);
      },
      get variant() {
        return s(a);
      },
      get onclick() {
        return e.data.onClick;
      },
      children: (l, o) => {
        var c = ee();
        z(() => P(c, e.data.label ?? "OK")), k(l, c);
      },
      $$slots: { default: !0 }
    });
  }
  k(t, n), X();
}
const an = {
  L: 1,
  M: 0,
  Q: 3,
  H: 2
}, Se = {
  MODE_NUMBER: 1,
  MODE_ALPHA_NUM: 2,
  MODE_8BIT_BYTE: 4,
  MODE_KANJI: 8
};
class Dl {
  constructor(e) {
    this.mode = Se.MODE_8BIT_BYTE, this.data = e;
  }
  getLength() {
    return this.data.length;
  }
  write(e) {
    for (let n = 0; n < this.data.length; n++)
      e.put(this.data.charCodeAt(n), 8);
  }
}
class Nr {
  constructor() {
    this.buffer = [], this.length = 0;
  }
  get(e) {
    const n = Math.floor(e / 8);
    return (this.buffer[n] >>> 7 - e % 8 & 1) == 1;
  }
  put(e, n) {
    for (let r = 0; r < n; r++)
      this.putBit((e >>> n - r - 1 & 1) == 1);
  }
  getLengthInBits() {
    return this.length;
  }
  putBit(e) {
    const n = Math.floor(this.length / 8);
    this.buffer.length <= n && this.buffer.push(0), e && (this.buffer[n] |= 128 >>> this.length % 8), this.length++;
  }
}
const ce = {
  glog: function(t) {
    if (t < 1)
      throw new Error("glog(" + t + ")");
    return ce.LOG_TABLE[t];
  },
  gexp: function(t) {
    for (; t < 0; )
      t += 255;
    for (; t >= 256; )
      t -= 255;
    return ce.EXP_TABLE[t];
  },
  EXP_TABLE: new Array(256),
  LOG_TABLE: new Array(256)
};
for (let t = 0; t < 8; t++)
  ce.EXP_TABLE[t] = 1 << t;
for (let t = 8; t < 256; t++)
  ce.EXP_TABLE[t] = ce.EXP_TABLE[t - 4] ^ ce.EXP_TABLE[t - 5] ^ ce.EXP_TABLE[t - 6] ^ ce.EXP_TABLE[t - 8];
for (let t = 0; t < 255; t++)
  ce.LOG_TABLE[ce.EXP_TABLE[t]] = t;
class Vt {
  constructor(e, n) {
    if (e.length == null)
      throw new Error(e.length + "/" + n);
    let r = 0;
    for (; r < e.length && e[r] == 0; )
      r++;
    this.num = new Array(e.length - r + n);
    for (let i = 0; i < e.length - r; i++)
      this.num[i] = e[i + r];
  }
  get(e) {
    return this.num[e];
  }
  getLength() {
    return this.num.length;
  }
  multiply(e) {
    const n = new Array(this.getLength() + e.getLength() - 1);
    for (let r = 0; r < this.getLength(); r++)
      for (let i = 0; i < e.getLength(); i++)
        n[r + i] ^= ce.gexp(ce.glog(this.get(r)) + ce.glog(e.get(i)));
    return new Vt(n, 0);
  }
  mod(e) {
    if (this.getLength() - e.getLength() < 0)
      return this;
    const n = ce.glog(this.get(0)) - ce.glog(e.get(0)), r = new Array(this.getLength());
    for (let i = 0; i < this.getLength(); i++)
      r[i] = this.get(i);
    for (let i = 0; i < e.getLength(); i++)
      r[i] ^= ce.gexp(ce.glog(e.get(i)) + n);
    return new Vt(r, 0).mod(e);
  }
}
const st = class st {
  constructor(e, n) {
    this.totalCount = e, this.dataCount = n;
  }
  static getRSBlocks(e, n) {
    const r = st.getRsBlockTable(e, n);
    if (r == null)
      throw new Error(
        "bad rs block @ typeNumber:" + e + "/errorCorrectLevel:" + n
      );
    const i = r.length / 3, a = [];
    for (let l = 0; l < i; l++) {
      const o = r[l * 3 + 0], c = r[l * 3 + 1], f = r[l * 3 + 2];
      for (let u = 0; u < o; u++)
        a.push(new st(c, f));
    }
    return a;
  }
  static getRsBlockTable(e, n) {
    switch (n) {
      case an.L:
        return st.RS_BLOCK_TABLE[(e - 1) * 4 + 0];
      case an.M:
        return st.RS_BLOCK_TABLE[(e - 1) * 4 + 1];
      case an.Q:
        return st.RS_BLOCK_TABLE[(e - 1) * 4 + 2];
      case an.H:
        return st.RS_BLOCK_TABLE[(e - 1) * 4 + 3];
      default:
        return;
    }
  }
};
st.RS_BLOCK_TABLE = [
  [1, 26, 19],
  [1, 26, 16],
  [1, 26, 13],
  [1, 26, 9],
  [1, 44, 34],
  [1, 44, 28],
  [1, 44, 22],
  [1, 44, 16],
  [1, 70, 55],
  [1, 70, 44],
  [2, 35, 17],
  [2, 35, 13],
  [1, 100, 80],
  [2, 50, 32],
  [2, 50, 24],
  [4, 25, 9],
  [1, 134, 108],
  [2, 67, 43],
  [2, 33, 15, 2, 34, 16],
  [2, 33, 11, 2, 34, 12],
  [2, 86, 68],
  [4, 43, 27],
  [4, 43, 19],
  [4, 43, 15],
  [2, 98, 78],
  [4, 49, 31],
  [2, 32, 14, 4, 33, 15],
  [4, 39, 13, 1, 40, 14],
  [2, 121, 97],
  [2, 60, 38, 2, 61, 39],
  [4, 40, 18, 2, 41, 19],
  [4, 40, 14, 2, 41, 15],
  [2, 146, 116],
  [3, 58, 36, 2, 59, 37],
  [4, 36, 16, 4, 37, 17],
  [4, 36, 12, 4, 37, 13],
  [2, 86, 68, 2, 87, 69],
  [4, 69, 43, 1, 70, 44],
  [6, 43, 19, 2, 44, 20],
  [6, 43, 15, 2, 44, 16],
  [4, 101, 81],
  [1, 80, 50, 4, 81, 51],
  [4, 50, 22, 4, 51, 23],
  [3, 36, 12, 8, 37, 13],
  [2, 116, 92, 2, 117, 93],
  [6, 58, 36, 2, 59, 37],
  [4, 46, 20, 6, 47, 21],
  [7, 42, 14, 4, 43, 15],
  [4, 133, 107],
  [8, 59, 37, 1, 60, 38],
  [8, 44, 20, 4, 45, 21],
  [12, 33, 11, 4, 34, 12],
  [3, 145, 115, 1, 146, 116],
  [4, 64, 40, 5, 65, 41],
  [11, 36, 16, 5, 37, 17],
  [11, 36, 12, 5, 37, 13],
  [5, 109, 87, 1, 110, 88],
  [5, 65, 41, 5, 66, 42],
  [5, 54, 24, 7, 55, 25],
  [11, 36, 12],
  [5, 122, 98, 1, 123, 99],
  [7, 73, 45, 3, 74, 46],
  [15, 43, 19, 2, 44, 20],
  [3, 45, 15, 13, 46, 16],
  [1, 135, 107, 5, 136, 108],
  [10, 74, 46, 1, 75, 47],
  [1, 50, 22, 15, 51, 23],
  [2, 42, 14, 17, 43, 15],
  [5, 150, 120, 1, 151, 121],
  [9, 69, 43, 4, 70, 44],
  [17, 50, 22, 1, 51, 23],
  [2, 42, 14, 19, 43, 15],
  [3, 141, 113, 4, 142, 114],
  [3, 70, 44, 11, 71, 45],
  [17, 47, 21, 4, 48, 22],
  [9, 39, 13, 16, 40, 14],
  [3, 135, 107, 5, 136, 108],
  [3, 67, 41, 13, 68, 42],
  [15, 54, 24, 5, 55, 25],
  [15, 43, 15, 10, 44, 16],
  [4, 144, 116, 4, 145, 117],
  [17, 68, 42],
  [17, 50, 22, 6, 51, 23],
  [19, 46, 16, 6, 47, 17],
  [2, 139, 111, 7, 140, 112],
  [17, 74, 46],
  [7, 54, 24, 16, 55, 25],
  [34, 37, 13],
  [4, 151, 121, 5, 152, 122],
  [4, 75, 47, 14, 76, 48],
  [11, 54, 24, 14, 55, 25],
  [16, 45, 15, 14, 46, 16],
  [6, 147, 117, 4, 148, 118],
  [6, 73, 45, 14, 74, 46],
  [11, 54, 24, 16, 55, 25],
  [30, 46, 16, 2, 47, 17],
  [8, 132, 106, 4, 133, 107],
  [8, 75, 47, 13, 76, 48],
  [7, 54, 24, 22, 55, 25],
  [22, 45, 15, 13, 46, 16],
  [10, 142, 114, 2, 143, 115],
  [19, 74, 46, 4, 75, 47],
  [28, 50, 22, 6, 51, 23],
  [33, 46, 16, 4, 47, 17],
  [8, 152, 122, 4, 153, 123],
  [22, 73, 45, 3, 74, 46],
  [8, 53, 23, 26, 54, 24],
  [12, 45, 15, 28, 46, 16],
  [3, 147, 117, 10, 148, 118],
  [3, 73, 45, 23, 74, 46],
  [4, 54, 24, 31, 55, 25],
  [11, 45, 15, 31, 46, 16],
  [7, 146, 116, 7, 147, 117],
  [21, 73, 45, 7, 74, 46],
  [1, 53, 23, 37, 54, 24],
  [19, 45, 15, 26, 46, 16],
  [5, 145, 115, 10, 146, 116],
  [19, 75, 47, 10, 76, 48],
  [15, 54, 24, 25, 55, 25],
  [23, 45, 15, 25, 46, 16],
  [13, 145, 115, 3, 146, 116],
  [2, 74, 46, 29, 75, 47],
  [42, 54, 24, 1, 55, 25],
  [23, 45, 15, 28, 46, 16],
  [17, 145, 115],
  [10, 74, 46, 23, 75, 47],
  [10, 54, 24, 35, 55, 25],
  [19, 45, 15, 35, 46, 16],
  [17, 145, 115, 1, 146, 116],
  [14, 74, 46, 21, 75, 47],
  [29, 54, 24, 19, 55, 25],
  [11, 45, 15, 46, 46, 16],
  [13, 145, 115, 6, 146, 116],
  [14, 74, 46, 23, 75, 47],
  [44, 54, 24, 7, 55, 25],
  [59, 46, 16, 1, 47, 17],
  [12, 151, 121, 7, 152, 122],
  [12, 75, 47, 26, 76, 48],
  [39, 54, 24, 14, 55, 25],
  [22, 45, 15, 41, 46, 16],
  [6, 151, 121, 14, 152, 122],
  [6, 75, 47, 34, 76, 48],
  [46, 54, 24, 10, 55, 25],
  [2, 45, 15, 64, 46, 16],
  [17, 152, 122, 4, 153, 123],
  [29, 74, 46, 14, 75, 47],
  [49, 54, 24, 10, 55, 25],
  [24, 45, 15, 46, 46, 16],
  [4, 152, 122, 18, 153, 123],
  [13, 74, 46, 32, 75, 47],
  [48, 54, 24, 14, 55, 25],
  [42, 45, 15, 32, 46, 16],
  [20, 147, 117, 4, 148, 118],
  [40, 75, 47, 7, 76, 48],
  [43, 54, 24, 22, 55, 25],
  [10, 45, 15, 67, 46, 16],
  [19, 148, 118, 6, 149, 119],
  [18, 75, 47, 31, 76, 48],
  [34, 54, 24, 34, 55, 25],
  [20, 45, 15, 61, 46, 16]
];
let Sn = st;
const ht = {
  PATTERN000: 0,
  PATTERN001: 1,
  PATTERN010: 2,
  PATTERN011: 3,
  PATTERN100: 4,
  PATTERN101: 5,
  PATTERN110: 6,
  PATTERN111: 7
}, J = {
  PATTERN_POSITION_TABLE: [
    [],
    [6, 18],
    [6, 22],
    [6, 26],
    [6, 30],
    [6, 34],
    [6, 22, 38],
    [6, 24, 42],
    [6, 26, 46],
    [6, 28, 50],
    [6, 30, 54],
    [6, 32, 58],
    [6, 34, 62],
    [6, 26, 46, 66],
    [6, 26, 48, 70],
    [6, 26, 50, 74],
    [6, 30, 54, 78],
    [6, 30, 56, 82],
    [6, 30, 58, 86],
    [6, 34, 62, 90],
    [6, 28, 50, 72, 94],
    [6, 26, 50, 74, 98],
    [6, 30, 54, 78, 102],
    [6, 28, 54, 80, 106],
    [6, 32, 58, 84, 110],
    [6, 30, 58, 86, 114],
    [6, 34, 62, 90, 118],
    [6, 26, 50, 74, 98, 122],
    [6, 30, 54, 78, 102, 126],
    [6, 26, 52, 78, 104, 130],
    [6, 30, 56, 82, 108, 134],
    [6, 34, 60, 86, 112, 138],
    [6, 30, 58, 86, 114, 142],
    [6, 34, 62, 90, 118, 146],
    [6, 30, 54, 78, 102, 126, 150],
    [6, 24, 50, 76, 102, 128, 154],
    [6, 28, 54, 80, 106, 132, 158],
    [6, 32, 58, 84, 110, 136, 162],
    [6, 26, 54, 82, 110, 138, 166],
    [6, 30, 58, 86, 114, 142, 170]
  ],
  G15: 1335,
  G18: 7973,
  G15_MASK: 21522,
  getBCHTypeInfo: function(t) {
    let e = t << 10;
    for (; J.getBCHDigit(e) - J.getBCHDigit(J.G15) >= 0; )
      e ^= J.G15 << J.getBCHDigit(e) - J.getBCHDigit(J.G15);
    return (t << 10 | e) ^ J.G15_MASK;
  },
  getBCHTypeNumber: function(t) {
    let e = t << 12;
    for (; J.getBCHDigit(e) - J.getBCHDigit(J.G18) >= 0; )
      e ^= J.G18 << J.getBCHDigit(e) - J.getBCHDigit(J.G18);
    return t << 12 | e;
  },
  getBCHDigit: function(t) {
    let e = 0;
    for (; t != 0; )
      e++, t >>>= 1;
    return e;
  },
  getPatternPosition: function(t) {
    return J.PATTERN_POSITION_TABLE[t - 1];
  },
  getMask: function(t, e, n) {
    switch (t) {
      case ht.PATTERN000:
        return (e + n) % 2 == 0;
      case ht.PATTERN001:
        return e % 2 == 0;
      case ht.PATTERN010:
        return n % 3 == 0;
      case ht.PATTERN011:
        return (e + n) % 3 == 0;
      case ht.PATTERN100:
        return (Math.floor(e / 2) + Math.floor(n / 3)) % 2 == 0;
      case ht.PATTERN101:
        return e * n % 2 + e * n % 3 == 0;
      case ht.PATTERN110:
        return (e * n % 2 + e * n % 3) % 2 == 0;
      case ht.PATTERN111:
        return (e * n % 3 + (e + n) % 2) % 2 == 0;
      default:
        throw new Error("bad maskPattern:" + t);
    }
  },
  getErrorCorrectPolynomial: function(t) {
    let e = new Vt([1], 0);
    for (let n = 0; n < t; n++)
      e = e.multiply(new Vt([1, ce.gexp(n)], 0));
    return e;
  },
  getLengthInBits: function(t, e) {
    if (1 <= e && e < 10)
      switch (t) {
        case Se.MODE_NUMBER:
          return 10;
        case Se.MODE_ALPHA_NUM:
          return 9;
        case Se.MODE_8BIT_BYTE:
          return 8;
        case Se.MODE_KANJI:
          return 8;
        default:
          throw new Error("mode:" + t);
      }
    else if (e < 27)
      switch (t) {
        case Se.MODE_NUMBER:
          return 12;
        case Se.MODE_ALPHA_NUM:
          return 11;
        case Se.MODE_8BIT_BYTE:
          return 16;
        case Se.MODE_KANJI:
          return 10;
        default:
          throw new Error("mode:" + t);
      }
    else if (e < 41)
      switch (t) {
        case Se.MODE_NUMBER:
          return 14;
        case Se.MODE_ALPHA_NUM:
          return 13;
        case Se.MODE_8BIT_BYTE:
          return 16;
        case Se.MODE_KANJI:
          return 12;
        default:
          throw new Error("mode:" + t);
      }
    else
      throw new Error("type:" + e);
  },
  getLostPoint: function(t) {
    const e = t.getModuleCount();
    let n = 0;
    for (let a = 0; a < e; a++)
      for (let l = 0; l < e; l++) {
        let o = 0;
        const c = t.isDark(a, l);
        for (let f = -1; f <= 1; f++)
          if (!(a + f < 0 || e <= a + f))
            for (let u = -1; u <= 1; u++)
              l + u < 0 || e <= l + u || f == 0 && u == 0 || c == t.isDark(a + f, l + u) && o++;
        o > 5 && (n += 3 + o - 5);
      }
    for (let a = 0; a < e - 1; a++)
      for (let l = 0; l < e - 1; l++) {
        let o = 0;
        t.isDark(a, l) && o++, t.isDark(a + 1, l) && o++, t.isDark(a, l + 1) && o++, t.isDark(a + 1, l + 1) && o++, (o == 0 || o == 4) && (n += 3);
      }
    for (let a = 0; a < e; a++)
      for (let l = 0; l < e - 6; l++)
        t.isDark(a, l) && !t.isDark(a, l + 1) && t.isDark(a, l + 2) && t.isDark(a, l + 3) && t.isDark(a, l + 4) && !t.isDark(a, l + 5) && t.isDark(a, l + 6) && (n += 40);
    for (let a = 0; a < e; a++)
      for (let l = 0; l < e - 6; l++)
        t.isDark(l, a) && !t.isDark(l + 1, a) && t.isDark(l + 2, a) && t.isDark(l + 3, a) && t.isDark(l + 4, a) && !t.isDark(l + 5, a) && t.isDark(l + 6, a) && (n += 40);
    let r = 0;
    for (let a = 0; a < e; a++)
      for (let l = 0; l < e; l++)
        t.isDark(l, a) && r++;
    const i = Math.abs(100 * r / e / e - 50) / 5;
    return n += i * 10, n;
  }
}, gt = class gt {
  constructor(e, n) {
    this.typeNumber = e, this.errorCorrectLevel = n, this.modules = null, this.moduleCount = 0, this.dataCache = null, this.dataList = [];
  }
  addData(e) {
    const n = new Dl(e);
    this.dataList.push(n), this.dataCache = null;
  }
  isDark(e, n) {
    if (e < 0 || this.moduleCount <= e || n < 0 || this.moduleCount <= n)
      throw new Error(e + "," + n);
    return this.modules[e][n];
  }
  getModuleCount() {
    return this.moduleCount;
  }
  make() {
    if (this.typeNumber < 1) {
      let e = 1;
      for (e = 1; e < 40; e++) {
        const n = Sn.getRSBlocks(e, this.errorCorrectLevel), r = new Nr();
        let i = 0;
        for (let a = 0; a < n.length; a++)
          i += n[a].dataCount;
        for (let a = 0; a < this.dataList.length; a++) {
          const l = this.dataList[a];
          r.put(l.mode, 4), r.put(l.getLength(), J.getLengthInBits(l.mode, e)), l.write(r);
        }
        if (r.getLengthInBits() <= i * 8) break;
      }
      this.typeNumber = e;
    }
    this.makeImpl(!1, this.getBestMaskPattern());
  }
  makeImpl(e, n) {
    this.moduleCount = this.typeNumber * 4 + 17, this.modules = new Array(this.moduleCount);
    for (let r = 0; r < this.moduleCount; r++) {
      this.modules[r] = new Array(this.moduleCount);
      for (let i = 0; i < this.moduleCount; i++)
        this.modules[r][i] = null;
    }
    this.setupPositionProbePattern(0, 0), this.setupPositionProbePattern(this.moduleCount - 7, 0), this.setupPositionProbePattern(0, this.moduleCount - 7), this.setupPositionAdjustPattern(), this.setupTimingPattern(), this.setupTypeInfo(e, n), this.typeNumber >= 7 && this.setupTypeNumber(e), this.dataCache == null && (this.dataCache = gt.createData(
      this.typeNumber,
      this.errorCorrectLevel,
      this.dataList
    )), this.mapData(this.dataCache, n);
  }
  setupPositionProbePattern(e, n) {
    for (let r = -1; r <= 7; r++)
      if (!(e + r <= -1 || this.moduleCount <= e + r))
        for (let i = -1; i <= 7; i++)
          n + i <= -1 || this.moduleCount <= n + i || (0 <= r && r <= 6 && (i == 0 || i == 6) || 0 <= i && i <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= i && i <= 4 ? this.modules[e + r][n + i] = !0 : this.modules[e + r][n + i] = !1);
  }
  getBestMaskPattern() {
    let e = 0, n = 0;
    for (let r = 0; r < 8; r++) {
      this.makeImpl(!0, r);
      const i = J.getLostPoint(this);
      (r == 0 || e > i) && (e = i, n = r);
    }
    return n;
  }
  setupTimingPattern() {
    for (let e = 8; e < this.moduleCount - 8; e++)
      this.modules[e][6] == null && (this.modules[e][6] = e % 2 == 0);
    for (let e = 8; e < this.moduleCount - 8; e++)
      this.modules[6][e] == null && (this.modules[6][e] = e % 2 == 0);
  }
  setupPositionAdjustPattern() {
    const e = J.getPatternPosition(this.typeNumber);
    for (let n = 0; n < e.length; n++)
      for (let r = 0; r < e.length; r++) {
        const i = e[n], a = e[r];
        if (this.modules[i][a] == null)
          for (let l = -2; l <= 2; l++)
            for (let o = -2; o <= 2; o++)
              l == -2 || l == 2 || o == -2 || o == 2 || l == 0 && o == 0 ? this.modules[i + l][a + o] = !0 : this.modules[i + l][a + o] = !1;
      }
  }
  setupTypeNumber(e) {
    const n = J.getBCHTypeNumber(this.typeNumber);
    for (let r = 0; r < 18; r++) {
      const i = !e && (n >> r & 1) == 1;
      this.modules[Math.floor(r / 3)][r % 3 + this.moduleCount - 8 - 3] = i;
    }
    for (let r = 0; r < 18; r++) {
      const i = !e && (n >> r & 1) == 1;
      this.modules[r % 3 + this.moduleCount - 8 - 3][Math.floor(r / 3)] = i;
    }
  }
  setupTypeInfo(e, n) {
    const r = this.errorCorrectLevel << 3 | n, i = J.getBCHTypeInfo(r);
    for (let a = 0; a < 15; a++) {
      const l = !e && (i >> a & 1) == 1;
      a < 6 ? this.modules[a][8] = l : a < 8 ? this.modules[a + 1][8] = l : this.modules[this.moduleCount - 15 + a][8] = l;
    }
    for (let a = 0; a < 15; a++) {
      const l = !e && (i >> a & 1) == 1;
      a < 8 ? this.modules[8][this.moduleCount - a - 1] = l : a < 9 ? this.modules[8][15 - a - 1 + 1] = l : this.modules[8][15 - a - 1] = l;
    }
    this.modules[this.moduleCount - 8][8] = !e;
  }
  mapData(e, n) {
    let r = -1, i = this.moduleCount - 1, a = 7, l = 0;
    for (let o = this.moduleCount - 1; o > 0; o -= 2)
      for (o == 6 && o--; ; ) {
        for (let c = 0; c < 2; c++)
          if (this.modules[i][o - c] == null) {
            let f = !1;
            l < e.length && (f = (e[l] >>> a & 1) == 1), J.getMask(n, i, o - c) && (f = !f), this.modules[i][o - c] = f, a--, a == -1 && (l++, a = 7);
          }
        if (i += r, i < 0 || this.moduleCount <= i) {
          i -= r, r = -r;
          break;
        }
      }
  }
  static createData(e, n, r) {
    const i = Sn.getRSBlocks(e, n), a = new Nr();
    for (let o = 0; o < r.length; o++) {
      const c = r[o];
      a.put(c.mode, 4), a.put(c.getLength(), J.getLengthInBits(c.mode, e)), c.write(a);
    }
    let l = 0;
    for (let o = 0; o < i.length; o++)
      l += i[o].dataCount;
    if (a.getLengthInBits() > l * 8)
      throw new Error(
        "code length overflow. (" + a.getLengthInBits() + ">" + l * 8 + ")"
      );
    for (a.getLengthInBits() + 4 <= l * 8 && a.put(0, 4); a.getLengthInBits() % 8 != 0; )
      a.putBit(!1);
    for (; !(a.getLengthInBits() >= l * 8 || (a.put(gt.PAD0, 8), a.getLengthInBits() >= l * 8)); )
      a.put(gt.PAD1, 8);
    return gt.createBytes(a, i);
  }
  static createBytes(e, n) {
    let r = 0, i = 0, a = 0;
    const l = new Array(n.length), o = new Array(n.length);
    for (let v = 0; v < n.length; v++) {
      const d = n[v].dataCount, _ = n[v].totalCount - d;
      i = Math.max(i, d), a = Math.max(a, _), l[v] = new Array(d);
      for (let p = 0; p < l[v].length; p++)
        l[v][p] = 255 & e.buffer[p + r];
      r += d;
      const g = J.getErrorCorrectPolynomial(_), h = new Vt(l[v], g.getLength() - 1).mod(g);
      o[v] = new Array(g.getLength() - 1);
      for (let p = 0; p < o[v].length; p++) {
        const y = p + h.getLength() - o[v].length;
        o[v][p] = y >= 0 ? h.get(y) : 0;
      }
    }
    let c = 0;
    for (let v = 0; v < n.length; v++)
      c += n[v].totalCount;
    const f = new Array(c);
    let u = 0;
    for (let v = 0; v < i; v++)
      for (let d = 0; d < n.length; d++)
        v < l[d].length && (f[u++] = l[d][v]);
    for (let v = 0; v < a; v++)
      for (let d = 0; d < n.length; d++)
        v < o[d].length && (f[u++] = o[d][v]);
    return f;
  }
};
gt.PAD0 = 236, gt.PAD1 = 17;
let sr = gt;
function Hl(t, e = "L", n = -1) {
  try {
    const r = new sr(n, an[e]), i = [];
    r.addData(t), r.make();
    const a = r.modules, l = a.length;
    for (const [c, f] of a.entries()) {
      let u;
      for (const [v, d] of f.entries())
        d ? (u || (u = { x: v, y: c, width: 0, height: 1 }), u.width++) : (u && u.width > 0 && i.push(u), u = void 0);
      u && u.width > 0 && i.push(u);
    }
    const o = [
      `<svg xmlns="http://www.w3.org/2000/svg" width="300" viewBox="0 0 ${l} ${l}">`
    ];
    for (const { x: c, y: f, width: u, height: v } of i)
      o.push(`<rect x="${c}" y="${f}" width="${u}" height="${v}" />`);
    return o.push("</svg>"), o.join("");
  } catch {
  }
}
var Il = /* @__PURE__ */ L('<div class="qr svelte-14k3qh1"><div class="qr-container svelte-14k3qh1"></div></div>'), ql = /* @__PURE__ */ L('<p class="qr-fallback svelte-14k3qh1"> </p>');
function Fl(t, e) {
  W(e, !0);
  const n = {
    en: pe,
    ko: me,
    "zh-Hans": we,
    "zh-Hant": ke,
    tr: be
  }, r = /* @__PURE__ */ E(() => ye(n));
  let i = /* @__PURE__ */ R(""), a = /* @__PURE__ */ R(!1);
  He(() => {
    if (e.data)
      try {
        const u = Hl(e.data);
        A(i, u || "", !0), A(a, !u);
      } catch {
        A(i, ""), A(a, !0);
      }
  });
  var l = ne(), o = K(l);
  {
    var c = (u) => {
      var v = Il(), d = w(v);
      ss(d, () => s(i), !0), k(u, v);
    }, f = (u) => {
      var v = ql(), d = w(v);
      z((_) => P(d, _), [() => s(r)(62)]), k(u, v);
    };
    H(o, (u) => {
      s(i) ? u(c) : s(a) && u(f, 1);
    });
  }
  k(t, l), X();
}
var jl = /* @__PURE__ */ L('<textarea class="prompt-textarea svelte-19pbf8u" readonly="" rows="9" spellcheck="false"></textarea>');
function Kl(t, e) {
  W(e, !0);
  let n = /* @__PURE__ */ E(() => typeof e.data == "string" ? e.data : e.data?.content ?? "");
  var r = jl();
  z(() => vs(r, s(n))), k(t, r), X();
}
var Ul = /* @__PURE__ */ L('<div class="waiting svelte-1hxwvxp"><!> <p class="waiting-label svelte-1hxwvxp"> </p></div>'), Gl = /* @__PURE__ */ L('<div class="actions svelte-1hxwvxp"><!> <!></div>'), Yl = /* @__PURE__ */ L('<!> <!> <div class="elements svelte-1hxwvxp"></div> <!>', 1);
function Vl(t, e) {
  W(e, !0);
  const n = {
    en: pe,
    ko: me,
    "zh-Hans": we,
    "zh-Hant": ke,
    tr: be
  }, r = /* @__PURE__ */ E(() => ye(n));
  let i = ue(e, "body", 3, ""), a = /* @__PURE__ */ E(() => x.promptElements.length > 0 && !x.promptElements.some((_) => _.type === "accept" || _.type === "button" || _.type === "link"));
  var l = Yl(), o = K(l);
  bt(o, {
    get title() {
      return e.title;
    },
    get subtitle() {
      return i();
    },
    get onclose() {
      return e.onclose;
    }
  });
  var c = T(o, 2);
  {
    var f = (_) => {
      var g = Ul(), m = w(g);
      gn(m, {});
      var h = T(m, 2), p = w(h);
      z((y) => P(p, y), [() => s(r)(10)]), k(_, g);
    };
    H(c, (_) => {
      x.promptElements.length === 0 && _(f);
    });
  }
  var u = T(c, 2);
  Re(u, 21, () => x.promptElements, Be, (_, g) => {
    var m = ne(), h = K(m);
    {
      var p = (B) => {
        Al(B, {
          get data() {
            return s(g).data;
          }
        });
      }, y = (B) => {
        Pl(B, {
          get oncomplete() {
            return e.onconfirm;
          },
          get oncancel() {
            return e.onclose;
          }
        });
      }, b = (B) => {
        Ll(B, {
          get data() {
            return s(g).data;
          }
        });
      }, S = (B) => {
        Ol(B, {
          get data() {
            return s(g).data;
          }
        });
      }, N = (B) => {
        Rl(B, {
          get data() {
            return s(g).data;
          }
        });
      }, M = (B) => {
        Fl(B, {
          get data() {
            return s(g).data;
          }
        });
      }, O = (B) => {
        Kl(B, {
          get data() {
            return s(g).data;
          }
        });
      };
      H(h, (B) => {
        s(g).type === "asset" ? B(p) : s(g).type === "accept" ? B(y, 1) : s(g).type === "countdown" ? B(b, 2) : s(g).type === "link" ? B(S, 3) : s(g).type === "button" ? B(N, 4) : s(g).type === "qr" ? B(M, 5) : s(g).type === "textarea" && B(O, 6);
      });
    }
    k(_, m);
  });
  var v = T(u, 2);
  {
    var d = (_) => {
      var g = Gl(), m = w(g);
      ae(m, {
        variant: "secondary",
        get onclick() {
          return e.onclose;
        },
        children: (p, y) => {
          var b = ee();
          z((S) => P(b, S), [() => s(r)(11)]), k(p, b);
        },
        $$slots: { default: !0 }
      });
      var h = T(m, 2);
      ae(h, {
        get onclick() {
          return e.onconfirm;
        },
        children: (p, y) => {
          var b = ee();
          z((S) => P(b, S), [() => s(r)(12)]), k(p, b);
        },
        $$slots: { default: !0 }
      }), k(_, g);
    };
    H(v, (_) => {
      s(a) && _(d);
    });
  }
  k(t, l), X();
}
var Wl = /* @__PURE__ */ L('<li class="sk-permission-item warning svelte-qgdoxk"><svg class="sk-warn-icon svelte-qgdoxk" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 1.5L14.5 13H1.5L8 1.5z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"></path><path d="M8 6v3M8 11v.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path></svg> <span> <span class="action-note svelte-qgdoxk"> </span></span></li>'), Xl = /* @__PURE__ */ L('<span class="contract-hint svelte-qgdoxk"> </span>'), Ql = /* @__PURE__ */ L('<li class="sk-permission-item neutral svelte-qgdoxk"><span class="sk-bullet svelte-qgdoxk">–</span> <span> <!></span></li>'), Jl = /* @__PURE__ */ L('<li class="sk-permission-item warning svelte-qgdoxk"><svg class="sk-warn-icon svelte-qgdoxk" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 1.5L14.5 13H1.5L8 1.5z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"></path><path d="M8 6v3M8 11v.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path></svg> <span> </span></li>'), Zl = /* @__PURE__ */ L('<div class="sk-contract-group svelte-qgdoxk"><div class="sk-contract-header svelte-qgdoxk"> </div> <ul class="sk-permissions-list svelte-qgdoxk"><!></ul></div>'), $l = /* @__PURE__ */ L('<li class="sk-permission-item warning svelte-qgdoxk"><svg class="sk-warn-icon svelte-qgdoxk" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 1.5L14.5 13H1.5L8 1.5z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"></path><path d="M8 6v3M8 11v.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path></svg> <span><!></span></li>'), eo = /* @__PURE__ */ L('<ul class="sk-permissions-list svelte-qgdoxk"></ul>'), to = /* @__PURE__ */ L('<div class="sk-details svelte-qgdoxk"><div class="sk-section-label svelte-qgdoxk"><!></div> <!> <div class="sk-boundary svelte-qgdoxk"> </div></div>'), no = /* @__PURE__ */ L('<p class="sk-about svelte-qgdoxk"> </p>'), ro = /* @__PURE__ */ L('<!> <div class="sk-body svelte-qgdoxk"><p class="sk-description svelte-qgdoxk"><!></p> <button class="sk-summary-badge svelte-qgdoxk"><span class="sk-summary-left svelte-qgdoxk"><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="7" stroke="var(--web-ui-text-secondary)" stroke-width="1.5"></circle><path d="M8 7v4M8 5.5v.5" stroke="var(--web-ui-text-secondary)" stroke-width="1.5" stroke-linecap="round"></path></svg> <span><!></span></span> <span class="sk-toggle svelte-qgdoxk"> </span></button> <!> <button class="sk-about-toggle svelte-qgdoxk"> </button> <!> <div class="sk-info-note svelte-qgdoxk"><!></div></div> <div class="actions svelte-qgdoxk"><!> <!></div>', 1);
function io(t, e) {
  W(e, !0);
  const n = (C, D = Wn, Z = Wn) => {
    var de = ne(), je = K(de);
    {
      var yt = (ft) => {
        var ve = Wl(), Ke = T(w(ve), 2), it = w(Ke), Xe = T(it), Qe = w(Xe);
        z(
          (Je) => {
            P(it, `${D() ?? ""} `), P(Qe, Je);
          },
          [() => s(d)(23)]
        ), k(ft, ve);
      }, Qt = /* @__PURE__ */ E(() => i(D())), Rn = (ft) => {
        var ve = Ql(), Ke = T(w(ve), 2), it = w(Ke), Xe = T(it);
        {
          var Qe = (Je) => {
            var xt = Xl(), Jt = w(xt);
            z(() => P(Jt, `(${Z() ?? ""})`)), k(Je, xt);
          };
          H(Xe, (Je) => {
            Z() && Je(Qe);
          });
        }
        z(() => P(it, D())), k(ft, ve);
      };
      H(je, (ft) => {
        s(Qt) ? ft(yt) : ft(Rn, -1);
      });
    }
    k(C, de);
  }, r = /* @__PURE__ */ new Set(["transfer", "withdraw", "transferfrom"]);
  function i(C) {
    return r.has(C.toLowerCase());
  }
  let a = /* @__PURE__ */ E(() => x.skWhitelist.map((C) => ({
    contract: C.contract,
    actions: C.actions && C.actions.length > 0 ? C.actions : [],
    isAllActions: !C.actions || C.actions.length === 0
  }))), l = /* @__PURE__ */ E(() => s(a).reduce((C, D) => C + (D.isAllActions ? 1 : D.actions.length), 0)), o = /* @__PURE__ */ E(() => s(a).length), c = /* @__PURE__ */ E(() => s(a).some((C) => C.isAllActions)), f = /* @__PURE__ */ E(() => s(c) || s(l) > 8 || s(o) > 2), u = /* @__PURE__ */ E(() => s(l) > 3);
  const v = {
    en: pe,
    ko: me,
    "zh-Hans": we,
    "zh-Hant": ke,
    tr: be
  }, d = /* @__PURE__ */ E(() => ye(v));
  let _ = /* @__PURE__ */ E(() => x.skAppName ? s(d)(21, [x.skAppName]) : s(d)(22)), g = /* @__PURE__ */ R(!1), m = /* @__PURE__ */ R(!1), h = !1;
  He(() => {
    s(f) && !h && (A(g, !0), h = !0);
  });
  var p = ro(), y = K(p);
  bt(y, {
    get title() {
      return s(_);
    },
    get onclose() {
      return e.onclose;
    }
  });
  var b = T(y, 2), S = w(b), N = w(S);
  {
    let C = /* @__PURE__ */ E(() => s(d).c(24)), D = /* @__PURE__ */ E(() => [x.skAppName]);
    ze(N, {
      get x() {
        return s(C);
      },
      get a() {
        return s(D);
      }
    });
  }
  var M = T(S, 2), O = w(M), B = T(w(O), 2), Q = w(B);
  {
    let C = /* @__PURE__ */ E(() => s(d).c(25)), D = /* @__PURE__ */ E(() => [
      s(l),
      s(l) !== 1 ? "s" : "",
      s(o),
      s(o) !== 1 ? "s" : ""
    ]);
    ze(Q, {
      get x() {
        return s(C);
      },
      get a() {
        return s(D);
      }
    });
  }
  var I = T(O, 2), Y = w(I), V = T(M, 2);
  {
    var se = (C) => {
      var D = to(), Z = w(D), de = w(Z);
      {
        let ve = /* @__PURE__ */ E(() => s(d).c(28)), Ke = /* @__PURE__ */ E(() => [x.skAppName]);
        ze(de, {
          get x() {
            return s(ve);
          },
          get a() {
            return s(Ke);
          }
        });
      }
      var je = T(Z, 2);
      {
        var yt = (ve) => {
          var Ke = ne(), it = K(Ke);
          Re(it, 17, () => s(a), Be, (Xe, Qe) => {
            var Je = Zl(), xt = w(Je), Jt = w(xt), dt = T(xt, 2), Et = w(dt);
            {
              var Zt = (Ze) => {
                var Tt = Jl(), Dn = T(w(Tt), 2), Hn = w(Dn);
                z((In) => P(Hn, In), [() => s(d)(29)]), k(Ze, Tt);
              }, $t = (Ze) => {
                var Tt = ne(), Dn = K(Tt);
                Re(Dn, 17, () => s(Qe).actions, Be, (Hn, In) => {
                  n(Hn, () => s(In), () => {
                  });
                }), k(Ze, Tt);
              };
              H(Et, (Ze) => {
                s(Qe).isAllActions ? Ze(Zt) : Ze($t, -1);
              });
            }
            z(() => P(Jt, s(Qe).contract)), k(Xe, Je);
          }), k(ve, Ke);
        }, Qt = (ve) => {
          var Ke = eo();
          Re(Ke, 21, () => s(a), Be, (it, Xe) => {
            var Qe = ne(), Je = K(Qe);
            {
              var xt = (dt) => {
                var Et = $l(), Zt = T(w(Et), 2), $t = w(Zt);
                {
                  let Ze = /* @__PURE__ */ E(() => s(d).c(30)), Tt = /* @__PURE__ */ E(() => [s(Xe).contract]);
                  ze($t, {
                    get x() {
                      return s(Ze);
                    },
                    get a() {
                      return s(Tt);
                    }
                  });
                }
                k(dt, Et);
              }, Jt = (dt) => {
                var Et = ne(), Zt = K(Et);
                Re(Zt, 17, () => s(Xe).actions, Be, ($t, Ze) => {
                  n($t, () => s(Ze), () => s(Xe).contract);
                }), k(dt, Et);
              };
              H(Je, (dt) => {
                s(Xe).isAllActions ? dt(xt) : dt(Jt, -1);
              });
            }
            k(it, Qe);
          }), k(ve, Ke);
        };
        H(je, (ve) => {
          s(u) ? ve(yt) : ve(Qt, -1);
        });
      }
      var Rn = T(je, 2), ft = w(Rn);
      z((ve) => P(ft, ve), [() => s(d)(31)]), k(C, D);
    };
    H(V, (C) => {
      s(g) && C(se);
    });
  }
  var U = T(V, 2), xe = w(U), he = T(U, 2);
  {
    var Fe = (C) => {
      var D = no(), Z = w(D);
      z((de) => P(Z, de), [() => s(d)(33)]), k(C, D);
    };
    H(he, (C) => {
      s(m) && C(Fe);
    });
  }
  var Le = T(he, 2), Ne = w(Le);
  {
    let C = /* @__PURE__ */ E(() => s(d).c(34)), D = /* @__PURE__ */ E(() => [x.skAppName]);
    ze(Ne, {
      get x() {
        return s(C);
      },
      get a() {
        return s(D);
      }
    });
  }
  var G = T(b, 2), le = w(G);
  ae(le, {
    variant: "secondary",
    get onclick() {
      return e.onclose;
    },
    children: (C, D) => {
      var Z = ee();
      z((de) => P(Z, de), [() => s(d)(35)]), k(C, Z);
    },
    $$slots: { default: !0 }
  });
  var oe = T(le, 2);
  ae(oe, {
    get onclick() {
      return e.onapprove;
    },
    children: (C, D) => {
      var Z = ee();
      z((de) => P(Z, de), [() => s(d)(36)]), k(C, Z);
    },
    $$slots: { default: !0 }
  }), z(
    (C, D) => {
      Ae(M, "aria-expanded", s(g)), P(Y, C), Ae(U, "aria-expanded", s(m)), P(xe, D);
    },
    [
      () => s(g) ? s(d)(26) : s(d)(27),
      () => s(d)(32)
    ]
  ), ct("click", M, () => A(g, !s(g))), ct("click", U, () => A(m, !s(m))), k(t, p), X();
}
Bt(["click"]);
var ao = /* @__PURE__ */ L("<strong> </strong>"), so = /* @__PURE__ */ L('<!> <div class="sk-body svelte-1kb26es"><div class="sk-app-name svelte-1kb26es"> </div> <p class="sk-description svelte-1kb26es"><!></p> <div class="options svelte-1kb26es"><label><input type="radio" class="svelte-1kb26es"/> <div class="option-content svelte-1kb26es"><span class="option-title svelte-1kb26es"> </span> <span class="option-subtitle svelte-1kb26es"> </span></div></label> <label><input type="radio" class="svelte-1kb26es"/> <div class="option-content svelte-1kb26es"><span class="option-title svelte-1kb26es"> </span> <span class="option-subtitle svelte-1kb26es"> </span></div></label></div> <div class="sk-info-note svelte-1kb26es"><!></div></div> <div class="actions svelte-1kb26es"><!> <!></div>', 1);
function lo(t, e) {
  W(e, !0);
  const n = [], r = {
    en: pe,
    ko: me,
    "zh-Hans": we,
    "zh-Hant": ke,
    tr: be
  }, i = /* @__PURE__ */ E(() => ye(r));
  let a = /* @__PURE__ */ R("add"), l = /* @__PURE__ */ E(() => x.skExistingKeyCount === 1 ? "another device" : `${x.skExistingKeyCount} other devices`);
  var o = so(), c = K(o);
  {
    let G = /* @__PURE__ */ E(() => s(i)(13));
    bt(c, {
      get title() {
        return s(G);
      },
      get onclose() {
        return e.onclose;
      }
    });
  }
  var f = T(c, 2), u = w(f), v = w(u), d = T(u, 2);
  {
    const G = (le) => {
      var oe = ao(), C = w(oe);
      z(() => P(C, s(l))), k(le, oe);
    };
    var _ = w(d);
    {
      let le = /* @__PURE__ */ E(() => [G]), oe = /* @__PURE__ */ E(() => s(i).c(14));
      ze(_, {
        get t() {
          return s(le);
        },
        get x() {
          return s(oe);
        }
      });
    }
  }
  var g = T(d, 2), m = w(g);
  let h;
  var p = w(m);
  p.value = p.__value = "add";
  var y = T(p, 2), b = w(y), S = w(b), N = T(b, 2), M = w(N), O = T(m, 2);
  let B;
  var Q = w(O);
  Q.value = Q.__value = "replace";
  var I = T(Q, 2), Y = w(I), V = w(Y), se = T(Y, 2), U = w(se), xe = T(g, 2), he = w(xe);
  {
    let G = /* @__PURE__ */ E(() => s(i).c(19)), le = /* @__PURE__ */ E(() => [x.skAppName]);
    ze(he, {
      get x() {
        return s(G);
      },
      get a() {
        return s(le);
      }
    });
  }
  var Fe = T(f, 2), Le = w(Fe);
  ae(Le, {
    variant: "secondary",
    onclick: () => e.onselect?.("cancel"),
    children: (G, le) => {
      var oe = ee();
      z((C) => P(oe, C), [() => s(i)(11)]), k(G, oe);
    },
    $$slots: { default: !0 }
  });
  var Ne = T(Le, 2);
  ae(Ne, {
    onclick: () => e.onselect?.(s(a)),
    children: (G, le) => {
      var oe = ee();
      z((C) => P(oe, C), [() => s(i)(20)]), k(G, oe);
    },
    $$slots: { default: !0 }
  }), z(
    (G, le, oe, C) => {
      P(v, x.skAppName), h = Ot(m, 1, "svelte-1kb26es", null, h, { selected: s(a) === "add" }), P(S, G), P(M, le), B = Ot(O, 1, "svelte-1kb26es", null, B, { selected: s(a) === "replace" }), P(V, oe), P(U, C);
    },
    [
      () => s(i)(15),
      () => s(i)(16),
      () => s(i)(17),
      () => s(i)(18)
    ]
  ), Pr(n, [], p, () => s(a), (G) => A(a, G)), Pr(n, [], Q, () => s(a), (G) => A(a, G)), k(t, o), X();
}
var oo = /* @__PURE__ */ L('<li class="sk-permission-item added svelte-5mdirq"><span class="sk-indicator added svelte-5mdirq">+</span> <span> </span></li>'), Or = /* @__PURE__ */ L('<div class="sk-section svelte-5mdirq"><div class="sk-section-label svelte-5mdirq"> </div> <ul class="sk-permissions-list svelte-5mdirq"></ul></div>'), co = /* @__PURE__ */ L('<li class="sk-permission-item removed svelte-5mdirq"><span class="sk-indicator removed svelte-5mdirq">−</span> <span> </span></li>'), uo = /* @__PURE__ */ L('<!> <div class="sk-body svelte-5mdirq"><div class="sk-app-name svelte-5mdirq"> </div> <p class="sk-description svelte-5mdirq"> </p> <!> <!></div> <div class="actions svelte-5mdirq"><!> <!></div>', 1);
function fo(t, e) {
  W(e, !0);
  const n = {
    en: pe,
    ko: me,
    "zh-Hans": we,
    "zh-Hant": ke,
    tr: be
  }, r = /* @__PURE__ */ E(() => ye(n));
  function i(N) {
    const M = [];
    for (const O of N)
      if (O.actions && O.actions.length > 0)
        for (const B of O.actions)
          M.push(`${B} (${O.contract})`);
      else
        M.push(s(r)(41, [O.contract]));
    return M;
  }
  let a = /* @__PURE__ */ E(() => i(x.skAdded)), l = /* @__PURE__ */ E(() => i(x.skRemoved));
  var o = uo(), c = K(o);
  {
    let N = /* @__PURE__ */ E(() => s(r)(13));
    bt(c, {
      get title() {
        return s(N);
      },
      get onclose() {
        return e.onclose;
      }
    });
  }
  var f = T(c, 2), u = w(f), v = w(u), d = T(u, 2), _ = w(d), g = T(d, 2);
  {
    var m = (N) => {
      var M = Or(), O = w(M), B = w(O), Q = T(O, 2);
      Re(Q, 21, () => s(a), Be, (I, Y) => {
        var V = oo(), se = T(w(V), 2), U = w(se);
        z(() => P(U, s(Y))), k(I, V);
      }), z((I) => P(B, I), [() => s(r)(43)]), k(N, M);
    };
    H(g, (N) => {
      x.skAdded.length > 0 && N(m);
    });
  }
  var h = T(g, 2);
  {
    var p = (N) => {
      var M = Or(), O = w(M), B = w(O), Q = T(O, 2);
      Re(Q, 21, () => s(l), Be, (I, Y) => {
        var V = co(), se = T(w(V), 2), U = w(se);
        z(() => P(U, s(Y))), k(I, V);
      }), z((I) => P(B, I), [() => s(r)(44)]), k(N, M);
    };
    H(h, (N) => {
      x.skRemoved.length > 0 && N(p);
    });
  }
  var y = T(f, 2), b = w(y);
  ae(b, {
    variant: "secondary",
    onclick: () => e.onselect?.("dismiss"),
    children: (N, M) => {
      var O = ee();
      z((B) => P(O, B), [() => s(r)(35)]), k(N, O);
    },
    $$slots: { default: !0 }
  });
  var S = T(b, 2);
  ae(S, {
    onclick: () => e.onselect?.("update"),
    children: (N, M) => {
      var O = ee();
      z((B) => P(O, B), [() => s(r)(45)]), k(N, O);
    },
    $$slots: { default: !0 }
  }), z(
    (N) => {
      P(v, x.skAppName), P(_, N);
    },
    [() => s(r)(42)]
  ), k(t, o), X();
}
var vo = /* @__PURE__ */ L('<!> <div class="sk-body svelte-17kifxa"><div class="sk-app-name svelte-17kifxa"> </div> <p class="sk-description svelte-17kifxa"> </p> <div class="sk-info-note svelte-17kifxa"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" class="svelte-17kifxa"><circle cx="8" cy="8" r="7" stroke="var(--web-ui-text-secondary)" stroke-width="1.5"></circle><path d="M8 7v4M8 5.5v.5" stroke="var(--web-ui-text-secondary)" stroke-width="1.5" stroke-linecap="round"></path></svg> <span> </span></div></div> <div class="actions svelte-17kifxa"><!> <!></div>', 1);
function ho(t, e) {
  W(e, !0);
  const n = {
    en: pe,
    ko: me,
    "zh-Hans": we,
    "zh-Hant": ke,
    tr: be
  }, r = /* @__PURE__ */ E(() => ye(n));
  var i = vo(), a = K(i);
  {
    let p = /* @__PURE__ */ E(() => s(r)(13));
    bt(a, {
      get title() {
        return s(p);
      },
      get onclose() {
        return e.onclose;
      }
    });
  }
  var l = T(a, 2), o = w(l), c = w(o), f = T(o, 2), u = w(f), v = T(f, 2), d = T(w(v), 2), _ = w(d), g = T(l, 2), m = w(g);
  ae(m, {
    variant: "secondary",
    get onclick() {
      return e.onclose;
    },
    children: (p, y) => {
      var b = ee();
      z((S) => P(b, S), [() => s(r)(39)]), k(p, b);
    },
    $$slots: { default: !0 }
  });
  var h = T(m, 2);
  ae(h, {
    get onclick() {
      return e.onconfirm;
    },
    children: (p, y) => {
      var b = ee();
      z((S) => P(b, S), [() => s(r)(40)]), k(p, b);
    },
    $$slots: { default: !0 }
  }), z(
    (p, y) => {
      P(c, x.skAppName), P(u, p), P(_, y);
    },
    [() => s(r)(37), () => s(r)(38)]
  ), k(t, i), X();
}
function go(t, e) {
  W(e, !0);
  let n = ue(e, "closeOnOverlayClick", 3, !0), r = ue(e, "closeOnEscape", 3, !0);
  bs(t, {
    get closeOnOverlayClick() {
      return n();
    },
    get closeOnEscape() {
      return r();
    },
    get onclose() {
      return e.oncancel;
    },
    children: (i, a) => {
      var l = ne(), o = K(l);
      {
        var c = (h) => {
          gl(h, {
            get onclose() {
              return e.oncancel;
            },
            get oncomplete() {
              return e.onlogincomplete;
            }
          });
        }, f = (h) => {
          Tl(h, {
            get onclose() {
              return e.oncancel;
            },
            get ondone() {
              return e.ontransactdone;
            }
          });
        }, u = (h) => {
          Vl(h, {
            get title() {
              return x.promptTitle;
            },
            get body() {
              return x.promptBody;
            },
            get onclose() {
              return e.oncancel;
            },
            get onconfirm() {
              return e.onpromptconfirm;
            }
          });
        }, v = (h) => {
          Is(h, {
            get message() {
              return x.errorMessage;
            },
            get details() {
              return x.errorDetails;
            },
            get onclose() {
              return e.oncancel;
            }
          });
        }, d = (h) => {
          io(h, {
            get onclose() {
              return e.oncancel;
            },
            get onapprove() {
              return e.onskconsentapprove;
            }
          });
        }, _ = (h) => {
          lo(h, {
            get onclose() {
              return e.oncancel;
            },
            get onselect() {
              return e.onskconflictselect;
            }
          });
        }, g = (h) => {
          fo(h, {
            get onclose() {
              return e.oncancel;
            },
            get onselect() {
              return e.onskmismatchselect;
            }
          });
        }, m = (h) => {
          ho(h, {
            get onclose() {
              return e.oncancel;
            },
            get onconfirm() {
              return e.onskremoveconfirm;
            }
          });
        };
        H(o, (h) => {
          x.view === "login" ? h(c) : x.view === "transact" ? h(f, 1) : x.view === "prompt" ? h(u, 2) : x.view === "error" ? h(v, 3) : x.view === "sk-consent" ? h(d, 4) : x.view === "sk-conflict" ? h(_, 5) : x.view === "sk-mismatch" ? h(g, 6) : x.view === "sk-remove" && h(m, 7);
        });
      }
      k(i, l);
    },
    $$slots: { default: !0 }
  }), X();
}
let _o = ["Something went wrong.", "The request was cancelled.", "Couldn't reach the network. Check your connection and try again.", "The transaction expired before it completed. Please try again.", "Your account needs more network resources (CPU, NET, or RAM) to complete this.", "Insufficient balance to complete this transaction.", "The transaction could not be completed."];
const po = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  c: _o
}, Symbol.toStringTag, { value: "Module" }));
let mo = ["문제가 발생했습니다.", "요청이 취소되었습니다.", "네트워크에 연결할 수 없습니다. 연결 상태를 확인한 후 다시 시도하세요.", "거래가 완료되기 전에 만료되었습니다. 다시 시도하세요.", "이 작업을 완료하려면 계정에 더 많은 네트워크 리소스(CPU, NET 또는 RAM)가 필요합니다.", "이 거래를 완료하기에 잔액이 부족합니다.", "거래를 완료할 수 없습니다."];
const wo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  c: mo
}, Symbol.toStringTag, { value: "Module" }));
let ko = ["出了点问题。", "请求已取消。", "无法连接到网络。请检查您的连接后重试。", "交易在完成前已过期。请重试。", "您的账户需要更多网络资源（CPU、NET 或 RAM）才能完成此操作。", "余额不足，无法完成此交易。", "无法完成此交易。"];
const bo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  c: ko
}, Symbol.toStringTag, { value: "Module" }));
let yo = ["發生錯誤。", "請求已取消。", "無法連線至網路。請檢查您的連線，然後再試一次。", "交易在完成前已逾時。請再試一次。", "您的帳戶需要更多網路資源（CPU、NET 或 RAM）才能完成此操作。", "餘額不足，無法完成此交易。", "無法完成交易。"];
const xo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  c: yo
}, Symbol.toStringTag, { value: "Module" }));
let Eo = ["Bir şeyler ters gitti.", "İstek iptal edildi.", "Ağa ulaşılamadı. Bağlantınızı kontrol edip tekrar deneyin.", "İşlem tamamlanmadan önce zaman aşımına uğradı. Lütfen tekrar deneyin.", "Bunu tamamlamak için hesabınızın daha fazla ağ kaynağına (CPU, NET veya RAM) ihtiyacı var.", "Bu işlemi tamamlamak için yeterli bakiye yok.", "İşlem tamamlanamadı."];
const To = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  c: Eo
}, Symbol.toStringTag, { value: "Module" }));
let lr = zi[0];
function Co(t) {
  lr = t;
}
const Ao = (t) => Pi(t[lr], lr);
function So(t) {
  return t.length > 0 ? t.charAt(0).toUpperCase() + t.slice(1) : t;
}
const Po = { en: po, ko: wo, "zh-Hans": bo, "zh-Hant": xo, tr: To };
function zo(t) {
  const e = t instanceof Error ? t.message : String(t ?? ""), n = Ao(Po);
  if (!e.trim()) return { message: n(0), details: "" };
  const r = e.toLowerCase(), i = (l) => ({ message: l, details: e }), a = e.match(/assertion failure with message:\s*(.+)/i);
  return a ? i(So(a[1].trim())) : r.includes("cancel") || r.includes("rejected") || r.includes("declined") ? i(n(1)) : r.includes("failed to fetch") || r.includes("networkerror") || r.includes("network request failed") || r.includes("timeout") || r.includes("timed out") || r.includes("econnrefused") || r.includes("enotfound") ? i(n(2)) : r.includes("expired") || r.includes("expiration") ? i(n(3)) : r.includes("insufficient ram") || r.includes("billed") || r.includes("cpu usage") || r.includes("net usage") || r.includes("resources") ? i(
    n(4)
  ) : r.includes("overdrawn") || r.includes("insufficient funds") ? i(n(5)) : e.length <= 120 ? { message: e, details: "" } : { message: n(6), details: e };
}
const Mo = {
  theme: "auto",
  closeOnOverlayClick: !0,
  closeOnEscape: !0,
  zIndex: 999999,
  logging: !1,
  minimal: !1
}, Lo = ':host{color-scheme:light;--web-ui-bg: oklch(.995 .002 75);--web-ui-surface: oklch(.97 .003 75);--web-ui-text: oklch(.22 .008 75);--web-ui-text-secondary: oklch(.52 .006 75);--web-ui-border: oklch(.9 .004 75);--web-ui-backdrop: oklch(.22 .008 75 / .35);--web-ui-shadow: 0 10px 30px -12px oklch(.22 .008 75 / .18);--web-ui-success: oklch(.62 .11 155);--web-ui-error: oklch(.58 .15 28);--web-ui-warning: oklch(.72 .14 70);--web-ui-accent: oklch(.22 .008 75);--web-ui-accent-hover: oklch(.32 .008 75);--web-ui-accent-text: oklch(.995 .002 75);--web-ui-ring: oklch(.22 .008 75);--web-ui-radius: 12px;--web-ui-radius-sm: 8px;--web-ui-radius-xs: 4px;--web-ui-font: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI Variable", "Segoe UI", Roboto, sans-serif;--web-ui-font-mono: ui-monospace, "SF Mono", "Fira Code", "Fira Mono", "Roboto Mono", monospace;--web-ui-ease: cubic-bezier(.22, 1, .36, 1);font-variant-numeric:tabular-nums}@media(prefers-color-scheme:dark){:host(:not([data-theme="light"])){color-scheme:dark;--web-ui-bg: oklch(.18 .006 75);--web-ui-surface: oklch(.22 .008 75);--web-ui-text: oklch(.95 .003 75);--web-ui-text-secondary: oklch(.66 .006 75);--web-ui-border: oklch(.28 .008 75);--web-ui-backdrop: oklch(.1 .005 75 / .55);--web-ui-shadow: 0 10px 30px -12px oklch(0 0 0 / .5);--web-ui-success: oklch(.7 .11 155);--web-ui-error: oklch(.66 .15 28);--web-ui-warning: oklch(.78 .13 70);--web-ui-accent: oklch(.95 .003 75);--web-ui-accent-hover: oklch(.85 .003 75);--web-ui-accent-text: oklch(.18 .006 75);--web-ui-ring: oklch(.95 .003 75)}}:host([data-theme="dark"]){color-scheme:dark;--web-ui-bg: oklch(.18 .006 75);--web-ui-surface: oklch(.22 .008 75);--web-ui-text: oklch(.95 .003 75);--web-ui-text-secondary: oklch(.66 .006 75);--web-ui-border: oklch(.28 .008 75);--web-ui-backdrop: oklch(.1 .005 75 / .55);--web-ui-shadow: 0 10px 30px -12px oklch(0 0 0 / .5);--web-ui-success: oklch(.7 .11 155);--web-ui-error: oklch(.66 .15 28);--web-ui-warning: oklch(.78 .13 70);--web-ui-accent: oklch(.95 .003 75);--web-ui-accent-hover: oklch(.85 .003 75);--web-ui-accent-text: oklch(.18 .006 75);--web-ui-ring: oklch(.95 .003 75)}', No = ".web-ui-overlay.svelte-133dbco{position:fixed;inset:0;display:flex;align-items:center;justify-content:center;background:var(--web-ui-backdrop);opacity:0;transition:opacity .2s ease-out;z-index:1}.web-ui-overlay.visible.svelte-133dbco{opacity:1}.web-ui-overlay.mobile.svelte-133dbco{align-items:flex-end}.web-ui-modal.svelte-133dbco{background:var(--web-ui-bg);border-radius:var(--web-ui-radius);box-shadow:var(--web-ui-shadow);width:100%;max-width:400px;max-height:85vh;overflow-y:auto;font-family:var(--web-ui-font);color:var(--web-ui-text);padding:24px;transform:scale(.95) translateY(10px);transition:transform .2s ease-out}.web-ui-overlay.visible.svelte-133dbco .web-ui-modal:where(.svelte-133dbco){transform:scale(1) translateY(0)}.web-ui-modal.mobile.svelte-133dbco{max-width:100%;max-height:90vh;border-radius:16px 16px 0 0;padding:12px 24px 24px;transform:translateY(100%)}.web-ui-overlay.visible.svelte-133dbco .web-ui-modal.mobile:where(.svelte-133dbco){transform:translateY(0)}.drag-handle.svelte-133dbco{display:flex;justify-content:center;padding:4px 0 16px}.drag-handle.svelte-133dbco span:where(.svelte-133dbco){display:block;width:36px;height:4px;border-radius:2px;background:var(--web-ui-border)}@media(prefers-reduced-motion:reduce){.web-ui-overlay.svelte-133dbco,.web-ui-modal.svelte-133dbco{transition:none}}.header.svelte-8nabiy{display:flex;align-items:flex-start;justify-content:space-between;gap:12px;margin-bottom:20px}.header-text.svelte-8nabiy{flex:1;min-width:0}h2.svelte-8nabiy{margin:0;font-size:20px;font-weight:600;letter-spacing:-.01em;color:var(--web-ui-text);font-family:var(--web-ui-font);line-height:1.25}.subtitle.svelte-8nabiy{margin:6px 0 0;font-size:13px;font-weight:500;color:var(--web-ui-text-secondary);font-family:var(--web-ui-font);line-height:1.45}.icon-btn.svelte-8nabiy{display:flex;align-items:center;justify-content:center;width:32px;height:32px;border:none;border-radius:var(--web-ui-radius-sm);background:var(--web-ui-surface);color:var(--web-ui-text-secondary);cursor:pointer;transition:background .15s ease,color .15s ease;padding:0;flex-shrink:0}.icon-btn.svelte-8nabiy:hover{background:var(--web-ui-border);color:var(--web-ui-text)}.icon-btn.svelte-8nabiy:focus-visible{outline:2px solid var(--web-ui-ring);outline-offset:2px}@media(max-width:640px){.icon-btn.svelte-8nabiy{width:44px;height:44px}}.btn.svelte-10u0xy3{display:inline-flex;align-items:center;justify-content:center;gap:8px;height:44px;padding:0 20px;border:none;border-radius:var(--web-ui-radius-sm);font-family:var(--web-ui-font);font-size:15px;font-weight:500;letter-spacing:-.005em;cursor:pointer;text-decoration:none;transition:background .15s var(--web-ui-ease),transform .1s ease;min-width:0;box-sizing:border-box}.btn.block.svelte-10u0xy3{width:100%}.btn.multiline.svelte-10u0xy3{height:auto;min-height:44px;padding:16px 20px;line-height:1.45;white-space:pre-line}.btn.svelte-10u0xy3:focus-visible{outline:2px solid var(--web-ui-ring);outline-offset:2px}.btn.svelte-10u0xy3:active:not(:disabled){transform:scale(.98)}.btn.svelte-10u0xy3:disabled{opacity:.5;cursor:not-allowed}.primary.svelte-10u0xy3{background:var(--web-ui-accent);color:var(--web-ui-accent-text)}.primary.svelte-10u0xy3:hover:not(:disabled){background:var(--web-ui-accent-hover)}.secondary.svelte-10u0xy3{background:transparent;color:var(--web-ui-text);border:1px solid var(--web-ui-border)}.secondary.svelte-10u0xy3:hover:not(:disabled){background:var(--web-ui-surface)}.error-content.svelte-y9soiq{display:flex;flex-direction:column;align-items:center;gap:16px;padding:8px 0 24px}.error-icon.svelte-y9soiq{display:flex}.error-message.svelte-y9soiq{margin:0;font-size:15px;font-weight:500;color:var(--web-ui-text);text-align:center;font-family:var(--web-ui-font);line-height:1.4}.details-toggle.svelte-y9soiq{display:inline-flex;align-items:center;align-self:center;min-height:44px;padding:4px 8px;background:none;border:none;font-family:var(--web-ui-font);font-size:13px;font-weight:500;color:var(--web-ui-text-secondary);cursor:pointer;text-decoration:underline;text-underline-offset:2px}.details-toggle.svelte-y9soiq:hover{color:var(--web-ui-text)}.details-toggle.svelte-y9soiq:focus-visible{outline:2px solid var(--web-ui-ring);outline-offset:2px;border-radius:var(--web-ui-radius-xs)}.error-details.svelte-y9soiq{margin:0;font-size:13px;color:var(--web-ui-text-secondary);text-align:center;font-family:var(--web-ui-font);word-break:break-word;line-height:1.5;background:var(--web-ui-surface);padding:10px 14px;border-radius:var(--web-ui-radius-xs);width:100%}.actions.svelte-y9soiq{display:flex;gap:8px;justify-content:flex-end}.select-card.svelte-f3myrl{display:flex;align-items:center;gap:14px;width:100%;padding:14px 16px;border:1px solid var(--web-ui-border);border-radius:var(--web-ui-radius-sm);background:transparent;color:var(--web-ui-text);font-family:var(--web-ui-font);font-size:15px;font-weight:500;letter-spacing:-.005em;cursor:pointer;transition:background .15s var(--web-ui-ease),border-color .15s var(--web-ui-ease);text-align:left;box-sizing:border-box}.select-card.svelte-f3myrl:hover{background:var(--web-ui-surface);border-color:var(--web-ui-text-secondary)}.select-card.svelte-f3myrl:focus-visible{outline:2px solid var(--web-ui-ring);outline-offset:2px}.select-card.svelte-f3myrl:active{transform:scale(.995)}.select-logo.svelte-f3myrl{width:32px;height:32px;border-radius:var(--web-ui-radius-xs);object-fit:contain;flex-shrink:0}.select-logo-placeholder.svelte-f3myrl{width:32px;height:32px;border-radius:var(--web-ui-radius-xs);background:var(--web-ui-surface);border:1px solid var(--web-ui-border);display:flex;align-items:center;justify-content:center;font-weight:500;font-size:14px;color:var(--web-ui-text-secondary);flex-shrink:0}.select-text.svelte-f3myrl{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px}.select-label.svelte-f3myrl{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.select-caption.svelte-f3myrl{font-size:12px;font-weight:400;color:var(--web-ui-text-secondary)}.spinner.svelte-1qm4te0{display:inline-flex;animation:svelte-1qm4te0-spin 1s linear infinite}.spinner.svelte-1qm4te0 svg:where(.svelte-1qm4te0){width:100%;height:100%}@keyframes svelte-1qm4te0-spin{to{transform:rotate(360deg)}}@media(prefers-reduced-motion:reduce){.spinner.svelte-1qm4te0{animation-duration:2s}}.field.svelte-1ldu9ck{display:flex;flex-direction:column;gap:6px}.field-label.svelte-1ldu9ck{font-family:var(--web-ui-font);font-size:12px;font-weight:500;color:var(--web-ui-text-secondary)}.field-control.svelte-1ldu9ck{display:flex;align-items:center;gap:2px;height:44px;padding:0 14px;border:1px solid var(--web-ui-border);border-radius:var(--web-ui-radius-sm);background:var(--web-ui-bg);transition:border-color .15s var(--web-ui-ease);box-sizing:border-box}.field-control.svelte-1ldu9ck:hover{border-color:var(--web-ui-text-secondary)}.field-control.svelte-1ldu9ck:focus-within{border-color:var(--web-ui-accent);outline:2px solid var(--web-ui-ring);outline-offset:1px}.field-control.invalid.svelte-1ldu9ck{border-color:var(--web-ui-error)}.field-prefix.svelte-1ldu9ck{font-family:var(--web-ui-font-mono);font-size:15px;color:var(--web-ui-text-secondary)}input.svelte-1ldu9ck{flex:1;min-width:0;border:none;outline:none;background:transparent;color:var(--web-ui-text);font-family:var(--web-ui-font-mono);font-size:15px;letter-spacing:-.005em;padding:0}input.svelte-1ldu9ck::placeholder{color:var(--web-ui-text-secondary);opacity:.7}.entry.svelte-1t9vubs{display:flex;flex-direction:column;gap:14px}.entry-error.svelte-1t9vubs{margin:-4px 0 0;font-family:var(--web-ui-font);font-size:12px;line-height:1.5;color:var(--web-ui-error)}.chain-list.svelte-1oqx6nm,.choice-list.svelte-1gs5td9{display:flex;flex-direction:column;gap:8px}.choice-manual.svelte-1gs5td9{display:flex;flex-direction:column;gap:14px}.choice-loading.svelte-1gs5td9{display:flex;flex-direction:column;align-items:center;gap:16px;padding:40px 0}.choice-loading.svelte-1gs5td9 p:where(.svelte-1gs5td9){margin:0;font-size:14px;color:var(--web-ui-text-secondary);font-family:var(--web-ui-font)}.choice-note.svelte-1gs5td9{margin:0;font-family:var(--web-ui-font);font-size:13px;line-height:1.5;color:var(--web-ui-text-secondary)}.choice-error.svelte-1gs5td9{margin:-4px 0 0;font-family:var(--web-ui-font);font-size:12px;line-height:1.5;color:var(--web-ui-error)}.permission-list.svelte-x1too2{display:flex;flex-direction:column;gap:8px}.permission-loading.svelte-x1too2{display:flex;flex-direction:column;align-items:center;gap:16px;padding:40px 0}.permission-loading.svelte-x1too2 p:where(.svelte-x1too2){margin:0;font-size:14px;color:var(--web-ui-text-secondary);font-family:var(--web-ui-font)}.permission-note.svelte-x1too2{margin:0;font-size:14px;line-height:1.5;color:var(--web-ui-text-secondary);font-family:var(--web-ui-font)}.permission-key.svelte-x1too2{margin:10px 0 0;padding:10px 12px;background:var(--web-ui-surface);border-radius:var(--web-ui-radius-xs);font-family:var(--web-ui-font-mono);font-size:12px;line-height:1.5;color:var(--web-ui-text-secondary);overflow-wrap:anywhere}.wallet-list.svelte-1swrueq{display:flex;flex-direction:column;gap:8px}.loading.svelte-1swrueq{display:flex;flex-direction:column;align-items:center;gap:16px;padding:40px 0}.loading.svelte-1swrueq p:where(.svelte-1swrueq){margin:0;font-size:14px;color:var(--web-ui-text-secondary);font-family:var(--web-ui-font)}.origin.svelte-1swrueq{margin:14px 0 0;text-align:center;font-size:12px;color:var(--web-ui-text-secondary);font-family:var(--web-ui-font)}.transact-content.svelte-px1e45{display:flex;flex-direction:column;align-items:center;gap:16px;padding:16px 0 8px}.stage-label.svelte-px1e45{margin:0;font-size:16px;font-weight:500;color:var(--web-ui-text);font-family:var(--web-ui-font)}.confirm-sub.svelte-px1e45{margin:0;font-size:13px;color:var(--web-ui-text-secondary);font-family:var(--web-ui-font)}.done-actions.svelte-px1e45{padding-top:20px}.session-info.svelte-px1e45{display:flex;flex-direction:column;gap:10px;width:100%;padding:14px 16px;background:var(--web-ui-surface);border-radius:var(--web-ui-radius-sm)}.info-row.svelte-px1e45{display:flex;align-items:center;justify-content:space-between;gap:8px}.info-label.svelte-px1e45{font-size:13px;color:var(--web-ui-text-secondary);font-family:var(--web-ui-font)}.info-value-row.svelte-px1e45{display:flex;align-items:center;gap:6px}.info-value.svelte-px1e45{font-size:13px;font-weight:500;color:var(--web-ui-text);font-family:var(--web-ui-font)}.info-value.mono.svelte-px1e45{font-family:var(--web-ui-font-mono);letter-spacing:-.02em}.chain-logo.svelte-px1e45{width:16px;height:16px;border-radius:50%}.success-icon.svelte-px1e45 .checkmark:where(.svelte-px1e45){stroke-dasharray:30;stroke-dashoffset:30;animation:svelte-px1e45-draw .4s ease-out .1s forwards}@keyframes svelte-px1e45-draw{to{stroke-dashoffset:0}}@media(prefers-reduced-motion:reduce){.success-icon.svelte-px1e45 .checkmark:where(.svelte-px1e45){animation:none;stroke-dashoffset:0}}.asset.svelte-1smsag4{text-align:center;padding:8px 0}.value.svelte-1smsag4{margin:0;font-size:20px;font-weight:600;line-height:1.4;color:var(--web-ui-text);font-family:var(--web-ui-font)}.label.svelte-1smsag4{margin:2px 0 0;font-size:13px;font-weight:400;color:var(--web-ui-text-secondary);font-family:var(--web-ui-font)}.accept.svelte-2cq8ks{display:flex;gap:8px;justify-content:flex-end}.countdown.svelte-1dtoznn{display:flex;flex-direction:column;align-items:center;gap:8px;padding:4px 0}.timer-ring.svelte-1dtoznn{position:relative;display:flex;align-items:center;justify-content:center}.progress.svelte-1dtoznn{transform:rotate(-90deg);transform-origin:center;transition:stroke-dashoffset .2s linear}.time.svelte-1dtoznn{position:absolute;font-size:13px;font-weight:600;font-variant-numeric:tabular-nums;color:var(--web-ui-text);font-family:var(--web-ui-font)}.label.svelte-1dtoznn{margin:0;font-size:13px;font-weight:500;color:var(--web-ui-text-secondary);font-family:var(--web-ui-font)}@media(prefers-reduced-motion:reduce){.progress.svelte-1dtoznn{transition:none}}.text-link.svelte-1b9bzfw{display:inline-flex;align-items:center;align-self:center;min-height:44px;font-family:var(--web-ui-font);font-size:14px;font-weight:500;color:var(--web-ui-accent);text-decoration:underline;text-underline-offset:2px;padding:4px 12px;border-radius:var(--web-ui-radius-xs)}.text-link.svelte-1b9bzfw:focus-visible{outline:2px solid var(--web-ui-ring);outline-offset:2px}.prompt-button.svelte-f40858{display:flex;width:100%}.qr.svelte-14k3qh1{display:flex;justify-content:center;padding:4px 0}.qr-container.svelte-14k3qh1{background:#fff;border-radius:8px;padding:12px;display:flex;width:100%;max-width:240px}.qr-container.svelte-14k3qh1 svg{width:100%;height:auto}.qr-fallback.svelte-14k3qh1{margin:0;text-align:center;font-size:13px;color:var(--web-ui-text-secondary);font-family:var(--web-ui-font);padding:8px 0}.prompt-textarea.svelte-19pbf8u{width:100%;box-sizing:border-box;margin:0;padding:12px 14px;resize:none;overflow-y:auto;border:1px solid var(--web-ui-border);border-radius:var(--web-ui-radius-sm);background:var(--web-ui-surface);color:var(--web-ui-text);font-family:var(--web-ui-font-mono);font-size:12px;line-height:1.6;white-space:pre-wrap;overflow-wrap:anywhere;user-select:text;-webkit-user-select:text}.prompt-textarea.svelte-19pbf8u:focus-visible{outline:2px solid var(--web-ui-ring);outline-offset:2px}.elements.svelte-1hxwvxp{display:flex;flex-direction:column;gap:16px}.waiting.svelte-1hxwvxp{display:flex;flex-direction:column;align-items:center;gap:12px;padding:16px 0 8px}.waiting-label.svelte-1hxwvxp{margin:0;font-size:13px;font-weight:500;color:var(--web-ui-text-secondary);font-family:var(--web-ui-font)}.actions.svelte-1hxwvxp{display:flex;gap:8px;justify-content:flex-end;padding-top:12px}.sk-body.svelte-qgdoxk{display:flex;flex-direction:column;gap:12px}.sk-description.svelte-qgdoxk{margin:0;font-size:15px;line-height:1.5;color:var(--web-ui-text-secondary);font-family:var(--web-ui-font)}.sk-summary-badge.svelte-qgdoxk{display:flex;align-items:center;justify-content:space-between;gap:8px;padding:12px 14px;background:var(--web-ui-surface);border:1px solid var(--web-ui-border);border-radius:var(--web-ui-radius-sm);cursor:pointer;font-family:var(--web-ui-font);font-size:13px;color:var(--web-ui-text-secondary);width:100%;box-sizing:border-box}.sk-summary-badge.svelte-qgdoxk:hover{border-color:var(--web-ui-accent)}.sk-summary-badge.svelte-qgdoxk:focus-visible{outline:2px solid var(--web-ui-ring);outline-offset:2px}.sk-summary-left.svelte-qgdoxk{display:flex;align-items:center;gap:8px}.sk-toggle.svelte-qgdoxk{color:var(--web-ui-accent);font-weight:500;font-size:13px;white-space:nowrap}.sk-details.svelte-qgdoxk{display:flex;flex-direction:column;gap:8px}.sk-section-label.svelte-qgdoxk{font-size:13px;color:var(--web-ui-text-secondary);font-family:var(--web-ui-font);line-height:1.5}.sk-contract-group.svelte-qgdoxk{display:flex;flex-direction:column;gap:4px}.sk-contract-header.svelte-qgdoxk{font-size:12px;font-weight:600;color:var(--web-ui-text-secondary);font-family:var(--web-ui-font-mono);letter-spacing:-.02em;text-transform:none}.sk-permissions-list.svelte-qgdoxk{display:flex;flex-direction:column;gap:4px;list-style:none;margin:0;padding:0}.sk-permission-item.svelte-qgdoxk{display:flex;align-items:center;gap:10px;padding:10px 12px;font-size:13px;font-family:var(--web-ui-font);color:var(--web-ui-text);border-radius:var(--web-ui-radius-xs)}.sk-permission-item.neutral.svelte-qgdoxk{background:var(--web-ui-surface)}.sk-permission-item.warning.svelte-qgdoxk{background:color-mix(in oklch,var(--web-ui-warning) 12%,transparent);color:var(--web-ui-text)}.sk-warn-icon.svelte-qgdoxk{color:var(--web-ui-warning);flex-shrink:0}.sk-bullet.svelte-qgdoxk{color:var(--web-ui-text-secondary);font-weight:500}.action-note.svelte-qgdoxk{color:var(--web-ui-text-secondary);font-size:.92em}.contract-hint.svelte-qgdoxk{color:var(--web-ui-text-secondary);font-size:.9em}.sk-boundary.svelte-qgdoxk{font-size:12px;color:var(--web-ui-text-secondary);font-family:var(--web-ui-font);font-style:italic;padding:8px 0 0}.sk-about-toggle.svelte-qgdoxk{display:inline-flex;align-items:center;align-self:flex-start;min-height:44px;padding:4px 0;background:none;border:none;font-family:var(--web-ui-font);font-size:13px;font-weight:500;color:var(--web-ui-accent);cursor:pointer;text-align:left}.sk-about-toggle.svelte-qgdoxk:focus-visible{outline:2px solid var(--web-ui-ring);outline-offset:2px;border-radius:var(--web-ui-radius-xs)}.sk-about.svelte-qgdoxk{margin:0;font-size:13px;line-height:1.5;color:var(--web-ui-text-secondary);font-family:var(--web-ui-font);padding:10px 12px;background:var(--web-ui-surface);border-radius:var(--web-ui-radius-xs)}.sk-info-note.svelte-qgdoxk{font-size:12px;color:var(--web-ui-text-secondary);font-family:var(--web-ui-font);line-height:1.5;padding:8px 12px;background:var(--web-ui-surface);border-radius:var(--web-ui-radius-xs)}.actions.svelte-qgdoxk{display:flex;gap:8px;justify-content:flex-end;padding-top:8px}.sk-body.svelte-1kb26es{display:flex;flex-direction:column;gap:12px}.sk-app-name.svelte-1kb26es{font-size:16px;font-weight:600;color:var(--web-ui-text);font-family:var(--web-ui-font)}.sk-description.svelte-1kb26es{margin:0;font-size:15px;line-height:1.5;color:var(--web-ui-text-secondary);font-family:var(--web-ui-font)}.options.svelte-1kb26es{display:flex;flex-direction:column;gap:8px}label.svelte-1kb26es{display:flex;align-items:flex-start;gap:12px;padding:14px;background:transparent;border:1px solid var(--web-ui-border);border-radius:var(--web-ui-radius-sm);cursor:pointer;transition:border-color .15s var(--web-ui-ease),background .15s var(--web-ui-ease)}label.selected.svelte-1kb26es{border-color:var(--web-ui-accent);background:color-mix(in oklch,var(--web-ui-accent) 6%,transparent)}label.svelte-1kb26es:not(.selected):hover{border-color:var(--web-ui-text-secondary);background:var(--web-ui-surface)}input[type=radio].svelte-1kb26es{margin-top:2px;accent-color:var(--web-ui-accent)}.option-content.svelte-1kb26es{display:flex;flex-direction:column;gap:2px}.option-title.svelte-1kb26es{font-weight:500;font-size:14px;color:var(--web-ui-text);font-family:var(--web-ui-font)}.option-subtitle.svelte-1kb26es{font-size:12px;color:var(--web-ui-text-secondary);font-family:var(--web-ui-font)}.sk-info-note.svelte-1kb26es{font-size:12px;color:var(--web-ui-text-secondary);font-family:var(--web-ui-font);line-height:1.5;padding:8px 12px;background:var(--web-ui-surface);border-radius:var(--web-ui-radius-xs)}.actions.svelte-1kb26es{display:flex;gap:8px;justify-content:flex-end;padding-top:8px}.sk-body.svelte-5mdirq{display:flex;flex-direction:column;gap:12px}.sk-app-name.svelte-5mdirq{font-size:16px;font-weight:600;color:var(--web-ui-text);font-family:var(--web-ui-font)}.sk-description.svelte-5mdirq{margin:0;font-size:15px;line-height:1.5;color:var(--web-ui-text-secondary);font-family:var(--web-ui-font)}.sk-section.svelte-5mdirq{display:flex;flex-direction:column;gap:6px}.sk-section-label.svelte-5mdirq{font-size:13px;font-weight:500;color:var(--web-ui-text-secondary);font-family:var(--web-ui-font)}.sk-permissions-list.svelte-5mdirq{display:flex;flex-direction:column;gap:4px;list-style:none;margin:0;padding:0}.sk-permission-item.svelte-5mdirq{display:flex;align-items:center;gap:10px;padding:10px 12px;font-size:13px;font-family:var(--web-ui-font);color:var(--web-ui-text);border-radius:var(--web-ui-radius-xs)}.sk-permission-item.added.svelte-5mdirq{background:color-mix(in oklch,var(--web-ui-success) 10%,transparent)}.sk-permission-item.removed.svelte-5mdirq{background:var(--web-ui-surface)}.sk-indicator.svelte-5mdirq{font-weight:700;font-size:14px;width:16px;text-align:center;flex-shrink:0}.sk-indicator.added.svelte-5mdirq{color:var(--web-ui-success)}.sk-indicator.removed.svelte-5mdirq{color:var(--web-ui-text-secondary)}.actions.svelte-5mdirq{display:flex;gap:8px;justify-content:flex-end;padding-top:8px}.sk-body.svelte-17kifxa{display:flex;flex-direction:column;gap:12px}.sk-app-name.svelte-17kifxa{font-size:16px;font-weight:600;color:var(--web-ui-text);font-family:var(--web-ui-font)}.sk-description.svelte-17kifxa{margin:0;font-size:15px;line-height:1.5;color:var(--web-ui-text-secondary);font-family:var(--web-ui-font)}.sk-info-note.svelte-17kifxa{display:flex;align-items:flex-start;gap:10px;font-size:13px;color:var(--web-ui-text-secondary);font-family:var(--web-ui-font);line-height:1.5;padding:12px 14px;background:var(--web-ui-surface);border-radius:var(--web-ui-radius-sm)}.sk-info-note.svelte-17kifxa svg:where(.svelte-17kifxa){flex-shrink:0;margin-top:1px}.actions.svelte-17kifxa{display:flex;gap:8px;justify-content:flex-end;padding-top:8px}\n", Oo = ["en", "ko", "zh-Hans", "zh-Hant", "tr"], qt = "en", Bo = {
  "zh-cn": "zh-Hans",
  "zh-sg": "zh-Hans",
  "zh-hans": "zh-Hans",
  "zh-tw": "zh-Hant",
  "zh-hk": "zh-Hant",
  "zh-hant": "zh-Hant"
};
function Pn(t) {
  if (!t) return;
  const e = t.trim().toLowerCase();
  if (!e) return;
  if (e === "zh" || e.startsWith("zh-")) {
    const [, r] = e.split("-");
    return Bo[`zh-${r}`] ?? "zh-Hans";
  }
  const n = e.split("-")[0];
  return Oo.find((r) => r.toLowerCase() === n);
}
function Ro() {
  if (typeof navigator > "u") return qt;
  const t = navigator.languages?.length ? navigator.languages : [navigator.language];
  for (const e of t) {
    const n = Pn(e);
    if (n) return n;
  }
  return qt;
}
const Do = /\{\{\s*([\w.]+)\s*\}\}/g;
function Ft(t) {
  return typeof t == "object" && t !== null && !Array.isArray(t);
}
function or(t, e) {
  for (const [n, r] of Object.entries(e)) {
    const i = t[n];
    Ft(r) && Ft(i) ? or(i, r) : Ft(r) ? t[n] = or({}, r) : t[n] = r;
  }
  return t;
}
function Ho(t, e) {
  return e ? t.replace(Do, (n, r) => {
    if (r === "default") return n;
    const i = e[r];
    return i == null ? n : String(i);
  }) : t;
}
class Io {
  constructor() {
    this.locales = {};
  }
  merge(e) {
    if (Ft(e))
      for (const [n, r] of Object.entries(e)) {
        const i = Pn(n);
        if (!i || !Ft(r)) continue;
        const a = this.locales[i] ?? {};
        this.locales[i] = or(a, r);
      }
  }
  translate(e, n, r, i) {
    const a = i ? `${i}.${n}` : n, l = this.lookup(e, a) ?? this.lookup(qt, a);
    return Ho(l ?? r?.default ?? a, r);
  }
  lookup(e, n) {
    let r = this.locales[e];
    for (const i of n.split(".")) {
      if (!Ft(r)) return;
      r = r[i];
    }
    return typeof r == "string" ? r : void 0;
  }
}
const _r = class _r {
  constructor(e = {}) {
    if (this.initialized = !1, this.pending = null, this.hideTimer = null, this.domReadyHandler = null, this.catalog = new Io(), this.locale = qt, this.options = { ...Mo, ...e }, e.theme && (on.theme = e.theme), e.appearance && (on.appearance = e.appearance), e.appName && (x.appName = e.appName), x.minimal = this.options.minimal, e.locale === void 0)
      this.locale = Ro();
    else {
      const n = Pn(e.locale);
      this.locale = n ?? qt, n || this.log(`Unsupported locale "${e.locale}", falling back to ${this.locale}`);
    }
    this.applyLocale(), typeof document < "u" && this.initialize();
  }
  initialize() {
    if (this.initialized) return;
    this.element = document.createElement("div"), this.element.id = "web-ui", this.element.style.cssText = `position:fixed;inset:0;z-index:${this.options.zIndex};pointer-events:none;display:none;`, this.shadow = this.element.attachShadow({ mode: "open" });
    const e = new CSSStyleSheet();
    e.replaceSync(`${Lo}
${No}`), this.shadow.adoptedStyleSheets = [e];
    const n = document.createElement("div");
    this.shadow.appendChild(n), on.applyToHost(this.shadow.host), this.app = es(go, {
      target: n,
      props: {
        closeOnOverlayClick: this.options.closeOnOverlayClick,
        closeOnEscape: this.options.closeOnEscape,
        oncancel: () => this.handleCancel(),
        onlogincomplete: (r) => this.resolvePending(r),
        onpromptconfirm: () => this.resolvePending({}, !0),
        onskconsentapprove: () => this.resolvePending(!0, !0),
        onskconflictselect: (r) => this.resolvePending(r, !0),
        onskmismatchselect: (r) => this.resolvePending(r, !0),
        onskremoveconfirm: () => this.resolvePending(!0, !0),
        ontransactdone: () => this.handleTransactDone()
      }
    }), document.readyState === "complete" || document.readyState === "interactive" ? this.appendElement() : (this.domReadyHandler = () => this.appendElement(), document.addEventListener("DOMContentLoaded", this.domReadyHandler)), this.initialized = !0;
  }
  appendElement() {
    if (!this.element) return;
    const e = document.getElementById("web-ui");
    e && e.remove(), document.body.appendChild(this.element);
  }
  clearTimers() {
    this.hideTimer !== null && (clearTimeout(this.hideTimer), this.hideTimer = null);
  }
  handleTransactDone() {
    this.clearTimers(), this.hide(), x.reset();
  }
  show() {
    this.clearTimers(), this.element && (this.element.style.display = "block", this.element.style.pointerEvents = "auto"), x.active = !0;
  }
  hide() {
    x.active = !1, this.hideTimer = setTimeout(() => {
      this.hideTimer = null, this.element && (this.element.style.display = "none", this.element.style.pointerEvents = "none");
    }, 200);
  }
  log(...e) {
    this.options.logging && console.log("[WebUI]", ...e);
  }
  setPending(e) {
    return new Promise((n, r) => {
      this.pending = {
        resolve: n,
        reject: r,
        cancelValue: e
      };
    });
  }
  resolvePending(e, n = !1) {
    const r = this.pending;
    r && (this.pending = null, r.resolve(e), n && this.hide());
  }
  handleCancel() {
    this.log("User cancelled"), this.hide();
    const e = this.pending;
    e && (this.pending = null, e.cancelValue !== void 0 ? e.resolve(e.cancelValue) : e.reject(new Error("User cancelled")));
  }
  async login(e) {
    this.log("login", e), x.loginContext = e, e.appName && (x.appName = e.appName), x.view = "login", this.show();
    const n = await this.setPending();
    return x.minimal && this.hide(), n;
  }
  async onError(e) {
    if (this.log("onError", e), x.minimal) {
      this.hide(), x.reset();
      return;
    }
    const { message: n, details: r } = zo(e);
    x.view = "error", x.errorMessage = n, x.errorDetails = r, this.show();
  }
  async onAccountCreate(e) {
    return this.log("onAccountCreate"), {};
  }
  async onAccountCreateComplete() {
    this.log("onAccountCreateComplete");
  }
  async onLogin() {
    this.log("onLogin");
  }
  async onLoginComplete() {
    this.log("onLoginComplete"), this.hide(), x.reset();
  }
  async onTransact() {
    this.log("onTransact"), x.minimal || (x.view = "transact", x.transactStage = "preparing", x.transactStartTime = Date.now(), this.show());
  }
  async onTransactComplete() {
    this.log("onTransactComplete"), this.hide(), x.reset();
  }
  async onSign() {
    this.log("onSign"), x.transactStage = "signing";
  }
  async onSignComplete() {
    this.log("onSignComplete"), x.transactStage = "signed", x.minimal || (x.view = "transact", this.show());
  }
  async onBroadcast() {
    this.log("onBroadcast"), x.transactStage = "broadcasting";
  }
  async onBroadcastComplete() {
    this.log("onBroadcastComplete"), x.transactStage = "confirming";
  }
  prompt(e) {
    return this.log("prompt", e), (!x.minimal || !e.optional) && (x.view = "prompt", x.promptTitle = e.title || "Confirm", x.promptBody = e.body || "", x.promptElements = e.elements || [], this.show()), Oi(this.setPending(), () => {
      this.handleCancel();
    });
  }
  async onSessionKeyConsent(e) {
    return this.log("onSessionKeyConsent", e), x.view = "sk-consent", x.skAppName = e.appName, x.skWhitelist = e.whitelist, this.show(), this.setPending(!1);
  }
  async onSessionKeyConflict(e) {
    return this.log("onSessionKeyConflict", e), x.view = "sk-conflict", x.skAppName = e.appName, x.skExistingKeyCount = e.existingKeyCount, this.show(), this.setPending("cancel");
  }
  async onSessionKeyMismatch(e) {
    return this.log("onSessionKeyMismatch", e), x.view = "sk-mismatch", x.skAppName = e.appName, x.skAdded = e.added, x.skRemoved = e.removed, this.show(), this.setPending("dismiss");
  }
  async onSessionKeyRemove(e) {
    return this.log("onSessionKeyRemove", e), x.view = "sk-remove", x.skAppName = e.appName, this.show(), this.setPending(!1);
  }
  status(e) {
    this.log("status", e);
  }
  translate(e, n, r) {
    return this.catalog.translate(this.locale, e, n, r);
  }
  getTranslate(e) {
    return (n, r) => this.translate(n, r, e);
  }
  addTranslations(e) {
    this.catalog.merge(e);
  }
  setLocale(e) {
    this.locale = Pn(e) ?? qt, this.applyLocale(), this.log("setLocale", this.locale);
  }
  // Every wuchale adapter holds its own locale state; all of them must be driven.
  applyLocale() {
    Ss(this.locale), Co(this.locale);
  }
  getLocale() {
    return this.locale;
  }
  getMinimal() {
    return x.minimal;
  }
  setMinimal(e) {
    x.minimal = e;
  }
  setSession(e, n, r) {
    x.accountName = e, x.chainName = n, x.chainLogo = r ?? "";
  }
  destroy() {
    this.clearTimers(), this.domReadyHandler && (document.removeEventListener("DOMContentLoaded", this.domReadyHandler), this.domReadyHandler = null), this.pending && (this.pending.reject(new Error("WebUI destroyed")), this.pending = null), this.app && (ns(this.app), this.app = void 0), this.element && (this.element.remove(), this.element = void 0), this.shadow = void 0, this.initialized = !1;
  }
};
_r.version = "__ver";
let Br = _r;
export {
  Br as WebUI,
  Br as default,
  Oo as supportedLocales
};
